<template>
  <div v-if="previwEmit">
    <b-card>
      <div slot="header">
        <b-row>
          <b-col cols="12" sm="2" md="2" lg="2" xl="2">
            <div>
              <template v-if="typeInvoice == '1'">
                <h3 class="display"><b>Factura Electrónica</b></h3>
              </template>
              <template v-else-if="typeInvoice == '2'">
                <h3 class="display"><b>Factura de Contingencia</b></h3>
              </template>            
            </div>
          </b-col>
          <b-col cols="12" sm="2" md="2" lg="2" xl="2">
            <select class="form-control input-placedark input-dark colorBorde" v-model="tipoOperacion">
              <option
                v-for="tipo in listadeoperaciones"
                :value="tipo.tipo"
                :key="tipo.tipo">
                {{ tipo.name }}
              </option>
              </select>
          </b-col>
          <b-col cols="12" sm="2" md="2" lg="2" xl="2">
            <datepicker
              style="border-radius:4px;border:1px solid #012171"
              v-model="femision"
              :format="customFormatter"
              :language="es"
              :bootstrap-styling="true"
              :disabledDates="diasnopermitidos"
              :placeholder="currentdate">
            </datepicker>
          </b-col>
          <b-col cols="12" sm="2" md="2" lg="2" xl="2">
            <b-form-select
              class="input-placedark input-dark colorBorde"
              v-model="typeInvoice"
              :options="options">
            </b-form-select>
          </b-col>
          <b-col cols="12" sm="2" md="2" lg="2" xl="2">
            <b-input-group>
              <b-form-checkbox
                v-model="switchAnticipo"
                :disabled="disabledAnticipo"
                class="mx-1 cargaritemsPersonalizado">
                Anticipo
              </b-form-checkbox>
              <b-button
                class="ml-2"
                :disabled="buttonRegularizacionAnticipos"
                id="tooltipButton-20"
                size="sm"
                variant="success"
                @click="addAnticipos">
                Regularización Anticipo
              </b-button>
            </b-input-group>
          </b-col>
          <b-col cols="12" sm="2" md="2" lg="2" xl="2">
            <select class="custom-select mr-sm-2 input-placedark input-dark colorBorde" v-model="moneda">
              <option
                :value="moneda"
                v-for="moneda in tipoMoneda"
                v-bind:key="moneda.id">
                {{ moneda.descripcion }}
              </option>
            </select>
          </b-col>
        </b-row>
        <!-- Regularizacion de anticipos -->
        <b-row align-v="center">
          <b-modal title="Agregar facturas anticipo" size="lg" centered v-model="modalAnticipos">
            <div v-if="!cargandoAnticipos">
              <div class="row">
                <div class="col-md-12 text-center">
                  <h3>
                    Cargando Facturas con Anticipos
                    <i class="fa fa-spin fa-spinner"></i>
                  </h3>
                </div>
              </div>
            </div>
            <div v-else>
              <b-row>
                <b-col cols="12">
                  <b-table
                          responsive
                          :small="small"
                          :striped="striped"
                          :outlined="outlined"
                          :items="docAnticipos"
                          :fields="docAnticipos_fields"
                          :current-page="pactual"
                          :per-page="limite"
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                          :sort-direction="sortDirection"
                  >
                    <template
                            striped
                            hover
                            slot="idReceptor razonSocial"
                            slot-scope="row"
                    >{{ row.item.idReceptor }}</template>
                    <template striped hover slot="tipoAfectacion" slot-scope="row">
                      <div v-if="row.item.tipoAfectacion == '10'">Gravado</div>
                      <div v-else-if="row.item.tipoAfectacion == '20'">Exonerado</div>
                      <div v-else-if="row.item.tipoAfectacion == '30'">Inafecto</div>
                      <div v-else>Sin asignar</div>
                    </template>
                    <template striped hover slot="montoRegularizado">
                      <b-form-input
                              class="input-placedark input-dark"
                              placeholder="Monto por regularizar"
                              disabled
                      ></b-form-input>
                    </template>
                    <template striped hover slot="monto" slot-scope="row">
                      <b-input
                              size="sm"
                              class="descuento text-center"
                              v-model="row.item.montoAnticipo"
                      ></b-input>
                    </template>
                    <template striped hover slot="agregar" slot-scope="row">
                      <b-btn
                              class="btn btn-sm btn-group btn-outline-info"
                              @click="addAnt(row.item, row.index)"
                      >
                        <i class="fa fa-plus"></i>
                      </b-btn>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
              <b-row>
                <div class="col-md-6">
                  <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                </div>
                <div class="col-md-6">
                  <div class="float-right">
                    <b-pagination
                            size="sm"
                            :total-rows="total"
                            v-model="currentPage"
                            @input="loadListAnticipos"
                            :per-page="limite"
                    ></b-pagination>
                  </div>
                </div>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="4"></b-col>
                <b-col cols="5">
                  <strong>
                    <u>Resumen de Regularizacion de Anticipo</u>
                  </strong>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <ul>
                    <li
                            class="lianticipo"
                            v-for="(item, index) in selectedAnticipos"
                            v-bind:key="item.index"
                    >
                      <b-row>
                        <b-col cols="5"></b-col>
                        <b-col cols="2">{{ item.serieNumero }}</b-col>
                        <b-col cols="3" v-if="item.tipoAfectacion == 10">{{ item.montoAnticipado }}</b-col>
                        <b-col
                                cols="3"
                                v-else-if="item.tipoAfectacion == 30"
                        >{{ item.montoAnticipadoExonerado }}</b-col>
                        <b-col
                                cols="3"
                                v-else-if="item.tipoAfectacion == 20"
                        >{{ item.montoAnticipadoInafecto }}</b-col>
                        <b-col cols="3" v-else-if="item.tipoAfectacion == 40"
                        >{{ item.montoAnticipado }}</b-col>
                        <b-col cols="2">
                          <b-button size="sm" variant="danger" @click="remAnt(item, index)">
                            <i class="fa fa-times"></i>
                          </b-button>
                        </b-col>
                      </b-row>
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </div>
            <b-row v-if="cargandoAnticipos">
              <b-col cols="7"></b-col>
              <b-col cols="2" class="bordesAnticipos">Total anticipo:</b-col>
              <b-col cols="2" class="bordesAnticipos">{{ accumulateAnticipos() }}</b-col>
              <b-col cols="1"></b-col>
            </b-row>
            <div slot="modal-footer" class="w-100">
              <b-row>
                <b-col cols="12" sm="6" md="4" lg="4" xl="9"></b-col>
                <b-col cols="12" sm="6" md="4" lg="4" xl="2">
                  <template v-if="!validateRegularizacion()">
                    <b-button
                            v-if="!updateClienteDatos"
                            type="button"
                            variant="primary"
                            @click="sendFacturaAnticipos"
                    >
                      <i class="fa fa-plus"></i> Regularizar
                    </b-button>
                    <b-button v-else type="button" variant="secondary">
                      <i class="fa fa-spin fa-spinner"></i> Regularizando...
                    </b-button>
                  </template>
                  <template v-else>
                    <b-button type="button" variant="secondary" disabled>
                      <i class="fa fa-plus"></i> Regularizar
                    </b-button>
                  </template>
                </b-col>
              </b-row>
            </div>
          </b-modal>
          <!-- Fin de regularizacion de anticipos -->
        </b-row>
        <b-row v-if="tipoOperacion == '0200'" class="mt-2">     
          <b-col cols="12" sm="6" md="4" lg="4" xl="2">
            <b-row align-v="center">
              <b-col cols="4" class="text-right">
                <label>Incoterms</label>
              </b-col>
              <b-col cols="8">
                <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="incotermExporta">
                  <option
                    :value="tipo"
                    v-for="tipo in incoterms"
                    :key="tipo.tipo"
                  >{{ tipo.name }}</option>
                </select>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <template v-if="tipoOperacion == '0101EDU'">
      <b-row  class="mb-2">
        <b-col cols="12" sm="6" md="4" lg="4" xl="2">
          <b-form-input
                  class="input-placedark input-dark colorBorde"
                  placeholder="DNI del Alumno"
                  v-model="dniAlumno"
          ></b-form-input>
        </b-col>
        <b-col cols="12" sm="6" md="4" lg="4" xl="3">
          <b-form-input
                  class="input-placedark input-dark colorBorde"
                  placeholder="Nombre Completo"
                  v-model="nomApeAlumno"
          ></b-form-input>
        </b-col>
        <b-col cols="12" sm="6" md="4" lg="4" xl="3">
          <b-form-input
                  class="input-placedark input-dark colorBorde"
                  placeholder="Dirección Domicilio Alumno (Opcional)"
                  v-model="direccionDomAlumno"
          ></b-form-input>
        </b-col>
        <b-col cols="12" sm="6" md="4" lg="4" xl="2">
          <b-form-input
                  class="input-placedark input-dark colorBorde"
                  placeholder="Aula del Alumno (Opcional)"
                  v-model="aula">
          </b-form-input>
        </b-col>
        <b-col cols="12" sm="6" md="4" lg="4" xl="2">
          <b-form-input
                  class="input-placedark input-dark colorBorde"
                  placeholder="Grado Y Sección (Opcional)"
                  v-model="gradoYseccion"
          ></b-form-input>
        </b-col>
        <!-- <b-col cols="12" sm="6" md="4" lg="4" xl="3">
          <b-input-group size="md" :prepend="prependUbigeoOrigen">
            <b-form-input
                    class="input-placedark input-dark colorBorde"
                    placeholder="Ubigeo Domicilio Alumno"
                    v-model="ubigeoOrigenDom"
            ></b-form-input>
              <b-input-group-text class="colorBorde" slot="append">
                    <b-button @click="ubigeoOrigenDomicilio()" size="sm" variant="primary" class="sinresultados mr-1" title="Buscar Ubigeo">
                      <i class="fas fa-search"></i>
                    </b-button>
              </b-input-group-text>
          </b-input-group>
        </b-col> -->
      </b-row>
      <!-- <b-row class="mb-2">
        
        <b-col cols="12" sm="6" md="4" lg="4" xl="2">
          <b-input-group size="md" :prepend="prependUbigeoDestino">
            <b-form-input
                    class="input-placedark input-dark colorBorde"
                    placeholder="Ubigeo del Colegio"
                    v-model="ubigeoDestinoDom"
            ></b-form-input>
          </b-input-group>
        </b-col>
        <b-col cols="12" sm="6" md="4" lg="4" xl="4">
          <b-form-input
                  class="input-placedark input-dark colorBorde"
                  placeholder="Dirección del Colegio"
                  v-model="direccionColegio"
          ></b-form-input>
        </b-col> 
        <b-col cols="12" sm="6" md="4" lg="4" xl="2">
        <datepicker
              style="border-radius:4px;border:1px solid #012171"
              v-model="periodoAcademido"
              :format="customFormatter"
              :language="es"
              :bootstrap-styling="true"
              placeholder="Fecha Inicio Académido">
            </datepicker>
          </b-col>
      </b-row> -->
      <hr/>
      </template>
      <b-modal v-model="modalUbigeoOrigen" size="lg" centered>
        <h3>Buscar Ubigeo del Domicilio</h3>
        <b-row>
          <b-col cols="3">
            <template>
              <select class="custom-select mr-sm-2" v-model="departamentoSeleccionadoUbigeoOrigen">
                <option v-for="departamento in listDepartamento" :value="departamento.codDepartamento" :key="departamento.codDepartamento">{{ departamento.nombre }}</option>
              </select>
            </template>
                    </b-col>
                    <b-col cols="3">
                        <template>
                            <div v-if="!provOrigen">
                                <b-form-input 
                                    type="text"
                                    disabled
                                    placeholder="Selecciona una Provincia...">
                                </b-form-input>
                            </div>
                            <div v-else-if="provOrigenCargando">
                              <pulse-loader></pulse-loader>
                            </div>
                            <div v-else>
                                <select class="custom-select mr-sm-2" v-model="provinciaSeleccionadaUbigeoOrigen">
                                    <option v-for="provincia in listProvinceOrigen.Departments" :value="provincia.codProvincia" :key="provincia.codProvincia">{{ provincia.nombre }}</option>
                                </select>
                            </div>
                        </template>
                    </b-col>
                    <b-col cols="3">
                        <template>
                            <div v-if="!distOrigen">
                                <b-form-input 
                                    type="text"
                                    disabled
                                    placeholder="Selecciona un Distrito...">
                                </b-form-input>
                            </div>
                            <div v-else-if="distOrigenCargando">
                              <pulse-loader></pulse-loader>
                            </div>
                            <div v-else>
                                <select class="custom-select mr-sm-2" v-model="distritoSeleccionadoUbigeoOrigen">
                                    <option v-for="distrito in listDistrictOrigen.Departments" :value="distrito" :key="distrito.codDistrito">{{ distrito.nombre }}</option>
                                </select>
                            </div>
                        </template>
                    </b-col>
        </b-row>
      <hr/>  
      <h3>Buscar Ubigeo del Colegio</h3>
      <b-row>
        <b-col cols="3">
                    <template>
                        <select class="custom-select mr-sm-2" v-model="departamentoSeleccionadoUbigeoDestino">
                            <option v-for="departamento in listDepartamento" :value="departamento.codDepartamento" :key="departamento.codDepartamento">{{ departamento.nombre }}</option>
                        </select>
                    </template>
                </b-col>
                <b-col cols="3">
                    <template>
                        <div v-if="!provDestino">
                            <b-form-input 
                                type="text"
                                disabled
                                placeholder="Selecciona un Departamento...">
                            </b-form-input>
                        </div>
                        <div v-else-if="provDestinoCargando">
                            <pulse-loader></pulse-loader>
                        </div>
                        <div v-else>
                            <select class="custom-select mr-sm-2" v-model="provinciaSeleccionadaUbigeoDestino">
                                <option v-for="provincia in listProvinceDestino.Departments" :value="provincia.codProvincia" :key="provincia.codProvincia">{{ provincia.nombre }}</option>
                            </select>
                        </div>
                    </template>
                </b-col>
                <b-col cols="3">
                    <template>
                        <div v-if="!distDestino">
                            <b-form-input 
                                type="text"
                                disabled
                                placeholder="Selecciona un Departamento...">
                            </b-form-input>
                        </div>
                        <div v-else-if="distDestinoCargando">
                            <pulse-loader></pulse-loader>
                        </div>
                        <div v-else>
                            <select class="custom-select mr-sm-2" v-model="distritoSeleccionadoUbigeoDestino">
                                <option v-for="distrito in listDistrictDestino.Departments" :value="distrito" :key="distrito.codDistrito">{{ distrito.nombre }}</option>
                            </select>
                        </div>
                    </template>
                </b-col>
      </b-row>
      </b-modal>
      <b-row v-if="tipoOperacion != '0200'" class="smallito">
        <b-col cols="12" sm="9" md="10" lg="10" xl="10">
          <b-row>
            <b-col  cols="12" sm="6" md="4" lg="4" xl="2">
              <b-form-input
                      class="input-placedark input-dark colorBorde"
                      placeholder="RUC"
                      maxlength="11"
                      v-model="receptor.numero"
                      @change="pitcherReceiver(1)"
              ></b-form-input>
              <template v-if="cargandoreceptor">
                <b-list-group class="searcher-field">
                  <b-list-group-item>
                    Buscando
                    <i class="fa fa-spin fa-spinner"></i>
                  </b-list-group-item>
                </b-list-group>
              </template>
              <b-list-group v-if="listarec" class="searcher-field">
                <!-- <b-list-group-item v-if="norec">No hay Receptores con ese número</b-list-group-item> -->
                <template v-for="(item, index) in listaReceptores" class="buscarRuc">
                  <b-list-group-item
                          :key="index"
                          @click="setReceiver(item)"
                          class="searcher-result"
                  >{{item.idReceptor + ' - ' + item.razonSocial}}</b-list-group-item>
                </template>
              </b-list-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" lg="4" xl="4" class="pl-0 pr-0">
              <b-form-input
                      size="md"
                      type="text"
                      @keyup.enter="pitcherReceiver(2)" 
                      v-model="receptor.razonSocial"
                      :value="receptor.razonSocial"
                      placeholder="Razón Social"
                      class="input-placedark input-dark colorBorde"
              ></b-form-input>
            </b-col>
            <b-col cols="12" sm="12" md="4" lg="6" xl="6" class=" pr-0">
              <b-input-group>
                <b-form-input
                        class="input-placedark input-dark colorBorde"
                        size="md"
                        type="text"
                        :disabled="ructen"
                        placeholder="Dirección "
                        v-model="receptor.direccion"
                ></b-form-input>
                <b-input-group-text class="colorBorde" slot="append">
                  <b-button v-if="editarDireccion" @click="editarDire()" size="sm" variant="primary" class="sinresultados mr-1" title="Editar Dirección">
                    <i class="fa fa-pen"></i>
                  </b-button>
                  <b-button v-if="habilitarDireccion" @click="direccionLista()" size="sm" variant="success" class="sinresultados mr-1" title="Guardar Dirección">
                    <i class="fa fa-pen"></i>
                  </b-button>
                  <button class="btn btn-warning btn-sm sinresultados" @click="changeDirection()">
                    <i class="fa fa-list"></i>
                  </button>
                </b-input-group-text>
              </b-input-group>
              <template v-if="verDirecciones">
                <template v-for="(item, index) in direcciones" class="buscarRuc">
                  <b-list-group-item 
                          :key="index"
                          @click="setDirection(item)"
                          class="searcher-result"
                  >{{item.direccion}}</b-list-group-item>
                </template>
              </template>
            </b-col>
            <b-modal title="Agregar nuevos clientes" size="lg" centered v-model="modalCliente">
              <b-form-row>
                <b-col>
                  <b-form-group label="Ingrese el RUC de su cliente">
                    <b-row align-v="center">
                      <b-col cols="12">
                        <template>
                          <b-form-input v-model="rucCliente" placeholder="RUC (*)"></b-form-input>
                        </template>
                      </b-col>
                    </b-row>
                    <br />
                  </b-form-group>
                </b-col>
              </b-form-row>
              <div slot="modal-footer" class="w-100">
                <b-button
                        v-if="!updateClienteDatos"
                        type="button"
                        variant="primary"
                        @click="updateClient"
                >
                  <i class="fa fa-plus"></i> Actualizar
                </b-button>
                <b-button v-else type="button" variant="secondary">
                  <i class="fa fa-spin fa-spinner"></i> Actualizando...
                </b-button>
              </div>
            </b-modal>
            <b-modal v-model="modalClienteCargando" centered >
              <div class="text-center"><h3>Buscando RUC... <i class="fa fa-spin fa-spinner"></i> </h3></div> 
              <div slot="modal-footer" class="w-100">
              </div>
            </b-modal>
            <b-modal v-model="rucNoEncontrado" centered>
              <h3>No pude encontrar el RUC solicitado "{{ this.receptor.numero }}", por favor validar con el portal de SUNAT</h3>
            </b-modal>
          </b-row>
        </b-col>
        <b-col cols="12" sm="3" md="2" lg="2" xl="2" class="pr-0">
          <b-row>
            <template v-if="typeInvoice == '1'">
              <b-col cols="12" sm="12" md="12" lg="12" xl="10">
                <b-input-group style="width:115%">
                  <template v-if="seriesCargadas">
                    <b-button size="md" variant="secondary" outline-success>
                      Cargando Series...
                      <i class="fa fa-spin fa-spinner"></i>
                    </b-button>
                  </template>
                  <template v-else>
                    <select class="form-control input-placedark input-dark colorBorde" v-model="indexSerie">
                      <option
                              v-for="(serie, index) in listaSeries"
                              :value="index"
                              :key="index"
                      >{{ serie }}</option>
                    </select>
                  </template>
                </b-input-group>
              </b-col>
            </template>
            <template v-else-if="typeInvoice == '2'">
              <b-col cols="12" sm="12" md="12" lg="12" xl="10">
                <input
                        v-model="seriecon"
                        maxlength="4"
                        type="text"
                        class="form-control input-requerido input-dark"
                        placeholder="Serie (*)"
                />
              </b-col>
              <b-col cols="12" sm="12" md="12" lg="12" xl="10">
                <input
                        v-model="numero"
                        minlength="1"
                        type="text"
                        class="form-control"
                        placeholder="Numero"
                />
              </b-col>
            </template>
          </b-row>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col sm="2" >
          <select
                  class="custom-select mr-sm-2 input-placedark input-dark"
                  id="inlineFormCustomSelect"
                  v-model="tipoDocumentoExtrangeros"
          >
            <option
                    :value="tipodocumento.tipo"
                    v-for="tipodocumento in documentosIdentidadExtrangeros"
                    v-bind:key="tipodocumento.tipo"
            >{{ tipodocumento.nombre }}</option>
          </select>
        </b-col>
        <b-col sm="2">
          <b-form-group
                  label-for="input_receptorNumero"
                  :invalid-feedback="invalidFeedbackReceptorNumero"
                  :valid-feedback="validFeedbackReceptorNumero"
                  :state="stateReceptorNumero"
          >
            <b-input-group size="md">
              <b-form-input
                      :value="receptor.numero"
                      required
                      v-model="receptor.numero"
                      maxlength="15"
                      class="form-control input-placedark input-dark"
                      type="text"
                      id="input_receptorNumero"
                      :state="stateReceptorNumero"
                      placeholder="Ingresar Documento"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col sm="3">
          <b-form-input
                  class="input-placedark input-dark"
                  size="md"
                  type="text"
                  v-model="receptor.razonSocial"
                  :value="receptor.razonSocial"
                  placeholder="Razón Social"
          ></b-form-input>
        </b-col>
        <b-col sm="3">
          <b-col sm="12">
            <b-form-input
                    class="input-placedark"
                    size="md"
                    type="text"
                    v-model="receptor.direccion"
                    :value="receptor.direccion"
                    placeholder="Dirección"
            ></b-form-input>
          </b-col>
        </b-col>
        <b-col cols="1">
            <template v-if="typeInvoice == 1">
                <b-input-group>
                  <template v-if="seriesCargadas">
                    <b-button size="md" variant="secondary" outline-success>
                      Cargando Series...
                      <i class="fa fa-spin fa-spinner"></i>
                    </b-button>
                  </template>
                  <template v-else>
                    <select class="form-control input-placedark input-dark" v-model="indexSerie">
                      <option
                              v-for="(serie, index) in listaSeries"
                              :value="index"
                              :key="index"
                      >{{ serie }}</option>
                    </select>
                  </template>
                </b-input-group>
            </template>
            <!-- serie contingencia -->
            <template v-else>
              <b-col>
                <input
                        v-model="seriecon"
                        maxlength="4"
                        type="text"
                        class="form-control input-placedark colorBorde"
                        placeholder="Serie (*)"
                />
              </b-col>
              <b-col>
                <input
                        v-model="numero"
                        minlength="1"
                        type="text"
                        class="form-control"
                        placeholder="Numero"
                />
              </b-col>
            </template>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col cols="12" sm="3" md="3" lg="3" xl="1" class="pr-0">
          <b-form-input
                  @keyup.enter="enter()"
                  :min="0.0"
                  :step="0.01"
                  v-model="cantidad"
                  class="input-placedark input-dark colorBorde"
                  placeholder="Cantidad (*)"
                  
          ></b-form-input>
          <small v-if="checkcantidad" class="form-text text-muted">
            <span class="text-danger">{{ responsecheckcantidad }}</span>
          </small>
        </b-col>
        <b-col cols="12" sm="3" md="3" lg="3" xl="2" class="pr-0">
          <select
                  class="custom-select mr-sm-2 input-placedark input-dark colorBorde"
                  id="inlineFormCustomSelect"
                  v-model="unidadMedidaCantidad"
          >
            <option
                    :value="unidad.codigo"
                    v-for="unidad in unidades"
                    v-bind:key="unidad.id"
            >{{ unidad.descripcion }}</option>
          </select>
        </b-col>
        <b-col cols="12" sm="3" md="3" lg="3" xl="2" class="pr-0">
          <b-input-group>
            <b-form-input
                    autofocus
                    class="form-control input-placedark input-dark colorBorde"
                    placeholder="C. Prod."
                    maxlength="30"
                    v-model="codigoProducto"
                    @change="busquedaCodigoItem"
            ></b-form-input>
          </b-input-group>
          <template v-if="cargandoCodBarras">
            <b-list-group class="searcher-field">
              <b-list-group-item>
                Buscando
                <i class="fa fa-spin fa-spinner"></i>
              </b-list-group-item>
            </b-list-group>
          </template>
          <b-list-group v-if="listaProductCod" class="searcher-field">
            <table v-if="resultadoCodProducto.length > 0" class="searcher-result3">
                <tr class="centrarTitulo tablaborde">
                  <th style="width:10%;">Código</th>
                  <th style="width:50%;">Productos</th>
                  <th style="width:8%;">Precio</th>
                  <th style="width:5%;">Costo</th>
                  <th style="width:7%;">Stock</th>
                </tr>
              </table>
            <template v-for="(item, index) in resultadoCodProducto">
              <table  
                @click="setReceiverProductCode(item)" 
                class="searcher-result2" 
                :key="index">  
                <tr>
                  <td style="width:10%;" class="tablaborde centrarTitulo">{{item.codigo}}</td>
                  <td style="width:50%;" class="tablaborde ">{{item.descripcion.toUpperCase()}}</td>
                  <td style="width:8%;" class="tablaborde centrarTitulo">{{item.precioUnitario}}</td>
                  <td style="width:5%;color:red;" class="tablaborde centrarTitulo">{{item.precioCosto}}</td>
                  <td style="width:7%;" class="tablaborde centrarTitulo">{{item.stock}}</td>
                </tr>
              </table>
              </template>
          </b-list-group>
        </b-col>
        <b-col cols="12" sm="12" md="12" lg="12" xl="7">          
          <b-input-group>
            <b-form-input
                    placeholder="Descripción Producto"
                    maxlength="500"
                    v-model="descripcion"
                    @keydown="tecla"
                    class="input-placedark input-dark colorBorde"
                    type="text"
            ></b-form-input>
            <b-input-group-text class="colorBorde" slot="append">
              <button class="btn btn-warning btn-sm sinresultados" @click="cerrarresultados">
                <i class="fa fa-times"></i>
              </button>
              <b-button  variant="primary" class="sinresultados ml-1" size="sm"  @click="busquedaProductos()"><i class="fa fa-list"></i></b-button>     
            </b-input-group-text>
          </b-input-group>
          <template v-if="cargandoDescription">
            <b-list-group-item>
              Buscando
              <i class="fa fa-spin fa-spinner"></i>
            </b-list-group-item>
          </template>
          <b-list-group v-if="listades" class="searcher-field">
            <template v-if="!nuevaBusqueda">
                <table v-if="listaDescription.length > 0" class="searcher-result3">
                  <tr class="centrarTitulo tablaborde">
                    <th style="width:50%;">Productos</th>
                    <th style="width:8%;">Precio</th>
                    <th style="width:5%;">Costo</th>
                    <th style="width:10%;">Código</th>
                  </tr>
                </table>
                <template v-for="(item, index) in opcionesOrdenadas">
                  <table
                    @click="agregarItem(item)" 
                    class="searcher-result2" 
                    :key="index">  
                    <tr>
                      <td style="width:50%;" class="tablaborde ">{{item.descripcion.toUpperCase()}}</td>
                      <td style="width:8%;" class="tablaborde centrarTitulo">{{item.precioUnitario}}</td>
                      <td style="width:5%;color:red" class="tablaborde centrarTitulo">{{item.precioCosto}}</td>
                      <td style="width:10%;" class="tablaborde centrarTitulo">{{item.codigo}}</td>
                    </tr>
                  </table>
                </template>
              </template> 
          </b-list-group>
          <template>
              <div v-if="cargandoInformacion">
                <b-list-group-item>Cargando Informacion <i class="fa fa-spin fa-spinner"></i></b-list-group-item> 
              </div>
            </template>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col cols="12" sm="12" md="12" lg="12" xl="9">
          <b-row>
            <b-col cols="12" sm="12" md="12" lg="12" xl="12">
              <b-row>
                <b-col cols="12" sm="4" md="3" lg="2" xl="2" class="pr-0">
                  <b-form-input
                          v-if="!vunitario"
                          v-model="precioVentaUnitario"
                          class="input-placedark input-dark colorBorde"
                          placeholder="Precio Unitario (con IGV)"
                          @keyup.enter="enter()"
                          required
                  />
                  <b-form-input
                          v-else
                          v-model="precioVentaUnitario"
                          class="input-placedark input-dark colorBorde"
                          placeholder="Precio Unitario (con IGV)"
                          required
                          disabled
                  />
                  <small v-if="checkprecioventaunitario" class="form-text text-muted">
                    <span class="text-danger">{{ responsecheckprecioventaunitario }}</span>
                  </small>
                </b-col>
                <b-col cols="12" sm="4" md="3" lg="2" xl="2" class="pr-0">
                  <b-form-input
                          v-if="vunitario"
                          @keyup.enter="enter()"
                          type="text"
                          min="0.0"
                          step="0.01"
                          v-model.number="valorUnitario"
                          class="input-placedark input-dark colorBorde"
                          placeholder="Valor Unitario (Sin IGV)"
                          required
                  />
                  <b-form-input
                          v-else
                          type="number"
                          min="0.0"
                          step="0.01"
                          v-model="valorUnitario"
                          class="input-placedark input-dark colorBorde"
                          placeholder="Valor Unitario (Sin IGV)"
                          required
                          disabled
                  />
                  <small v-if="checkvalorunitario" class="form-text text-muted">
                    <span class="text-danger">{{ responsecheckvalorunitario }}</span>
                  </small>
                </b-col>
                <b-col cols="12" sm="4" md="3" lg="3" xl="1">
                    <b-form-checkbox v-model="descuento">Dscto</b-form-checkbox>
                </b-col>
                <b-col cols="12" sm="4" md="3" lg="3" xl="2" class="pl-0">
                  <b-input-group v-if="!descuento" class="colorBorde">
                    <b-form-input 
                      @keyup.enter="enter()"
                      v-model="descuentoItemMonto"
                      class="input-placedark input-dark colorBorde"
                    />
                    <b-input-group-text slot="prepend" class="colorBorde">
                      S/
                    </b-input-group-text>
                  </b-input-group>
                  <b-input-group v-else>
                    <input 
                    @keyup.enter="enter()"
                    v-model="descuentoItemPorcentaje"
                    class="form-control colorBorde"
                    />
                    <b-input-group-text slot="append" class="colorBorde">
                      %
                    </b-input-group-text>
                  </b-input-group>
                </b-col>
                <b-col cols="12" sm="6" md="3" lg="2" xl="2" class="pl-0">
                  <b-form-input v-if="tipoOperacion == '0200'" disabled value="Exportación"></b-form-input>
                  <b-form-input v-if="tipoOperacion == '0101EDU'" class="custom-select input-dark colorBorde" disabled value="Inafecto"></b-form-input>

                  <select :disabled="vunitario == true"
                          v-else
                          class="custom-select input-dark colorBorde"
                          v-model="especificacionIgv"
                  >
                    <option
                            :value="afec.id"
                            v-for="afec in listaafectacion"
                            v-bind:key="afec.id"
                    >{{ afec.descripcion }}</option>
                  </select> 
                </b-col>
                <b-col v-if="!ventaGratuita" cols="12" sm="6" md="3" lg="3" xl="3" class="pl-0 pr-0">
                  <b-form-input disabled value="Operación Onerosa" class="colorBorde"></b-form-input>
                </b-col>
                <b-col v-else cols="12" sm="6" md="3" lg="3" xl="3" class="pl-0 pr-0">
                  <b-form-input v-if="tipoOperacion == '0200'" disabled value="Bienes"></b-form-input>
                  <select
                          v-else
                          class="custom-select mr-sm-2 input-placedark input-dark colorBorde"
                          v-model="especificacion"
                  >
                    <option
                            :value="espec"
                            v-for="espec in Especificacion"
                            v-bind:key="espec.id"
                    >{{ espec.descripcion }}</option>
                  </select>
                </b-col>
              </b-row>
              <br />
              <b-row>
                <b-col cols="12" sm="6" md="3" lg="3" xl="12"></b-col>
              </b-row>
              <b-row v-if="detraccionCarga">
                <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                  <adicionales-detraccion-carga :modalEditarAdicionales="modalEditarAdicionales" :editarAdicionales="editarAdicionales" @detraccion="adicionalDetraccionBack" @ValordetraccionTrasporte="sumadetracciontrasporte"></adicionales-detraccion-carga>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <br />
          <br />
          <b-row>
            <!-- class=""
                title="Mostrar último comprobante Emitido"
                @click="vistaPreviaPdf"
                style="background: none; border: none; padding: 0;"> -->
                <!-- <img src="images/pdf02.png" alt="Icono" style="width: 60px; height: 80px;" -->
            <b-col class="buttonagregar" cols="12" sm="12" md="12" lg="12" xl="4">
              <div class="float-right">
              <b-button 
              class="btn btn-primary"
              title="Mostrar último comprobante Emitido"
              @click="vistaPreviaPdf"
              style="background: none; border: none; padding: 0;">
              <img src="images/pdf02.png" alt="Icono" style="width: 50px; height: 60px;">
              </b-button>
              </div>
              <b-modal id="prevmodal" size="lg" title="Vista Previa" cancel-title="Cerrar" v-model="previewmodal">
                  <template v-if="cargandoPdf"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
                  <template v-else>
                  <template v-if="pdfobject !==''">
                      <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
                  </template>
                  </template>
              </b-modal>
            </b-col> 
            <b-col cols="12" sm="12" md="12" lg="12" xl="4" class="text-center buttonagregar ">
              <template v-if="!setUpdateItem">
                <button
                        class="btn btn-primary btnagregarstyle"
                        v-if="validateFields()"
                        @click="addItem()"
                >
                  <i class="fa fa-plus"></i> Agregar 
                </button>
                <button class="btn btn-secondary btnagregarstyle" disabled v-else>
                  <i class="fa fa-plus"></i> Agregar<!-- BOTON AGREGAR PRODUCTO -->
                </button>
              </template>
              <template v-else>
                <button class="btn btn-warning" @click="executeUpdate()">
                  <i class="fa fa-plus"></i> Actualizar
                </button>
              </template>
            </b-col>
            <!-- importar items -->
            <b-col cols="12" sm="12" md="12" lg="12" xl="2">
              <b-button variant="success" @click="importarProductosGuia()" class="mover estilo ml-5">Items Guia</b-button>
            </b-col>
            <b-col  cols="12" sm="12" md="12" lg="12" xl="2" class="mover">
                        <!-- <b-form-file  v-model="doc" :state="Boolean(doc)" @change="onChange" placeholder="Documento" /> -->
                        <div class="upload-btn-wrapper">
                          <b-button class="estilo" v-model="doc" :state="Boolean(doc)"><i class="fas fa-upload"></i> Items</b-button>
                          <input  type="file" @change="onChange" name="myfile" />
                        </div>
                        <xlsx-read :file="file">                       
                            <xlsx-json>
                            <template #default="{collection}">
                                <div style="display:none;">
                                {{ coleccion=collection }}
                                </div>
                            </template>
                            </xlsx-json>
                        </xlsx-read>
              </b-col>
                    <!-- <b-col cols="1" class="mover">
                        <b-button :disabled="borraritem" @click="limpiarExcel()" variant="danger">Borrar</b-button>
                    </b-col> -->
                    <import :igvGlobal="igvGlobal" :item="item" :itemsEX="itemsEX" :action="action" @totalitems="totalitems"></import>
              <!-- importar items -->
          </b-row>
        </b-col>
        <b-col cols="1">
          <b-form-input
                    v-if="!vbarras"
                    :placeholder="placeholdercodigo"
                    class="form-control input-placedark input-dark colorBorde"
                    maxlength="8"
                    v-model="codigoSunatBarras"
                    @change="getReceiversBarCodeSunat"
            ></b-form-input>
        </b-col>
        <b-col style="background-color:#ffb80e;border-radius:20px" class="pt-2 pb-0 mb-2" cols="12" sm="12" md="12" lg="12" xl="2">
            
                <b-form-checkbox v-model="vunitario">Usar valor unitario</b-form-checkbox>
                <b-form-checkbox v-model="servicio">Servicio</b-form-checkbox>
                <b-form-checkbox v-model="ventaGratuita" :disabled="disabledGratuita">Venta Gratuita</b-form-checkbox>
                <b-form-checkbox v-model="icbper">ICBPER</b-form-checkbox>
            <div style="float:left">
              <b-form-checkbox v-model="isc">ISC</b-form-checkbox>
            </div>
            <div v-if="isc">
              <b-form-select class="ml-3 mb-2" style="width:40%;float:left" v-model="selectedISC" :options="optionsISC" size="sm"></b-form-select>
            </div>            
            <div class="mb-2" style="float:left" v-if="selectedISC == 1 && isc == true">
                <template v-if="cuadroISC">
                <b-input-group >
                    <template #append>
                      <b-input-group-text style="height:30px">%</b-input-group-text>
                    </template>
                      <b-form-input v-model="montoISC" @keyup.enter="valorUnitIsc()" type="number" style="height:30px;width:100px;margin-left:20px" autofocus ></b-form-input>
                </b-input-group>
                </template>
                <template v-else-if="flechaISC">
                  <b-button class="ml-2"  @click="mostrarISC" size="sm" variant="light"><i class="fas fa-arrow-right"></i></b-button>                 
                </template>
            </div>
            <div class="mb-2" style="float:left" v-if="selectedISC == 2 && isc == true">
              <template v-if="cuadroISC">
                <b-input-group >
                    <template #append>
                      <b-input-group-text style="height:30px">S/</b-input-group-text>
                    </template>
                      <b-form-input v-model="montoISC" @keyup.enter="valorUnitIsc()" type="number" style="height:30px;width:100px;margin-left:20px" autofocus ></b-form-input>
                </b-input-group>
                </template>
                <template v-else-if="flechaISC">
                  <b-button class="ml-2"  @click="mostrarISC" size="sm" variant="light"><i class="fas fa-arrow-right"></i></b-button>                 
                </template>
            </div>
            <div class="mt-2 mb-2" style="float:left;width:100%" v-if="selectedISC == 3 && isc == true">
                <template v-if="cuadroISC">
                  <div style="width:49%;float:left">
                     <b-input-group >
                        <template #append>
                          <b-input-group-text style="height:30px">S/</b-input-group-text>
                        </template>
                          <b-form-input v-model="montoISC" type="number" style="height:30px" autofocus ></b-form-input>
                      </b-input-group>
                  </div>
                  <div style="width:49%;float:right">
                      <b-input-group >
                        <template #append>
                          <b-input-group-text style="height:30px">%</b-input-group-text>
                        </template>
                        <b-form-input v-model="porcentajeISC" @keyup.enter="valorUnitIsc()" type="number" style="height:30px"></b-form-input>
                      </b-input-group>
                  </div>             
                </template>
                <template v-else-if="flechaISC">
                  <b-button class="ml-2"  @click="mostrarISC" size="sm" variant="light"><i class="fas fa-arrow-right"></i></b-button>                 
                </template>
            </div>
        </b-col>
      </b-row>
      <b-modal scrollable  size="xl" v-model="searchItems">
        <div slot="modal-header" class="w-100">
          <b-row>
            <b-col cols="1" class="mt-2">
              <label>B&uacute;squeda:</label>        
            </b-col>
            <b-col cols="6">
              <b-form-input style="color:black;border-color:black" v-model="descripcion"  @keyup.enter="search()" placeholder="Descripción"></b-form-input>
            </b-col>
            <b-col cols="1">
              <b-button variant="outline-primary" @click="search()" title="Buscar"><i class="fas fa-search"></i></b-button>
            </b-col>
            <b-col cols="2">
              <b-button variant="outline-primary" @click="cargarItems()" title="Agregar">Agregar Todo <i class="fas fa-plus"></i></b-button>
            </b-col>
            <b-col cols="2">
             <h5><p>Agregados: <b>{{ items.length }}</b></p></h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="10"></b-col>
            <b-col cols="2"><h5><p>Importe Total: <b>{{ importeTotal }}</b></p></h5></b-col>
          </b-row>
        </div>
        <div v-if="mostrarListaProduc">
          <div align="center" class="mb-5">
            <h3><i class="fas fa-spin fa-spinner"></i><strong>Cargando...</strong></h3> 
          </div>
        </div>
          <b-table
            v-else
            hover
            outlined
            small
            :items="ListProductos" 
            :fields="List_Productos">
            <template slot="codigo" slot-scope="row">
              {{row.item.codigo}}
            </template>
            <template slot="precioUnitario" slot-scope="row">
              <b-form-input style="color:black;border-color:black" v-model="row.item.precioUnitario" type="number"></b-form-input>
            </template>
            <template slot="precioCosto" slot-scope="row">
                <div v-if="row.item.precioCosto == null">
                  0.00
                </div>
                <div v-else>{{row.item.precioCosto}}</div>
            </template>
            <template slot="stock" slot-scope="row">
              <div v-if="row.item.stock < 0" style="color:red"><b>{{row.item.stock}}</b></div>
              <div v-else style="color:green"><b>{{row.item.stock}}</b></div>
            </template>
            <template slot="cantidad" slot-scope="row">
                <b-form-input style="color:black;border-color:black"  @keyup.enter="addUnidad(row.item)"  v-model="row.item.cantidad" placeholder="0" type="number"></b-form-input>
            </template>
            <template slot="accion" slot-scope="row">
              <b-button title="Agregar" variant="success" @click="addUnidad(row.item)" ><i class="fa fa-shopping-basket fa-lg"></i></b-button>
            </template>
          </b-table>
          <template  slot="modal-footer">
            <div class="w-100">
              <b-row>
                <b-col cols="1">
                  <p class="float-left mt-2">Código:</p>
                </b-col>
                <b-col cols="4">
                  <b-input-group>
                    <b-form-input
                      style="color:black;border-color:black" 
                      placeholder="Búsqueda por Código del Producto" 
                      v-model="codDescripcion" 
                      @keyup.enter="searchCodigo()" 
                      autofocus>
                    </b-form-input>
                    <b-input-group-text slot="append">
                      <b-button
                        title="Limpiar Caja de Búsqueda"
                        class="p-0 pr-1 pl-1"
                        variant="danger" 
                        size="sm"  
                        @click="limpiar()">
                        <i class="fa fa-trash danger"></i>
                      </b-button>         
                    </b-input-group-text>
                  </b-input-group>
                </b-col>
                <b-col cols="6"></b-col>
                <b-col cols="1">
                  <b-button variant="outline-primary" @click="closeSearchItem()" title="Salir">Cerrar</b-button>
                </b-col>
              </b-row>
            </div>
          </template>
      </b-modal>
      <b-table responsive :small="small" :items="items" :fields="items_fields" :outlined="outlined" :tbody-tr-class="rowClass">
        <template slot="index" slot-scope="row">
          <template v-if="row.item.idProducto !='-' && row.item.idProducto !=''">
            <i title="contiene idProducto" style="color:lightgreen" class="fas fa-check"></i>
          </template> 
          {{ row.index +1 }}
          </template>
          <template slot="descripcion" slot-scope="row">
            <b-form-textarea
              id="textarea"
              v-model="row.item.descripcion"
              placeholder="Enter something..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </template>
          <template slot="stock" slot-scope="row">
              <template v-if="row.item.stock ==null">
                    <i class="fa fa-spin fa-spinner"></i>
              </template>
              <template  v-else>
                <div v-if="row.item.stock < 0" style="color:red"><b>{{row.item.stock}}</b></div>
                <div v-else style="color:green"><b>{{row.item.stock}}</b></div>
              </template>
          </template>
        <template slot="precioUni" slot-scope="row">
          <template v-if="row.item.adicional && row.item.adicional.precioVentaUni && row.item.adicional.precioVentaUni !=''">
              {{row.item.adicional.precioVentaUni}}
          </template>
          <template v-else>
              {{row.item.precioVentaUnitario}}
          </template> 
        </template>
        <template slot="descuentoUni" slot-scope="row">
          <template v-if="row.item.adicional && row.item.adicional.indicardorDsct !='' && row.item.adicional.indicardorDsct == '01'">
            S/ {{row.item.adicional.dsctSoles}}
          </template>
          <template v-else-if="row.item.adicional && row.item.adicional.indicardorDsct !='' && row.item.adicional.indicardorDsct == '02'">
            {{row.item.adicional.dsctPorcentaje}}%
          </template>
          <template v-else>
            {{row.item.descuento}}
          </template>
        </template>
        <template slot="precioT" slot-scope="row"> 
          <template v-if="row.item.adicional && row.item.adicional.precioVentaUni && row.item.adicional.precioVentaUni !=''">
              <!-- {{(parseFloat(row.item.cantidad) * row.item.adicional.precioVentaUni).toFixed(2)}} -->
              {{(row.item.montoTotalImpuestosItem + row.item.valorVenta).toFixed(2)}}
          </template>
          <template v-else-if="row.item.montoTotalImpuestosItem + row.item.valorVenta == 0" >
   
                  {{(row.item.montoTotalImpuestosItem + row.item.valorVenta).toFixed(2)}}

          </template>
          <template v-else>
            {{row.item.montoTotalImpuestosItem + row.item.valorVenta}}
          </template>  
        </template>
        <template slot="acciones" slot-scope="row">
          <b-row>
            <button
                    class="btn btn-sm btn-group btn-outline-primary acciones-espacio"
                    @click.prevent="updateItem(row.index, row.item)"
            >
              <i class="fa fa-edit primary"></i>
            </button>
            <button
                    class="btn btn-sm btn-group btn-outline-danger"
                    @click.prevent="deleteItem(row.index)"
            >
              <i class="fa fa-trash danger"></i>
            </button>
          </b-row>
        </template>
        <template slot="muestraIgv" slot-scope="row">
            <p style="color:red; font-size:10px;margin:0px;padding: 0px;">{{ row.item.porcentajeImpuesto }}%</p>
        </template>
      </b-table>
      <hr />
      <b-row>
        <b-col cols="12" sm="12" md="6" lg="7" xl="8">
          <div>
            <b-row>
              <b-col cols="12" sm="12" md="12" lg="12" xl="4">
                <b-input-group>
                  <b-button v-if="formadepago.codigo =='00'"  v-b-tooltip.hover="'ver cuotas crédito'" style="border:none" variant="outline-primary" class="sinresultados mr-1" size="sm" @click="vercreditos()"><i class="fas fa-eye"></i></b-button>
                <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="formadepago">
                  <option :value="fpago"
                          v-for="fpago in formaPago"
                          v-bind:key="fpago.codigo"
                  >{{ fpago.nombre }}</option>
                </select>
                </b-input-group>
              </b-col>
              <b-col cols="12" sm="12" md="12" lg="12" xl="4">
                <b-form-group
                        label-for="input_seriedeguia"
                        :invalid-feedback="invalidFeedbackOrdenCompra"
                        :valid-feedback="validFeedbackOrdenCompra"
                        :state="stateOrdenCompra"
                >
                  <b-input-group size="md">
                    <b-form-input
                            :value="ordenCompra"
                            required
                            @input="ordenCompra = $event.toUpperCase()"
                            v-model="ordenCompra"
                            maxlength="20"
                            class="form-control input-placedark input-dark"
                            type="text"
                            id="input_ordendecompra"
                            :state="stateOrdenCompra"
                            placeholder="Orden de Compra"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="12" md="12" lg="12" xl="4">
                <datepicker
                        class="input-placedark input-dark"
                        v-model="fvencimiento"
                        :language="es"
                        :format="customFormatter"
                        :bootstrap-styling="true"
                        placeholder="Fecha de Vencimiento Factura"
                ></datepicker>
              </b-col>
            </b-row>
          </div>
          <b-row class="mb-2"> 
            <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="1"><img title="Pago con Yape" class="formasPagosImg" src="images/yape.png" @click="pagosImg(1)"><b-badge v-if="colorPago1" style="color:green">Yape</b-badge><p v-else>Yape</p></b-col>
            <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="1"><img title="Pago con Plin" class="formasPagosImg" src="images/plin.png" @click="pagosImg(2)"><b-badge v-if="colorPago2" style="color:green">Plin</b-badge><p v-else>Plin</p></b-col>
            <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="1"><img title="Pago A Crédito" class="formasPagosImg" src="images/Acredito.png" @click="pagosImg(3)"><b-badge v-if="colorPago3" style="color:green">A crédito</b-badge><p v-else>A crédito</p></b-col>
            <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="1"><img title="T.Débito" class="formasPagosImg" src="images/tDebito.png" @click="pagosImg(4)"><b-badge v-if="colorPago4" style="color:green">T.Débito</b-badge><p v-else>T.Débito</p></b-col>
            <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="1"><img title="Pago Efectivo" class="formasPagosImg" src="images/efectivo1.png" @click="pagosImg(5)"><b-badge v-if="colorPago5" style="color:green">Efectivo</b-badge><p v-else>Efectivo</p></b-col>
            <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="1"><img title="T.Crédito" class="formasPagosImg" src="images/tCredito.png" @click="pagosImg(6)"><b-badge v-if="colorPago6" style="color:green">T.Crédito</b-badge><p v-else>T.Crédito</p></b-col>
            <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="1"><img title="Depósito en Cuenta" class="formasPagosImg" src="images/depositoCuenta.png" @click="pagosImg(7)"><b-badge v-if="colorPago7" style="color:green">Déposito Cuenta</b-badge><p v-else>Déposito Cuenta</p></b-col>
            <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="1"><img title="Transferencia Bancos" class="formasPagosImg" src="images/transBancos.png" @click="pagosImg(8)"><b-badge v-if="colorPago8" style="color:green">Trans.Fondos</b-badge><p v-else>Trans. Fondos</p></b-col>
          </b-row>
          <div>
            <b-btn block v-b-toggle.relacionadas class="m-1 colorestelemovil">Guias Relacionadas</b-btn>
            <b-collapse id="relacionadas">
              <b-card>
                <b-row>
                  <b-col cols="12" sm="12" md="12" lg="12" xl="2">
                    <b-form-group                           
                            label-for="input_seriedeguia"
                            :invalid-feedback="invalidFeedbackSerieGuia"
                            :valid-feedback="validFeedbackSerieGuia"
                            :state="stateSerieGuia"
                    >
                      <b-input-group size="md">
                        <b-form-input
                                :value="seriedeguia"
                                required
                                @input="seriedeguia = $event.toUpperCase()"
                                v-model="seriedeguia"
                                minlength="4"
                                maxlength="4"
                                class="form-control input-placedark input-dark"
                                type="text"
                                id="input_seriedeguia"
                                :state="stateSerieGuia"
                                placeholder="Serie"
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="12" md="12" lg="12" xl="2">
                    <b-form-input
                            v-model="numerodeguia"
                            class="form-control input-placedark input-dark"
                            placeholder="Numero"
                            required
                    />
                  </b-col>
                  <b-col cols="12" sm="12" md="12" lg="12" xl="6">
                    <select
                            class="custom-select mr-sm-2 input-placedark input-dark"
                            v-model="tipodeguia"
                            :disabled="tipoguialock"
                    >
                      <option
                              :value="tipo.codigo"
                              v-for="tipo in tiposGuia"
                              v-bind:key="tipo.codigo"
                      >{{ tipo.nombre }}</option>
                    </select>
                  </b-col>
                  <b-col cols="12" sm="12" md="12" lg="12" xl="2">
                    <button v-if="validateFieldsGuia()" class="btn btn-primary" @click="addGuia">
                      <i class="fa fa-plus"></i> Agregar
                    </button>
                    <button v-else class="btn btn-secondary" disabled>
                      <i class="fa fa-plus"></i> Agregar
                    </button>
                      <input type="file" id="upload" @change="onChange2" hidden/>
                        <label class="lab" title="Subir Guias" for="upload"><i class="fas fa-upload"></i></label>
                      <xlsx-read :file="guiasdoc">                       
                            <xlsx-json>
                            <template #default="{collection}">
                                <div style="display:none;">
                                {{ guiasmasiva=collection }}
                                </div>
                            </template>
                            </xlsx-json>
                        </xlsx-read>
                        <masiva-guia :reciveitem="pasandoGuias" :accion="accion" @totalitems2="totalitems2"></masiva-guia>

                  </b-col>
                </b-row>
                <b-row>
                  <b-table striped hover :items="items_guias" :fields="fields_guias">
                    <template slot="tipoGuia2" slot-scope="row">
                      <template v-if="row.item.tipoGuia == 1 || row.item.tipoGuia == 'Guia Remision Remitente'">Guia Remision Remitente</template>
                      <template v-else-if="row.item.tipoGuia == 2 || row.item.tipoGuia == 'Guia Remision Transportista' ">Guia Remision Transportista</template>
                    </template>
                    <template striped hover slot="acciones" slot-scope="row">
                      <b-button-group>
                        <b-button
                                variant="danger"
                                title="Eliminar Documento Relacionado"
                                @click="deleteGuia(row.index)"
                        >
                          <i class="fa fa-trash"></i>
                        </b-button>
                      </b-button-group>
                    </template>
                  </b-table>
                </b-row>
              </b-card>
            </b-collapse>
          </div>
          <div>
            <b-btn block v-b-toggle.docrelacionados class="m-1 colorestelemovil">
              Documentos Relacionados
            </b-btn>
            <b-collapse id="docrelacionados">
              <b-card>
                <b-row>
                  <b-col cols="12" sm="12" md="12" lg="12" xl="2">
                    <b-form-input
                            v-model="numerorelacionado"
                            class="form-control input-placedark input-dark"
                            placeholder="Numero"
                            required
                    />
                  </b-col>
                  <b-col cols="12" sm="12" md="12" lg="12" xl="6">
                    <select
                            class="custom-select mr-sm-2 input-placedark input-dark"
                            v-model="docRelacionado"
                            :disabled="docrelacionadolock"
                    >
                      <option
                              :value="tipo.codigo"
                              v-for="tipo in listaDocRelacionados"
                              v-bind:key="tipo.codigo"
                      >{{ tipo.nombre }}</option>
                    </select>
                  </b-col>
                  <b-col cols="12" sm="12" md="12" lg="12" xl="2">
                    <button
                            v-if="validateFieldsRelacionadas()"
                            class="btn btn-primary"
                            @click="addDocRelacionado"
                    >
                      <i class="fa fa-plus"></i> Agregar
                    </button>
                    <button v-else class="btn btn-secondary" disabled>
                      <i class="fa fa-plus"></i> Agregar
                    </button>
                  </b-col>
                </b-row>
                <br />
                <b-row>
                  <b-table striped hover :items="items_relacionados" :fields="fields_relacionados">
                    <template striped hover slot="acciones" slot-scope="row">
                      <b-button-group>
                        <b-button
                                variant="danger"
                                title="Eliminar Guia"
                                @click="deleteDocRelacionado(row.index)"
                        >
                          <i class="fa fa-trash"></i>
                        </b-button>
                      </b-button-group>
                    </template>
                  </b-table>
                </b-row>
              </b-card>
            </b-collapse>
          </div>
          <div>
            <b-btn block v-b-toggle.adicionales class="m-1 colorestelemovil">Datos Adicionales</b-btn>
            <b-collapse id="adicionales">
              <b-card>
                <b-row>
                  <b-col cols="12" sm="12" md="12" lg="4" xl="5">
                    <input
                            type="text"
                            placeholder="Nombre del Adicional"
                            class="form-control input-placedark input-dark"
                            v-model="key"
                    />
                  </b-col>
                  <b-col cols="12" sm="12" md="12" lg="4" xl="5">
                    <input
                            type="text"
                            placeholder="Valor del Adicional"
                            class="form-control input-placedark input-dark"
                            v-model="value"
                    />
                  </b-col>
                  <b-col cols="12" sm="12" md="12" lg="4" xl="2">
                    <button
                            v-if="validateFieldsAdicionales()"
                            class="btn btn-primary"
                            @click="addAdicional"
                    >
                      <i class="fa fa-plus"></i> Agregar
                    </button>
                    <button v-else class="btn btn-secondary" disabled>
                      <i class="fa fa-plus"></i> Agregar
                    </button>
                  </b-col>
                </b-row>
               <br />
                <b-row>
                  <b-table striped hover :items="items_adicionales" :fields="fields_adicionales">
                    <template striped hover slot="acciones" slot-scope="row">
                      <b-button-group>
                        <b-button
                                variant="danger"
                                title="Eliminar Adicional"
                                @click="deleteAdicional(row.index)"
                        >
                          <i class="fa fa-trash"></i>
                        </b-button>
                      </b-button-group>
                    </template>
                  </b-table>
                </b-row>
              </b-card>
            </b-collapse>
            <br>
            <b-row>
              <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                <enviar-comprobantes :listaCorreos="listaCorreos"></enviar-comprobantes>
              </b-col>
            </b-row> 
          <b-modal size="lg" v-model="modalImportarProdGuiaR">
            <template slot="modal-header">
            <div style="width:100%">
              <div class="float-left">
                <h5>Importar Productos</h5>
              </div>
              <div class="float-right">
                <b-button :disabled="cargandoItemGuia" variant="primary" @click="finalizarProceso">
                  Importar
                </b-button>
              </div>
            </div>
          </template>
          <template v-if="cargandoGuias" >
            <div>
              <h5>Cargando...</h5>
            </div>
          </template>
          <template v-else>
            <div>
          <b-table
        responsive 
        :small="small"
        :outlined="outlined"
        :items="guides"
        :fields="guides_fields"           
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection" 
        >
        <template slot="estado" slot-scope="row">
            <div v-if="row.item.emitido==1"><span class="badge badge-success">Emitido <i class="fa fa-check"></i></span></div>
            <div v-else-if="row.item.emitido==0"><span class="badge badge-warning">Procesando <i class="fa fa-spin fa-spinner"></i></span></div>
            <div v-else-if="row.item.emitido==2"><span class="badge badge-danger">Rechazado <i class="fa fa-times"></i></span></div>
        </template>
        <template slot="checkbox" slot-scope="row">
          <b-form-checkbox
            :value="row.item"
            v-model="seleccionados"
            @change="mostrarDetalles(row, row.index)"
            :disabled="cargandoItemGuia"
           >
          </b-form-checkbox>
        </template>
        <template slot="receptor" slot-scope="row">
            <template v-if="row.item.receiver">
                {{row.item.idReceptor}} - {{row.item.receiver.razonSocial}}
            </template>
            <template v-else>
                {{ row.item.idReceptor }}
            </template>            
        </template>
        <template slot="emision" slot-scope="row">
            {{ row.item.fechaEmision | moment('D/M/Y') }} 
        </template>
        <template slot="serie" slot-scope="row">
            {{ row.item.serie}}-{{ row.item.numero}} 
        </template>
        <template slot="acciones" slot-scope="row">
            <template v-if="row.item.emitido!=2">
                <b-button-group>
                    <button v-show="!row.item.loading" type="button" class="btn" size="sm" @click="mostrarDetalles(row, row.index)" title="Mas opciones">
                        <template v-if="!row.item.mostrardetalles">
                            <i class="fa fa-plus"></i>
                        </template>
                        <template v-else>
                            <i class="fa fa-minus"></i>
                        </template>
                    </button>
                </b-button-group>
            </template>
        </template>
        <template slot="row-details" slot-scope="row">
                <b-table 
                    head-variant="light"
                    small
                    bordered
                    :items="row.item.lista" 
                    :fields="listaitems_fields" 
                    :busy="row.item.loading">
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Cargando...</strong>
                    </div>
                    <template slot="index" slot-scope="row">
                        {{ row.index+1 }}
                    </template>
                    <template slot="cantidad" slot-scope="row">
                            {{ Number.parseFloat(row.item.cantidad).toFixed(2) }}
                    </template>
                    <template slot="precioVentaUnitario" slot-scope="row">
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template v-if="row.item.precioVentaUnitario">
                                {{ Number.parseFloat(row.item.precioVentaUnitario).toFixed(2) }}
                            </template>  
                    </template>
                    <template slot="descuento" slot-scope="row">                     
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template v-if="row.item.descuento">
                                {{ Number.parseFloat(row.item.descuento).toFixed(2) }}
                            </template>
                            <template v-else>
                                0.00
                            </template>                    
                    </template>     
                    <template slot="valorVenta" slot-scope="row">                      
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template v-if="row.item.valorVenta">
                                {{ Number.parseFloat(row.item.valorVenta*($store.state.igv == 18 ? 1.18 : 1.105) ).toFixed(2) }}
                            </template>                      
                    </template>
                </b-table>
        </template>           
    </b-table>
  </div>
          </template>
          <template slot="modal-footer">
            <div>
              <b-button variant="primary" :disabled="cargandoItemGuia" @click="finalizarProceso">
                Importar
              </b-button>
            </div>
          </template>
            
          </b-modal >
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="5" xl="4">
          <b-row>
            <b-col cols="12" sm="12" md="12" lg="12" xl="4" class="text-left">
              <b-button
                      v-b-modal.otroscargosmodal1
                      variant="secondary"
                      :disabled="this.items.length > 0 ? false:true"
              >
                <i class="fa fa-hand-holding-usd"></i> Otros Cargos
              </b-button>
              <b-modal
                      id="otroscargosmodal1"
                      title="Agregar Otros Cargos"
                      size="lg"
                      centered
                      v-model="otroscargosmodal"
              >
                <template>
                  <b-row>
                    <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                      <select class="form-control input-placedark input-dark" v-model="otroCargo">
                        <option
                                v-for="otrocargo in listaOtrosCargos"
                                :value="otrocargo"
                                :key="otrocargo.codigo"
                        >{{ otrocargo.descripcion }}</option>
                      </select>
                    </b-col>
                    <b-col cols="2" sm="2" md="1" lg="1" xl="1">
                      <p class="mt-2">{{ moneda.simbolo }}</p>
                    </b-col>
                    <b-col cols="8" sm="8" md="4" lg="4" xl="4">
                      <b-form-input
                              type="number"
                              v-model="montoOtroCargo"
                              placeholder="Monto del cargo"
                              @keyup.enter="addMontoCargo()"
                      ></b-form-input>
                    </b-col>
                    <b-col cols="2" sm="2" md="1" lg="1" xl="1">
                      <b-button variant="success" @click="addMontoCargo()">
                        <i class="fa fa-plus"></i>
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                      <b-table
                              striped
                              hover
                              small
                              responsive
                              outlined
                              :fields="otroscargos_fields"
                              :items="listaOtrosCargosAgregados"
                              :busy="otroscargosbusy"
                      >
                        <div slot="table-busy" class="text-center text-danger my-2">
                          <b-spinner class="align-middle"></b-spinner>
                          <strong>Cargando...</strong>
                        </div>
                        <template slot="descripcion" slot-scope="row">
                          <div
                                  v-if="row.item.codigoCargoDescuento==50"
                          >Cargos globales que no afectan la base imponible del IGV/IVAP</div>
                        </template>
                        <template
                                slot="montoCargo"
                                slot-scope="row"
                        >{{ moneda.simbolo }} {{ row.item.montoCargoDescuento }}</template>
                        <template slot="acciones" slot-scope="row">
                          <b-button
                                  size="sm"
                                  variant="danger"
                                  @click="deleteOtroCargo(row.index, row.item)"
                          >
                            <i class="fa fa-trash"></i>
                          </b-button>
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>
                </template>
                <div slot="modal-footer" class="w-100">
                  <b-row>
                    <b-col cols="12" sm="12" md="8" lg="8" xl="8">
                      <b-button size="sm" variant="danger" @click="cerrarmodalOtroCargo()">
                        <i class="fa fa-times"></i> Cerrar
                      </b-button>
                    </b-col>
                    <b-col
                            cols="12"
                            sm="12"
                            md="4"
                            lg="4"
                            xl="4"
                    >Sumatoria de cargos: {{ moneda.simbolo }} {{ accumulateOtrosCargos() }}</b-col>
                  </b-row>
                </div>
              </b-modal>
            </b-col>

             <!--DECUENTO GLOBAL-->
            <b-col cols="12" sm="12" md="12" lg="12" xl="4">
                        <b-button
                            v-b-modal.descuentosglobalI
                            variant="secondary"
                            :disabled="this.items.length > 0 ? false:true">
                            <i class="fas fa-tags"></i> Dscto Global
                        </b-button>
                <b-modal 
                              id="descuentosglobalI"
                              title="Agregar Descuento Global"
                              size="lg"
                              centered
                              v-model="descuentoglobalM">
                        
      
       <template>
                <b-row>
                    <b-col cols="12" sm="3" md="3" lg="3" xl="3" class="mt-4">
                        <select disabled class="custom-select mr-sm-2 input-placedark input-dark"  v-model="especificacionIgv">
                          <option
                            :value="afec.id"
                            v-for="afec in listaafectacion"
                            v-bind:key="afec.id"
                          >{{ afec.descripcion }}
                          </option>
                        </select>
                    </b-col>
                    <b-col cols="12" sm="1" md="1" lg="1" xl="1" class="mt-4">
                        <!-- <b-form-checkbox class="mt-4" v-model="descuentoglobalC">Dscto</b-form-checkbox> -->
                          Dscto
                    </b-col>
                    <b-col cols="12" sm="3" md="3" lg="3" xl="3" class="mt-4" v-if="!descuentoglobalC">
                        <b-input-group size="xs" prepend="S/."> 
                            <input :disabled='gravado'  v-model="descuentoItemMontoG"
                                    class="form-control input-requerido input-dark" />
                        </b-input-group>
                    </b-col>
                    <b-col cols="12" sm="3" md="3" lg="3" xl="3" class="mt-4" v-else >                      
                        <b-input-group size="xs" append="%">
                            <input v-model="descuentoItemPorcentajeG"
                                    class="form-control input-requerido input-dark"/>
                        </b-input-group>
                    </b-col>
                    <b-col v-if="!descuentoglobalC">
                      <p>Descuento con IGV</p>
                      <div>
                          <!-- <div>{{ moneda.simbolo }} {{descuentoItemMontoG}}</div> -->
                           <div v-for="(i, ind) in listarMontos" :key="ind" >
                              <b-row>
                                <b-col xl="" class="">
                                  <b>{{ moneda.simbolo }} {{i.monto}}</b>
                                </b-col>
                                <b-col xl="">
                                  <i @click="borrarDescuento(ind)" class=" fa fa-1x fa-times-circle text-danger cursor"></i>
                                </b-col>
                              </b-row>
                           </div>
                      </div>
                    </b-col>
                    <b-col v-else>
                      <p>Descuento con IGV</p>
                      <div>
                          <div>{{ moneda.simbolo }} {{descuentoItemPorcentajeG}}</div>
                      </div>
                    </b-col> 
                    <b-col>
                      <p>Venta Total</p>
                         <div>{{ moneda.simbolo }} {{ accumulateTotalSale()}}</div>
                    </b-col>              
                </b-row>
          </template>
          <div slot="modal-footer" class="w-100">
            <b-row>
                <b-col cols="10" >
                    <b-button @click="addDescuentosGlobales()" variant="success">
                        Guardar
                        <i class="far fa-save"></i>
                    </b-button>
                </b-col>
                <b-col cols="2" >
                      <b-button size="sm" variant="danger" @click="cerrarmodaldsctGlobal()">
                        <i class="fa fa-times"></i> Cerrar
                      </b-button>
                </b-col>
            </b-row>
          </div>
                </b-modal>
            </b-col>
            <!--FIN DESCUENTO GLOBAL-->
             <b-col cols="4">
                <b-form-select :disabled="this.items.length > 0 ? false:true" v-model="selectedRetencion" :options="optionsIgv"></b-form-select>
            </b-col>
          </b-row> 
          <br>  
          <b-row>
            <b-col>
              <div class="text-center">
                <strong>TOTALES</strong>
              </div>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="12" sm="6" md="6" lg="6" xl="6">
              <div>
                <strong>IGV:</strong>
              </div>
              <div>
                <strong>Venta Gravada:</strong>
              </div>
              <div>
                <strong>Venta Exonerada:</strong>
              </div>
              <div>
                <strong>Venta Inafecta:</strong>
              </div>
              <div>
                <strong>Venta Gratuita:</strong>
              </div>
              <div>
                <strong>Venta Exportación:</strong>
              </div>
              <div><strong>ICBPER:</strong></div>
              <div>
                <strong>Descuento Anticipos:</strong>
              </div>
              <div>
                <strong>Descuentos:</strong>
              </div>
              <div>
                <strong>Descuento Global:</strong>
              </div>
              <div>
                <strong>Otros Cargos:</strong>
              </div>
              <div>
                <strong>Venta:</strong>
              </div>
              <b-row>
                <b-col cols="12">
                  <template v-if="tipoOperacion == '1001'">
                    <hr />
                    <select class="form-control input-placedark input-dark" v-model="detraccion">
                      <option
                              v-for="detraccion in listaDeDetracciones"
                              :value="detraccion"
                              :key="detraccion.codigo"
                      >{{ detraccion.descripcion }}</option>
                    </select>
                    <br />
                  </template>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="5" sm="2" md="2" lg="2" xl="2">
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
            </b-col>
            <b-col cols="5" sm="4" md="4" lg="4" xl="4">
              <div class="alineacionTotales">{{ accumulateIgv() }}</div>
              <div
                      v-if="descuentoGlobalMonto != '' || descuentoGlobalPorcentaje != ''"
                      class="alineacionTotales"
              >{{ totalVentaGravada }}</div>
              <div v-else class="alineacionTotales">{{ accumulateRecordedSale() }}</div>
              <div class="alineacionTotales">{{ accumulateExoneratedSale() }}</div>
              <div class="alineacionTotales">{{ accumulateUnaffectedSale() }}</div>
              <div class="alineacionTotales">{{ accumulateFreeSale() }}</div>
              <div class="alineacionTotales">{{ accumulateExportSale() }}</div>
              <div class="alineacionTotales">{{ accumulateICBPER().toFixed(2) }}</div>
              <div class="alineacionTotales">{{ accumulateAnticipos() }}</div>
              <div class="alineacionTotales">{{ accumulateDescuento() }}</div>
              <div class="alineacionTotales">{{ accumulatedescuentoG() }}</div>
              <div class="alineacionTotales">{{ accumulateOtrosCargos() }}</div>
              <div class="alineacionTotales">{{ accumulateTotalSale() }}</div>
              <template v-if="tipoOperacion == '1001'">
                <hr />
                <b-row>
                  <b-col cols="4">{{ detraccion.porcentajeDetraccion }}</b-col>
                </b-row>
                <b-row>
                  <template v-if="moneda.codigo == 'USD'">
                      <b-col cols="8">S/. {{ montoDetraccionCalc() }}</b-col>
                  </template>
                  <template v-else>
                      <b-col cols="8">{{ moneda.simbolo }} {{ montoDetraccionCalc() }}</b-col>
                  </template>
                </b-row>
              </template>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <template v-if="tipoOperacion == '1001'">
                <b-alert show variant="info">
                  <b-row>
                    <b-col cols="6">Cuenta de Detraccioneszz:</b-col>
                    <b-col cols="6">
                      <template v-if="cuentaDetracionAdmin != ''">
                        <b-col cols="12">
                          <template v-if="cuentaDetracionAdmin != ''">{{ cuentaDetracionAdmin }}</template>
                          <template
                                  v-else
                          >No existe cuenta de detracción, registrelo en Administrador/Perfil</template>
                        </b-col>
                      </template>
                      <template v-else>
                        Cargando
                        <i class="fa fa-spin fa-spinner"></i>
                      </template>
                    </b-col>
                  </b-row>
                </b-alert>
              </template>
            </b-col>
          </b-row>
          <br />
          <b-row>
              <b-col cols="6" md="6">
                <b-button v-if="check" disabled class="btn btn-seconday">
                   Emitiendo... <i class="fa fa-spin fa-spinner"></i>
                </b-button>
                <b-button
                        v-else
                        variant="success"
                        :disabled="!validateInvoice()"
                        @click.prevent="modalEmision">
                   Emitir Directo <i class="fa fa-location-arrow"></i>
                </b-button>
              </b-col>
            <b-col cols="4" md="4">
              <template v-if="previsualizar">
                 <span class="d-inline-block" tabindex="0" v-b-tooltip.top title="Elegir forma de Pago">
                <button class="btn btn-primary" :disabled="previsualizar" @click.prevent="sendPreviw(true)">
                  <i class="fa fa-search"></i> Previsualizar
                </button>
                 </span>
              </template>
              <template v-else>          
                <button class="btn btn-primary" @click.prevent="sendPreviw(true)">
                  <i class="fa fa-search"></i> Previsualizar
                </button>       
              </template>
            </b-col>
          </b-row>
        </b-col>
        <vue-snotify></vue-snotify>
      </b-row>
      <template v-if="invoicePrev.bandera">
        <modal-preview :invoicePrev="invoicePrev"></modal-preview>
        <!-- TEMPORAL************** -->
                <!-- <b-modal size="xs" v-model="modalimpresion">
                    <template slot="modal-header">
                        <div class="text-center">
                        Telemovil.global
                        </div>
                    </template>
                    <template>
                    <plantilla :impresion="dataImpresion" :printweb="printweb"></plantilla>

                    </template>
                    <template slot="modal-footer">
                        <b-row>
                            <b-col cols="4" class="pr-0" >
                                <template>
                                    <b-form-input style="border-color:black;color:black" type="number" placeholder="Num. Celular" v-model="numeroWhatsApp"  @keyup.enter="send_message()"></b-form-input>
                                </template>
                            </b-col>
                            <b-col cols="2" class="pl-0">
                                <template>
                                    <b-button title="Enviar a Whatsapp" style="border-color:black" variant="success"  @click="send_message()">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 448 512"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/></svg>
                                    </b-button>
                                </template>
                            </b-col>
                            <b-col cols="3" class="">
                                <b-button size="sm"  class="btn btn-info" @click="print()"><i class="fas fa-print"></i> Imprimir</b-button>
                            </b-col>
                            <b-col cols="3" class="">
                                <b-button size="sm" class="btn btn-success" @click="nuevaImpresion()"><i class="fas fa-plus"></i> Nuevo</b-button>
                            </b-col>
                        </b-row>
                    </template>
                </b-modal> -->
        <!-- TEMPORAL************** -->
      </template>
    </b-card>
    <!--Fin de datos de emision-->
    <!-- MODAL FORMA DE PAGO CREDITO -->
    <b-modal size="lg" v-model="modalCredito">
      <b-row class="mb-2">
        <b-col cols="2">
          <b-form-input type="number" v-b-tooltip.hover.left="'Ahora también puede ingresar su fecha de vencimiendo ingresando un número, que sumará a la fecha actual, formando su fecha vencimiento'" placeholder="Días" v-model="cantidadDias"></b-form-input>
        </b-col>
        <b-col cols="4">
          <datepicker class="input-placedark input-dark"
            v-model="fechaPagoCuota"
            :language="es"
            :format="customFormatter"
            :bootstrap-styling="true"
            :disabledDates="diasnopermitidosCredito"
            placeholder="Cronograma de pago"
          ></datepicker>
        </b-col>
        <b-col cols="4">
          <b-input class="text-center"
            type="number"
            v-model="montoPagoCuota"
            @keyup.enter='addcuota()'
            placeholder="Monto cuota"
          ></b-input>
        </b-col>
        <b-col cols="1">
          <b-button class="mt-1" variant="primary" size="sm" v-model="idencredito" :disabled="validarcredito" @click="addcuota()"><i class="fas fa-plus"></i></b-button>
        </b-col>
      </b-row>
      <template slot="modal-header">
            <div style="width:20%">
               <h4>Cuotas Crédito</h4>
            </div>   
            <div style="text-align:right;width:20%">
              <h4>Total Factura:</h4>
            </div>
            <div style="width:20%">
              <h4 style="color:red">{{ moneda.simbolo }}{{importeTotal.toFixed(2)}}</h4>
            </div>
          <template>
            <div style="text-align:right;width:20%">
              <h4>Total Neto:</h4>
            </div>
            <div style="width:20%">
              <h4 v-if="importeTotal !='' || montoDetraccion !='' || retencionIgvCredito !='' " style="color:red">{{ moneda.simbolo }}{{(importeTotal.toFixed(2) -  montoDetraccion - retencionIgvCredito).toFixed(2)}}</h4>
            </div>
          </template>
      </template>
     <b-table
     :outlined="outlined"
      small   
      :items="cuotasCredito" 
      :fields="cuotas_credito">
      <template slot="acciones" slot-scope="row">
          <b-button variant="outline-danger" style="border:none"  size="sm" @click="deletecuota(row.index)"><i class="fas fa-trash"></i></b-button>
      </template>
     </b-table>
     <template>
       <div slot="modal-footer" class="w-100">
         <b-row>
         <b-col cols="12" sm="12" md="10" lg="10" xl="10" >  
           <div style="color:">
             <h5>Total Crédito : {{totalcredito}}</h5>
           </div>
         </b-col>
         <b-col cols="12" sm="12" md="2" lg="2" xl="2">
           <b-button variant="primary" @click="modalcredito()">Cerrar</b-button>
         </b-col>
       </b-row>
       </div> 
      </template>
    </b-modal>
    <!-- FIN MODAL FORMA DE PAGO CREDITO -->
    <b-modal v-model="modalSustentaGastos" title="Ventana Informativa">
      Para este tipo de factura tenga en cuenta: <br>
      <b>1.</b> El tipo de documento debe ser <b>RUC 10</b><br>
      <b>2.</b> Debe llevar Código Sunat <b>84121901</b> ó <b>80131501</b><br><br>
      Puede consultar los códigos Sunat en: <b-link href="http://cps.facturaonline.pe/" target="_blank" variant="primary">cps.facturaonline.pe</b-link>
      <div slot="modal-footer">
        <b-button variant="primary" @click="cerrarModalSustentosGastos()">OK</b-button>
      </div>
    </b-modal>
    <b-alert v-model="openErrorFactura">
      <error-msj :errormodal="errorFactura" :error1="error1" :error2="error2" :error3="error3" :errorJson="errorJson" @cerrarmodal="cerrarmodal"></error-msj>
    </b-alert>
  </div>
  <div v-else>
    <template slot="title">
      <h6 class="colorEmision">Emision</h6>
      <div class="separador"></div>
    </template>
    <b-card>
      <b-alert show variant="primary" class="centerpreview">
        <strong>
          <i class="fa fa-2x fa-exclamation-circle"></i>
          Vista Previa - Datos aún sin valor oficial
        </strong>
      </b-alert>
      <b-row>
        <b-col cols="12" sm="7" md="7" lg="7" xl="7">
          <em>
            <strong>Para:</strong>
          </em>
          <br />
          <b-row>
            <b-col cols="12" sm="4" md="4" lg="4" xl="3">RUC:</b-col>
            <b-col cols="12" sm="8" md="8" lg="8" xl="9">{{ receptor.numero }}</b-col>
          </b-row>
          <b-row>
            <b-col cols="12" sm="4" md="4" lg="4" xl="3">Razon Social:</b-col>
            <b-col cols="12" sm="8" md="8" lg="8" xl="9">{{ receptor.razonSocial }}</b-col>
          </b-row>
          <b-row>
            <b-col cols="12" sm="4" md="4" lg="4" xl="3">Direccion:</b-col>
            <b-col cols="12" sm="8" md="8" lg="8" xl="9">{{ receptor.direccion }}</b-col>
          </b-row>
        </b-col>
        <b-col cols="12" sm="5" md="5" lg="5" xl="5">
          <em>
            <strong>Detalles:</strong>
          </em>
          <br />
          <b-row>
            <b-col cols="12" sm="5" md="5" lg="4" xl="4">Moneda:</b-col>
            <b-col cols="12" sm="7" md="7" lg="8" xl="8">{{ moneda.descripcion }}</b-col>
          </b-row>
          <b-row>
            <b-col cols="12" sm="5" md="5" lg="4" xl="4">Condicion de Pago:</b-col>
            <b-col
                    v-if="formadepago.codigo != '000'"
                    cols="12"
                    sm="7"
                    md="7"
                    lg="8"
                    xl="8"
            >{{ formadepago.nombre }}</b-col>
          </b-row>
          <b-row>
            <b-col cols="12" sm="5" md="5" lg="4" xl="4">Fecha Emision:</b-col>
            <b-col
                    cols="12"
                    sm="7"
                    md="7"
                    lg="8"
                    xl="8"
            >{{ femision | moment('DD/MM/YYYY hh:mm:ss A') }}</b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
          <template v-if="tipoOperacion != '1004'">
            <b-table
                    responsive
                    :small="small"
                    :items="items"
                    :fields="items_fields"
                    :outlined="outlined"
            >
              <template slot="index" slot-scope="row">
                  <template v-if="row.item.idProducto !='-' && row.item.idProducto !=''">
                    <i title="contiene idProducto" style="color:lightgreen" class="fas fa-check"></i>
                  </template> 
                {{ row.index +1 }}
              </template>
              <template slot="precioUni" slot-scope="row">
                {{row.item.adicional.precioVentaUni}}
              </template>
              <template slot="descuentoUni" slot-scope="row">
                <template v-if="row.item.adicional.indicardorDsct == '01'">
                  S/ {{row.item.adicional.dsctSoles}}
                </template>
                <template v-else-if="row.item.adicional.indicardorDsct == '02'">
                  {{row.item.adicional.dsctPorcentaje}}%
                </template>
                <template v-else>
                  {{0.00}}
                </template >
              </template>
              <template slot="precioT" slot-scope="row">
                <template v-if="row.item.adicional && row.item.adicional.precioVentaUni && row.item.adicional.precioVentaUni !=''">
                  <!-- {{(parseFloat(row.item.cantidad) * row.item.adicional.precioVentaUni).toFixed(2)}} -->
                  {{(row.item.montoTotalImpuestosItem + row.item.valorVenta).toFixed(2)}}
                </template>
                <template v-else>
                  {{row.item.montoTotalImpuestosItem + row.item.valorVenta}}
                </template> 
              </template>
            </b-table>
          </template>
          <template v-else-if="tipoOperacion == '1004'">
            <table class="table table-bordered table-sm">
              <thead>
              <tr>
                <th width="10%">Cantidad</th>
                <th width="50%">Descripcion</th>
                <th width="10%">{{ itemTitleSubtotal }}</th>
                <th width="10%">Igv</th>
                <th width="10%">{{ itemTitleTotal }}</th>
              </tr>
              </thead>
            </table>
            <table class="table table-borderless table-sm">
              <tbody v-for="(item, index) in items" :key="index">
              <tr>
                <td width="10%">{{ item.cantidad }}</td>
                <td width="50%">{{ item.descripcion }}</td>
                <td width="10%">{{ item.valorUnitario }}</td>
                <td width="10%">{{ item.montoAfectacionIgv }}</td>
                <td width="10%">{{ item.valorVenta }}</td>
              </tr>
              <tr>
                <td>Ubigeo Origen:</td>
                <td>{{ item.adicional.servicioTransporteCarga.ubigeoOrigen }}</td>
              </tr>
              <tr>
                <td>Direccion Origen:</td>
                <td>{{ item.adicional.servicioTransporteCarga.direccionOrigen }}</td>
              </tr>
              <tr>
                <td>Ubigeo Destino:</td>
                <td>{{ item.adicional.servicioTransporteCarga.ubigeoDestino }}</td>
              </tr>
              <tr>
                <td>Direccion Destino:</td>
                <td>{{ item.adicional.servicioTransporteCarga.direccionDestino }}</td>
              </tr>
              <tr>
                <td>Detalle Viaje:</td>
                <td>{{ item.adicional.servicioTransporteCarga.detalleViaje }}</td>
              </tr>
              <tr>
                <td>Valor referencial sericio Transporte:</td>
                <td>{{ item.adicional.servicioTransporteCarga.valorReferencialServicioTransporte }}</td>
              </tr>
              <tr>
                <td>Valor referencial servicio carga activa:</td>
                <td>{{ item.adicional.servicioTransporteCarga.valorReferencialCargaActiva }}</td>
              </tr>
              <tr>
                <td>Valor referencial servicio carga util:</td>
                <td>{{ item.adicional.servicioTransporteCarga.valorReferencialCargaUtil }}</td>
              </tr>
              <tr>
                <td>
                  <strong>Detalle tramos</strong>
                </td>
              </tr>
              <tr v-for="tramo in item.adicional.servicioTransporteCarga.detalleTramos">
                <td></td>
                <td>
              <tr>
                <td></td>
                <td>Punto origen:</td>
                <td colspan="2">{{ tramo.puntoOrigenViaje }}</td>
              </tr>
              <tr>
                <td></td>
                <td>Punto Destino:</td>
                <td colspan="2">{{ tramo.puntoDestinoViaje }}</td>
              </tr>
              <tr>
                <td></td>
                <td>Descripcion Tramo:</td>
                <td colspan="2">{{ tramo.descripcionTramo }}</td>
              </tr>
              <tr>
                <td></td>
                <td>Monto referencial preliminar:</td>
                <td colspan="2">{{ tramo.montoReferencialPreliminar }}</td>
              </tr>
              <tr>
                <td></td>
                <td>Configuracion vehicular:</td>
                <td colspan="2">{{ tramo.configuracionVehicular }}</td>
              </tr>
              <tr>
                <td></td>
                <td>Carga util vehiculo:</td>
                <td colspan="2">{{ tramo.cargaUtilTmVehiculo }}</td>
              </tr>
              <tr>
                <td></td>
                <td>Carga efectiva vehiculo:</td>
                <td colspan="2">{{ tramo.cargaEfectivaTmVehiculo }}</td>
              </tr>
              <tr>
                <td></td>
                <td>Valor referencial por tramo:</td>
                <td colspan="2">{{ tramo.valorReferencialPorTm }}</td>
              </tr>
              <tr>
                <td></td>
                <td>Valor preliminar carga util:</td>
                <td colspan="2">{{ tramo.valorPreliminarCargaUtil }}</td>
              </tr>
              </td>
              </tr>
              </tbody>
            </table>
          </template>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" sm="12" md="12" lg="6" xl="8">
          <em>
            <strong>Informacion Adicional</strong>
          </em>
          <br />
          <br />
          <b-row>
            <b-col cols="12" sm="12" md="12" lg="12" xl="12">
              <b-alert show variant="success">
                <b-row>
                  <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                    <strong>Extras:</strong>
                  </b-col>
                  <b-col v-if="ordenCompra != ''" cols="12" sm="12" md="12" lg="12" xl="12">
                    Orden de Compra: {{ ordenCompra }}
                    <br />
                  </b-col>
                  <b-col v-if="fvencimiento != ''" cols="12" sm="12" md="12" lg="12" xl="12">
                    Fecha de Vencimiento: {{ fvencimiento | moment('DD/MM/YYYY hh:mm:ss A') }}
                    <br />
                  </b-col>
                </b-row>
              </b-alert>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" sm="12" md="12" lg="12" xl="12">
              <b-alert show variant="success">
                <b-row>
                  <b-col cols="12" sm="12" md="12" lg="12" xl="6">
                    <strong>Guias Relacionadas:</strong>
                  </b-col>
                  <b-col cols="12" sm="12" md="12" lg="12" xl="6">
                    <ul>
                      <li
                              class="lianticipo"
                              v-for="item in items_guias"
                      >{{ item.serie }} - {{ item.numero }}</li>
                    </ul>
                  </b-col>
                </b-row>
              </b-alert>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" sm="12" md="12" lg="12" xl="12">
              <b-alert show variant="success">
                <b-row>
                  <b-col cols="12" sm="12" md="12" lg="12" xl="6">
                    <strong>Documentos Relacionados:</strong>
                  </b-col>
                  <b-col cols="12" sm="12" md="12" lg="12" xl="6">
                    <ul>
                      <li
                              class="lianticipo"
                              v-for="item in items_relacionados"
                      >{{ item.numerorelacionado }} - {{ item.tipoRelacionadoDescripcion }}</li>
                    </ul>
                  </b-col>
                </b-row>
              </b-alert>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" sm="12" md="12" lg="12" xl="12">
              <b-alert show variant="success">
                <b-row>
                  <b-col cols="12" sm="12" md="12" lg="12" xl="6">
                    <strong>Datos Adicionales:</strong>
                  </b-col>
                  <b-col cols="12" sm="12" md="12" lg="12" xl="6">
                    <ul>
                      <li
                              class="lianticipo"
                              v-for="item in items_adicionales"
                      >{{ item.key }} - {{ item.value }}</li>
                    </ul>
                  </b-col>
                </b-row>
              </b-alert>
            </b-col>
          </b-row>
          <b-row v-if="selectedAnticipos.length > 0">
            <b-col cols="12" sm="12" md="12" lg="12" xl="12">
              <b-alert show variant="success">
                <b-row>
                  <b-col cols="12" sm="12" md="12" lg="12" xl="6">
                    <strong>Regularizacion de Anticipos:</strong>
                  </b-col>
                  <b-col cols="12" sm="12" md="12" lg="12" xl="6">
                    <ul>
                      <li
                              class="lianticipo"
                              v-for="item in selectedAnticipos"
                      >{{ item.serieNumero }} Regulariza {{ moneda.simbolo }} {{ item.montoAnticipado }}</li>
                    </ul>
                  </b-col>
                </b-row>
              </b-alert>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" sm="12" md="12" lg="6" xl="4">
          <b-row>
            <b-col>
              <div class="text-center">
                <strong>TOTALES</strong>
              </div>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="6" sm="6" md="6" lg="6" xl="6">
              <div>
                <strong>IGV:</strong>
              </div>
              <div>
                <strong>Venta Gravada:</strong>
              </div>
              <div>
                <strong>Venta Exonerada:</strong>
              </div>
              <div>
                <strong>Venta Inafecta:</strong>
              </div>
              <div>
                <strong>Venta Gratuita:</strong>
              </div>
              <div>
                <strong>Venta Exportación:</strong>
              </div>
              <div><strong>ICBPER:</strong></div>
              <div>
                <strong>Descuento Anticipos:</strong>
              </div>
              <div>
                <strong>Descuentos:</strong>
              </div>
              <div>
                <strong>Descuento Global:</strong>
              </div>
              <div>
                <strong>Cargos:</strong>
              </div>
              <div>
                <strong>Venta:</strong>
              </div>
              <b-row>
                <b-col cols="12">
                  <template v-if="tipoOperacion == '1001'">
                    <hr />
                    <select class="form-control input-placedark input-dark" v-model="detraccion">
                      <option
                              v-for="detraccion in listaDeDetracciones"
                              :value="detraccion"
                              :key="detraccion.codigo"
                      >{{ detraccion.descripcion }}</option>
                    </select>
                    <br />
                  </template>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="2" sm="2" md="2" lg="2" xl="2">
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
              <div>{{ moneda.simbolo }}</div>
            </b-col>
            <b-col cols="4" sm="4" md="4" lg="4" xl="4">
              <div class="alineacionTotales">{{ accumulateIgv() }}</div>
              <div
                      v-if="descuentoGlobalMonto != '' || descuentoGlobalPorcentaje != ''"
                      class="alineacionTotales"
              >{{ totalVentaGravada }}</div>
              <div v-else class="alineacionTotales">{{ accumulateRecordedSale() }}</div>
              <div class="alineacionTotales">{{ accumulateExoneratedSale() }}</div>
              <div class="alineacionTotales">{{ accumulateUnaffectedSale() }}</div>
              <div class="alineacionTotales">{{ accumulateFreeSale() }}</div>
              <div class="alineacionTotales">{{ accumulateExportSale() }}</div>
              <div class="alineacionTotales">{{ accumulateICBPER().toFixed(2) }}</div>
              <div class="alineacionTotales">{{ accumulateAnticipos() }}</div>
              <div class="alineacionTotales">{{ accumulateDescuento() }}</div>
              <div class="alineacionTotales">{{ accumulatedescuentoG() }}</div>
              <div class="alineacionTotales">{{ accumulateOtrosCargos() }}</div>
              <div class="alineacionTotales">
                <strong>{{ accumulateTotalSale() }}</strong>
              </div>
              <template v-if="tipoOperacion == '1001'">
                <hr />
                <b-row>
                  <b-col cols="4">{{ detraccion.porcentajeDetraccion }}</b-col>
                </b-row>
                <b-row>
                 <template v-if="moneda.codigo == 'USD'">
                      <b-col cols="8">S/. {{ montoDetraccionCalc() }}</b-col>
                  </template>
                  <template v-else>
                      <b-col cols="8">{{ moneda.simbolo }} {{ montoDetraccionCalc() }}</b-col>
                  </template>
                </b-row>
              </template>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <template v-if="tipoOperacion == '1001'">
                <b-alert show variant="info">
                  <b-row>
                    <b-col cols="6">Cuenta de Detracciones:</b-col>
                    <b-col cols="6">
                      <template v-if="cuentaDetracionAdmin != ''">
                        <b-col cols="12">
                          <template v-if="cuentaDetracionAdmin != ''">{{ cuentaDetracionAdmin }}</template>
                          <template
                                  v-else
                          >No existe cuenta de detracción, registrelo en Administrador/Perfil</template>
                        </b-col>
                      </template>
                      <template v-else>
                        Cargando
                        <i class="fa fa-spin fa-spinner"></i>
                      </template>
                    </b-col>
                  </b-row>
                </b-alert>
              </template>
            </b-col>
          </b-row>
          <br />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4" sm="6" md="8" lg="8" xl="8"></b-col>
        <b-col cols="4" sm="3" md="2" lg="2" xl="2">
          <b-button v-if="check" class="btn btn-seconday botonesemitir">
            <i class="fa fa-spin fa-spinner"></i> Emitiendo...
          </b-button>
          <b-button
                  v-else
                  class="botonesemitir"
                  variant="primary"
                  :disabled="!validateInvoice()"
                  @click.prevent="sendInvoice"
          >
            <i class="fa fa-location-arrow"></i> Emitir
          </b-button>
        </b-col>
        <b-col cols="4" sm="3" md="2" lg="2" xl="2">
          <template>
            <b-button class="btn btn-danger botonesemitir" @click="sendPreviw(false)">
              <i class="fa fa-arrow-circle-left"></i> Atras
            </b-button>
          </template>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
  import { Switch as cSwitch } from "@coreui/vue";
  import axios from "axios";
  import download from "downloadjs";
  import Datepicker from "vuejs-datepicker";
  import { es } from "vuejs-datepicker/dist/locale";
  import vSelect from "vue-select";
  import AdicionalesDetraccionCarga from "@/components/factura/complementos/AdicionalesDetraccionCarga";
  import { UnidadMedida } from "@/shared/utils";
  import { TipoAfectacion } from "@/shared/utils";
  import { EspecificacionIgvTipo1 } from "@/shared/utils";
  import { EspecificacionIgvTipo2 } from "@/shared/utils";
  import { EspecificacionIgvTipo3 } from "@/shared/utils";
  import { listaDetraciones } from "@/shared/utils";
  import { ListaOperacionF } from "@/shared/utils";
  import { incoterm } from "@/shared/utils";
  import { FormaPagoCuentasCobrar } from "@/shared/utils";
  import { TipoMoneda } from "@/shared/utils";
  import { DocumentosIdentidadExtrangeros } from "@/shared/utils";
  import { tipoDocumentosRelaciondos } from "@/shared/utils";
  import ModalPreview from "@/components/factura/complementos/ModalPreview";
  import { tasaicbper } from "@/services/funciones";
  import { BFormFile } from "bootstrap-vue";
  import Import from '@/components/comunes/pImportItems';
  import MasivaGuia from '@/components/comunes/MasivaGuia'
  import { XlsxRead, XlsxJson, XlsxTable } from "vue-xlsx/dist/vue-xlsx.es.js";
  import ErrorMsj from '@/components/comunes/Errormsj'
  import Swal from 'sweetalert2'
  import Plantilla from '@/components/comunes/PlantillaImpresionTemporal'
  import EnviarComprobantes from '@/components/comunes/EnviarComprobantes'
  import { Departamentos } from '@/shared/utils'
  import { PulseLoader } from 'vue-spinner/dist/vue-spinner.min.js'
  export default {
    name: "FacturaEmision",
    props: ["emisionrapida","emisionrapidaGravada","emisionrapidaIgv"],
    components: {
      Datepicker,
      vSelect,
      AdicionalesDetraccionCarga,
      cSwitch,
      ModalPreview,
      XlsxRead,
      XlsxJson,
      XlsxTable,
      Import,
      BFormFile,
      MasivaGuia,
      ErrorMsj,
      Plantilla,
      EnviarComprobantes,
      PulseLoader
      
    },
    data: () => {
      return {
        //temporal
          dataImpresion: {},
          printweb: false,
          modalimpresion: false,
          numeroWhatsApp:'',      
        //temporal
        timer: null,
        timerCod: null,
        nuevaBusqueda:false,
        montoValorUnitario2:'',
        montoIgvGlobal:'',
        inafecto:'',
        descuentoglobalC:false,
        descuentoItemMontoG:'',
        descuentoItemPorcentajeG:'',
        descuentoglobalM:false,
        valorDesctGlobal:'',
        valorGlobal:'',
        cargosDescuentosGlobales:[],
        muestra:'',
        valGrabadaAnticipos:'',
        valDescuentoGlobal:'',
        sumatoriaOtrosCargos: 0,
        sumatoriaOtrosCargosProducto:0,
        guardandootroscargos: true,
        otroscargosmodal: false,    
        otroCargo: {
          codigo: "50",
          descripcion:
                  "Cargos globales que no afectan la base imponible del IGV/IVAP"
        },
        listaOtrosCargos: [
          {
            codigo: "50",
            descripcion:
                    "Cargos globales que no afectan la base imponible del IGV/IVAP"
          }
        ],
        listaOtrosCargosAgregados: [],
        otrosCargosProductoAgregados:[],
        otroscargos_fields: [
          { key: "descripcion", label: "Descripcion", sortable: true },
          { key: "montoCargo", label: "Monto", sortable: true },
          // {key: 'montoBaseCargo', label: 'Base', sortable: true},
          { key: "acciones", label: "Acciones" }
        ],
        otroscargosbusy: false,
        montoOtroCargo: "",
        montoOtroCargo2:"",
        sinresultados: false,
        listaCorreos: [],
        invoicePrev: {
          data: "",
          bandera: false
        },
        buttonRegularizacionAnticipos: true,
        disabledAnticipo: false,
        totalAnticipos: 0.0,
        cargandoAnticipoByRuc: false,
        receptorAnticipo: "",
        anticipos: [],
        rucCliente: "",
        razon_social: "",
        modalCliente: false,
        modalClienteCargando:false,
        rucNoEncontrado:false,
        modalAnticipos: false,
        updateClienteDatos: false,
        itemsDetraccionCheck: false,
        validateExportacion: false,
        cargandoAnticipos: false,
        adicionalDetraccion: {
          servicioTransporteCarga: {
            ubigeoOrigen: "",
            direccionOrigen: "",
            ubigeoDestino: "",
            direccionDestino: "",
            detalleViaje: "",
            valorReferencialServicioTransporte: 0,
            valorReferencialCargaActiva: 0,
            valorReferencialCargaUtil: 0,
            detalleTramos: []
          }
        },
        viewEmisionRapida: false,
        documentosRelacionados: [],
        listaDocRelacionados: tipoDocumentosRelaciondos,
        numerorelacionado: "",
        contingencia: false,
        labelTxt: {
          dataOn: "Si",
          dataOff: "No"
        },
        anticipo: false,
        show: true,
        switchAnticipo: false,
        detraccionCarga: false,
        previwEmit: true,
        disabledGratuita: false,
        totalDescuentosAcumulados: "",
        headers: [],
        itemsPlus: [],
        total: 0.0,
        desde: 0.0,
        hasta: 0.0,
        filter: null,
        sortBy: null,
        sortDesc: false,
        sortDirection: "asc",
        currentPage: 1,
        totalRows: null,
        documentosIdentidadExtrangeros: DocumentosIdentidadExtrangeros,
        tipoDocumentoExtrangeros: "0",
        cuentaDetracionAdmin: "",
        detraccion: {
          codigo: "000",
          descripcion: "Seleccionar tipo detraccion",
          porcentajeDetraccion: "0%"
        },
        montoDetraccion: "",
        listaDeDetracciones: listaDetraciones,
        indexSerie: 0,
        seriesCargadas: true,
        newSerie: true,
        rolSeries: "",
        listaSeries: [],
        // listaSeriesLocal:[],
        montoDescuento: "",
        porcentajeDescuento: "",
        valorVenta: "",
        otrosCargos: 0,
        descuentoGlobalMonto: "",
        descuentoGlobalPorcentaje: "",
        descuentoItemMonto: "",
        descuentoItemPorcentaje: "",
        checkedDsctoGlobal: true,
        setIndex: -1,
        setUpdateItem: false,
        listaafectacion: TipoAfectacion,
        EspecificacionIgv: EspecificacionIgvTipo1,
        EspecificacionIgv2: EspecificacionIgvTipo2,
        EspecificacionIgv3: EspecificacionIgvTipo3,
        unidades: UnidadMedida,
        placeholdercodigo: "C. Sunat",
        cargandoreceptor: false,
        listarec: true,
        norec: false,
        listaproductcode: false,
        listabarcodesunat: true,
        listades: true,
        listaProductCod:true,
        nodescription: false,
        noProductCode: false,
        noBarCodeSunat: false,
        listarecProductCode: false,
        invoice: {
          monedero:"",
          nombreMonedero:"",
          sumatoriaIsc:0.0,
          totalValorVenta :0.0,
          totalPrecioVenta :0.0,
          cargosDescuentosGlobales:[],
          email: [],
          tipoOperacion: "",
          serie: "",
          montoTotalImpuestos: 0.0,
          // totalVentaGravada: 0.0,
          totalVentaExonerada: 0.0,
          sumatoriaIgv: 0.0,
          importeTotal: 0.0,
          adicional: {
            totalAnticipos: 0.0,
            anticipos: {},
            totalDescuentoItem: "",
            extras: [],
            // credito:[],
            descuentoGlobal: {
              codigoMotivoDescuento: "",
              factorNumericoDescuento: 0.0,
              montoDescuento: 0.0,
              montoBaseDescuento: 0.0
            },
            detraccion: {
              codigoSujetoDetraccion: "",
              numeroCuentaBanco: "",
              medioPago: "",
              montoDetraccion: "",
              porcentajeDetraccion: ""
            },
            dirAlternativa: "",
            tipo_igv:''
          },
          guiasRelacionada: [],
          docRelacionada: [],
          items: [],
          receptor: {
            tipo: "",
            nro: "",
            razonSocial: "",
            direccionFiscal: ""
          }
        },
        moneda: {
          id: "1",
          codigo: "PEN",
          descripcion: "SOLES",
          simbolo: "S/."
        },
        largeModal: false,
        tipoOperacion: "0101",
        serie: "",
        seriecon: "",
        montoTotalImpuestos: 0.0,
        totalVentaInafecta: 0.0,
        totalVentaExonerada: 0.0,
        totalVentaExportacion: 0.0,
        totalVentaExportacion2: 0.0,
        totalVentaGravada: 0.0,
        sumatoriaIgv: 0.0,
        importeTotal: 0.0,
        sumatoriaIgvGratuitas: 0.0,
        Especificacion: [],
        especificacionIgv: "01",
        adicional: {
          serieGuia: "",
          numeroGuia: "",
          tipoGuia: "",
          fechaVencimiento: "",
          codigoSunatEstablecimiento: "A000",
          dirAlternativa: ""
        },
        receptor: {
          numero: "",
          tipo: "6",
          razonSocial: "",
          direccion: ""
        },
        unidadMedidaCantidad: "NIU",
        tipoAfectacionIgv: "01",
        cantidad: 1,
        descripcion: "",
        precioVentaUnitario: "",
        valorUnitario: "",
        flagPrecio: false,
        flagValor: false,
        flagCantidad: false,
        flagDescripcion: false,
        tipoIgv: "01",
        vunitario: false,
        vbarras: false,
        servicio: false,
        ventaGratuita: false,
        icbper: false,
        descuento: false,
        cargando: false,
        cargandopdf: false,
        cargandopdf2: false,
        cargandocdr: false,
        itemValid: false,
        tipoAfecIgv: false,
        isc:false,
        sumatoriaIsc:0.00,
        montoISC:'',
        items: [],
        items_fields: [
          // { key: "tieneID",label:''},
          { key: "index", label: "N°" },
          { key: "cantidad", label: "Cant", sortable: true },
          {key: 'descripcion', label: 'Descripción', sortable: true},
          { key: "stock", label: "Stock", sortable: true },
          { key: "precioUni", label: "P. Unit", sortable: true },
          // { key: "descuento", label: "Descuento", sortable: true },
          { key: "descuentoUni", label: "Desct.", sortable: true },
          { key: "valorVentaVista", label: "Valor Total", sortable: true },
          { key: "montoTotalImpuestosItem", label: "Igv", sortable: true },
          { key: "precioT",label:"Precio Total"},
          { key: "acciones", label: "Acciones", sortable: true },
          { key: "muestraIgv", label: "", sortable: true }     
        ],
        emisor: {
          ruc: "",
          razonSocial: "",
          serie: ""
        },
        cliente: {
          ruc: "",
          razonSocial: ""
        },
        ruc: "",
        listaReceptores: [],
        listaProductCode: [],
        listaProductCodeScaner: [],
        listaBarCodeSunat: [],
        listaDescription: [],
        cargandoCodBarras: false,
        cargandoBarrasSunat: false,
        cargandoDescription: false,
        es: es,
        adicionales: [],
        nombre: "",
        valor: "",
        total: "",
        editarbtn: true,
        eliminarbtn: false,
        selectedAnticipos: [],
        docAnticipos: [],
        docAnticipos_fields: [
          { key: "serie", label: "Serie", sorteable: true },
          { key: "numero", label: "Numero", sorteable: true },
          { key: "idReceptor", label: "RUC", sorteable: true },
          { key: "razonSocial", label: "Razon Social", sorteable: true },
          { key: "tipoAfectacion", label: "Afectacion", sorteable: true },
          {
            key: "montoRegularizar",
            label: "Saldo por Regularizar",
            sorteable: true
          },
          { key: "monto", label: "Monto a Aplicar", sorteable: true },
          { key: "agregar", label: "Agregar", sorteable: true }
        ],
        invoices: [],
        invoices_fields: [
          { key: "serie", label: "Serie", sorteable: true },
          { key: "numero", label: "Numero", sorteable: true },
          { key: "emision", label: "Emisión", sorteable: true },
          { key: "receptor", label: "Receptor", sorteable: true },
          { key: "moneda", label: "Importe Total", sorteable: true },
          { key: "estado", label: "Estado", sorteable: true },
          { key: "acciones", label: "Acciones" }
        ],
        pactual: 1,
        limite: 10,
        limiteGuia:20,
        orden: "desc",
        total: 0,
        correos: "",
        pdfobject: "",
        recipients: "",
        desde: "",
        hasta: "",
        check: false,
        cargandoadicionales: true,
        cargandorelacionadas: true,
        femision: "",
        fvencimiento: "",
        items_relacionados: [],
        fields_relacionados: [
          { key: "numerorelacionado", label: "Numero", sortable: true },
          { key: "tipoRelacionadoDescripcion", label: "Tipo", sortable: true },
          { key: "acciones", label: "Acciones", sortable: true }
        ],
        items_guias: [],
        fields_guias: [
          { key: "serie", label: "Serie", sorteble: true },
          { key: "numero", label: "Numero", sortable: true },
          { key: "tipoGuia2", label: "Tipo", sortable: true },
          { key: "acciones", label: "Acciones", sortable: true }
        ],
        items_adicionales: [],
        fields_adicionales: [
          { key: "key", label: "Clave", sortable: true },
          { key: "value", label: "Valor", sortable: true },
          { key: "acciones", label: "Acciones", sortable: true }
        ],
        key: "",
        value: "",
        cargandoadicional: false,
        striped: true,
        small: true,
        outlined: true,
        add_update_item: true,
        info: null,
        listadeoperaciones: ListaOperacionF,
        formaPago: FormaPagoCuentasCobrar,
        tipoMoneda: TipoMoneda,
        itemTitleSubtotal: "Valor Unitario",
        itemTitleTotal: "Valor Total",
        formadepago: {
          codigo: '008',
          nombre: "Efectivo ventas menores"
        },
        valorUnitario: "",
        especificacion: {
          codigo: "10",
          descripcion: "Operacion onerosa",
          codigoTributo: "1000"
        },
        codigoTributo: "",
        itemGuia: {
          numero: "",
          tipo: ""
        },
        itemRelacionado: {
          numero: "",
          tipo: ""
        },
        itemAdicional: {
          key: "",
          value: ""
        },
        guiasRelacionada: [],
        docRelacionada: [],
        tiposGuia: [
          {
            codigo: "09",
            nombre: "Guia Remision Remitente"
          },
          {
            codigo: "31",
            nombre: "Guia Remision Transportista"
          }
        ],
        seriedeguia: "",
        numerodeguia: "",
        tipodeguia: "09",
        docRelacionado: "99",
        tipodeguiadescripcion: "",
        tipoRelacionadoDescripcion: "",
        selected: 1,
        options: [
          { value: 1, text: "Factura Comercial" },
          { value: 2, text: "Factura Contingencia" }
        ],
        selectedISC: 0,
        optionsISC: [
          { value: 0, text: 'Opciones ISC' },
          { value: 1, text: 'Valor Venta %' },
          { value: 2, text: 'Monto Específico' },
          { value: 3, text: 'Precio Sugerido' },
        ],
        ordenCompra: "",
        typeInvoice: 1,
        direcciones: [],
        verDirecciones: false,
        checkvalorunitario: false,
        idProducto: "-",
        codigoProducto: "",
        codigoSunatBarras: "",
        checkcantidad: false,
        responsecheckcantidad: "",
        checkcodigo: false,
        responsecheckcodigo: "",
        checkdescripcion: false,
        responsecheckdescripcion: "",
        checkserie: false,
        serie_valida: "",
        responsecheckserie: "",
        checkseriecon: false,
        responsecheckseriecon: "",
        checkprecioventaunitario: false,
        util: "",
        numero: "",
        name: "",
        currentdate: "",
        tipodoc: "1",
        diasnopermitidos: {
          ranges: []
        },
        diasnopermitidosCredito: {
          ranges: []
        },
        tipoguialock: false,
        docrelacionadolock: false,
        rucValid: null,
        validadorseries: 0,
        bufferProforma: {},
        bufferOrdenpago: {},
        doc:null,
        file:null,
        coleccion:[],
        item:[],
        itemsEX:[],
        action: {
          i: false,
          reset: false
        },
        accion:{
          i:false,
          reset:false
        },
        listarMontos:[],
        gravado: false,
        totalVentaExonerada2:0.0,
        totalVentaInafecta2:0.0,
        idOrdenPago:'',
        searchItems:false,
        mostrarListaProduc:false,
        ListProductos:[],
        List_Productos:[
            { key: "codigo", label:"codigo", sortable:true},
            { key: "descripcion", label:"Producto", sortable:true},
            { key: "precioUnitario", label:"P.Venta", sortable:true},
            { key: "precioCosto", label:"P.Costo", sortable:true},
            { key: "stock", label:"Stock", sortable:true},
            { key: "cantidad", label:"Cantidad", sortable:true},
            { key: "accion", label:""}
        ],
        stock:'',
        subirItems:false,
        itemsModal:[],
        valorAnticipo:'',
        guiasdoc:null,
        guiasmasiva:[],
        pasandoGuias:[],
        saveAnticipos:[],
        ructen:true,
        openErrorFactura:false,
        errorFactura:false,
        error1:'',
        error2:'',
        error3:'',
        modalCredito:false,
        cuotasCredito:[],
        cuotas_credito:[
          {key:'identificadorCuota',label:'Cuotas'},
          {key:'fechaPagoCuota', label:'Fecha Vencimiento'},
          {key:'montoPagoCuota', label:'Monto',},      
          {key:'acciones', label:'Eliminar'}
        ],
        totalcredito:0.0,
        fechaPagoCuota:'',
        montoPagoCuota:'',
        num:0,
        validarcredito:true,
        idencredito:'',
        previsualizar:false,
        totalcuotas:0.0,
        codigoProductoGs1:'',
        totaldetraccion:0.00,
        cotributo:0.00,
        editarAdicionales:{},
        modalEditarAdicionales:false,
        editarConFacturaRapida:false,
        iscCodigo:'',
        valorUniSinIsC:'',
        cuadroISC:false,
        flechaISC:false,
        porcentajeISC:'',
        valorSugerido:'',
        selectedRetencion: null,
        optionsIgv: [
          { value: null, text: 'Afecto a Retención' },
          { value: 1, text: '3%' },
          { value: 2, text: '6%' },
        ],
        incoterms:incoterm,
        incotermExporta:{
          tipo:"4",
          name:"FOB"
        },
        retencionIgvCredito:'',
        tipocambiomonedadolar:{},
        totalsumadetraccion:'',
        modalSustentaGastos:false,
        cantidadDias:'',
        numdiaspermitidos:'',
        otrosCargosProducto:'',
        sumaCargoDescuentoItem:'',
        unoDieciocho:1.18,
        ceroDieciocho:0.18,
        dieciocho:18,
        // unoUno:1.1,
        // ceroUno:0.1,
        // diez:10,
        unoUno:1.105,
        ceroUno:0.105,
        diez:10.5,
        igvGlobal:null,
        monederoPago:'',
        colorPago1:false,
        colorPago2:false,
        colorPago3:false,
        colorPago4:false,
        colorPago5:false,
        colorPago6:false,
        colorPago7:false,
        colorPago8:false,
        busquedaAlmacenada:[],
        codDescripcion:'',
        lastKeyPressed:null,
        opcionesOrdenadas: [], // Inicialmente vacío
        opcionesOrdenadasCodigo:[],
        cargandoInformacion:false,
        reciveArrayActualizado:[],
        itemEditado:false,
        editarDireccion:false,
        habilitarDireccion:false,
        errorJson:{},
        modalImportarProdGuiaR:false,
        guides: [],
        guides_fields: [
          {key: 'serie', label: 'Serie-Número', sorteable: true},
          {key: 'emision', label: 'Emisión', sorteable: true},
          {key: 'receptor', label: 'Receptor', sorteable: true},
          {key: 'estado', label: 'Estado', sorteable: true},
          {key: 'acciones', label: ''},
          {key: 'checkbox', label: 'Seleccionar'}
        ],
        listaitems_fields: [
                {key: 'index', label: 'N°', sorteable: true},
                {key: 'cantidad', label: 'Cantidad', sorteable: true},
                {key: 'descripcion', label: 'Descripcion'},
                {key: 'codigoItem', label: 'Codigo Item', sorteable: true},
            ],
        cargandoGuias:true,
        f1:'',
        f2:'',
        seleccionados: [],
        itemsFiltrados: [],
        cargandoItemGuia:false,
        totalSeleccionados:[],
        banderaPdfUsuario: false,
        previewmodal: false,
        cargandoPdf: false,
        dataFactura: {},
        scanerCodigo:false,
        tPrecioVenta:'', //solo para uso de anticipos
        aula:'',
        gradoYseccion:'',
        dniAlumno:'',
        nomApeAlumno:'',
        ubigeoOrigenDom:'',
        prependUbigeoOrigen: '',
        prependUbigeoDestino: '',
        direccionDomAlumno:'',
        direccionColegio:'',
        modalUbigeoOrigen:false,
        departamentoSeleccionadoUbigeoOrigen: '00',
        provinciaSeleccionadaUbigeoOrigen: '',
        distritoSeleccionadoUbigeoOrigen: '',
        listDepartamento: Departamentos,
        listProvinceOrigen: [],
        listDistrictOrigen: [],
        distOrigen: false,
        distOrigenCargando:  false,
        provOrigen: false,
        provOrigenCargando: false,

        departamentoSeleccionadoUbigeoDestino: '00',
        provDestino: false,
        provDestinoCargando: false,
        provinciaSeleccionadaUbigeoDestino: '',
        listProvinceDestino: [],
        listDistrictDestino: [],
        distDestino: false,
        distDestinoCargando: false,
        distritoSeleccionadoUbigeoDestino: '',
        ubigeoDestinoDom:'',
        periodoAcademido:'',
        descuentaStock:'',
        resultadoCodProducto:[],
      };      
      
    },
    mounted() {
      this.getSeries();
      this.mensaje(); 
      this.initData();
      this.initDates();
      this.datesCredito();
      this.quickEmision(); //factura rapida
      this.quickEmisionProforma();
      this.$root.$on("bv::tooltip::show", bvEventObj => {});   
      this.consultaTipoCambio();
      this.respuestaFactura();
    },
    computed: {
      state() {
        let expreg = new RegExp("^[A-Z0-9]{3}$");
        if (this.serie.length == 0) {
        } else if (!expreg.test(this.serie)) {
          return false;
        } else if (this.serie.length == 3) {
          return true;
        }
      },
      invalidFeedback() {
        let expreg = new RegExp("^[A-Z0-9]{3}$");
        if (this.serie.length == 0) {
          return "Ingresa una Serie";
        } else {
          return "Minimo 3 caracteres";
        }
      },
      validFeedback() {
        return this.state === true ? "Perfecto" : "";
      },
      stateSerieGuia() {
        let expreg = new RegExp("^[A-Z0-9]{4}$");
        let numeros = new RegExp("^[0-9]$");
        let arrayserie = this.seriedeguia.split("");
        if (arrayserie[0] == "T" || arrayserie[0] == "V" || numeros.test(arrayserie[0])) {
          if (this.seriedeguia.length == 0) {
          } else if (!expreg.test(this.seriedeguia)) {
            return false;
          } else if (this.seriedeguia.length == 4) {
            return true;
          }
        } else {
          return false;
        }
      },
      invalidFeedbackSerieGuia() {
        let expreg = new RegExp("^[A-Z0-9]{4}$");
        if (this.seriedeguia.length == 0) {
          return "Ingresa una Serie";
        } else {
          return "Minimo 4 caracteres";
        }
      },
      validFeedbackSerieGuia() {
        return this.stateSerieGuia === true ? "Perfecto" : "";
      },
      stateOrdenCompra() {
        let expreg = new RegExp("^[A-Z0-9]{1,20}$");
        if (this.ordenCompra.length == 0) {
        } else if (!expreg.test(this.ordenCompra)) {
          return false;
        } else if (this.ordenCompra.length < 20) {
          return true;
        }
      },
      invalidFeedbackOrdenCompra() {
        let expreg = new RegExp("^[A-Z0-9]{1,20}$");
        if (this.ordenCompra.length == 0) {
          return "Ingresa una Orden de Compra";
        } else {
          return "Caracter Invalido";
        }
      },
      validFeedbackOrdenCompra() {
        return this.stateOrdenCompra === true ? "OC Valida" : "";
      },
      stateReceptorNumero() {
        let expreg = new RegExp("\\s|<|>");
        if (this.receptor.numero.length == 0) {
          return false;
        } else if (expreg.test(this.receptor.numero)) {
          return false;
        } else {
          if (
                  this.receptor.numero.length > 0 &&
                  this.receptor.numero.length < 8
          ) {
            return false;
          } else {
            return true;
          }
        }
      },
      invalidFeedbackReceptorNumero() {
        if (this.receptor.numero.length == 0) {
          return "Ingresa un numero de documento";
        } else {
          return "Minimo 8 digitos, sin espacios ni <,>";
        }
      },
      validFeedbackReceptorNumero() {
        return this.stateReceptorNumero === true
                ? "Doc. Valido"
                : "Doc. Invalido";
      },
      invalidFeedbackReceptorRuc() {
        if (this.receptor.numero.length == 0) {
          return "Ingresa un numero de documento";
        } else {
          return "11 digitos, sin espacios ni <,>";
        }
      },
      validFeedbackReceptorRuc() {
        return this.stateReceptorRuc === true ? "RUC Valido" : "RUC Invalido";
      }
    },
    watch: {
      cantidadDias(){
        this.cantidadDiasAgregados();
      },
      femision(){
        let pasandofecha = this.$moment(this.femision).format("YYYY-MM-DD")
        this.consultaTipoCambio(pasandofecha)
        //fecha vencimiento credito 
        let fechaHoy = new Date()
        var fecha1 = this.$moment(fechaHoy);
        var fecha2 = this.$moment(this.femision);
        let diasDiferencia = fecha1.diff(fecha2, 'days')
        if(diasDiferencia == 0){
          this.numdiaspermitidos = 0
          this.datesCredito();
        }else if(diasDiferencia == 1){
          this.numdiaspermitidos = 1
          this.datesCredito();
        }else if(diasDiferencia == 2){
          this.numdiaspermitidos = 2
          this.datesCredito();
        }else if(diasDiferencia == 3){
          this.numdiaspermitidos = 3
          this.datesCredito();
        }  
      },
      listaReceptores: function() {
        if (
                this.listaReceptores.length == 1 &&
                this.receptor.numero.length == 11
        ) {
          this.setReceiver(this.listaReceptores[0]);
        }
      },
      "receptor.numero": function() {
        if (this.receptor.numero.length < 3) {
          this.initReceptor();
        }
      },
      codigoSunatBarras: function() {
        if (this.codigoSunatBarras != null) {
          if (this.codigoSunatBarras.length === 8) {
            this.validateExportacion = true;
          } else {
            this.validateExportacion = false;
          }
        }
      },
      typeInvoice: function() {
        if (this.typeInvoice == "1") {
          this.contingencia = false;
          this.initDates();
        } else if (this.typeInvoice == "2") {
          this.initDates();
          this.contingencia = true;
        }
      },
      tipoOperacion: function() {
        // Operaciones sujetas a detraccion
        if (this.tipoOperacion == "1001" || this.tipoOperacion == "1002") {
          this.showAccountDetraction();
          this.detraccionCarga = false;
        } else if (this.tipoOperacion == "0200") {
          (this.receptor.tipo = "0"), (this.disabledGratuita = true);
          this.detraccionCarga = false;

        } else if (this.tipoOperacion == "1004") {
          this.showAccountDetraction();
          this.detraccionCarga = true;
          this.items = [];
        } else {
          (this.receptor.tipo = "6"), (this.disabledGratuita = false);
          this.detraccionCarga = false;
        }
        if(this.tipoOperacion !="1001"){
          this.detraccion = {
            codigo: "000",
            descripcion: "Seleccionar tipo detraccion",
            porcentajeDetraccion: "0%"
          };
          this.montoDetraccion = "";
          this.especificacionIgv = "01";
        }
        if(this.tipoOperacion =="0112"){
          this.modalSustentaGastos = true;
        }
        if(this.tipoOperacion === "0101EDU"){
          this.especificacionIgv = "02"
        }
      },
      checkedDsctoGlobal: function() {
        this.descuentoGlobalMonto = "";
        this.descuentoGlobalPorcentaje = "";
      },
      descuentoGlobalMonto: function() {
        let ventaGravadaActual = this.totalVentaGravada;
        if (this.totalVentaGravada > 0) {
          if (this.descuentoGlobalMonto != "") {
            this.factorNumericoDescuento =
                    (this.descuentoGlobalMonto * 100) / ventaGravadaActual;
            this.montoDescuento = this.descuentoGlobalMonto;
            this.montoBaseDescuento = ventaGravadaActual;
            this.totalVentaGravada = ventaGravadaActual - this.montoDescuento;
          }
        }
      },
      descuentoGlobalPorcentaje: function() {
        let ventaGravadaActual = this.totalVentaGravada;
        if (this.totalVentaGravada > 0) {
          if (this.descuentoGlobalPorcentaje != "") {
            this.factorNumericoDescuento = this.descuentoGlobalPorcentaje / 100;
            this.montoDescuento =
                    (this.descuentoGlobalPorcentaje / 100) * ventaGravadaActual;
            this.montoBaseDescuento = ventaGravadaActual - this.montoDescuento;
            this.totalVentaGravada = ventaGravadaActual - this.montoDescuento;
          }
        }
      },
      vbarras: function() {
        if (this.vbarras) {
          this.placeholdercodigo = "C. Barras";
        } else {
          this.placeholdercodigo = "C. Sunat";
        }
      },
      seriecon: function() {
        if (this.seriecon.length != "" && this.serie.length != 4) {
          this.checkseriecon = true;
          this.responsecheckseriecon = "Requerido 4 caracteres";
        } else {
          this.checkseriecon = false;
          this.responsecheckseriecon = "";
        }
      },
      cantidad: function() {
        if (this.cantidad < 0) {
          this.checkcantidad = true;
          this.responsecheckcantidad = "Cantidad debe ser mayor a 0";
        } else {
          this.checkcantidad = false;
          this.responsecheckcantidad = "";
        }
      },
      listaProductCodeScaner: function() {
        if (this.listaProductCodeScaner.length == 1) {
          this.setReceiverProductCode(this.listaProductCodeScaner[0]);
        }
      },
      codigoProducto: function() {
        if (this.codigoProducto.length == 30) {
          this.checkcodigo = true;
          this.responsecheckcodigo = "Alfanumerico de 1 a 30 caracteres ";
        } else {
          this.checkcodigo = false;
          this.responsecheckcodigo = "";
        }
      },
      descripcion: function() {
        if(this.descripcion.length > 500) {
          this.checkdescripcion = true;
          this.responsecheckdescripcion =
          "Alfanumerico de maximo 500 caracteres ";
        }else if (this.descripcion.length == 0) {
          (this.sinresultados = false),
          (this.listades = false),
          (this.listaDescription = []);
        }else {
          this.checkdescripcion = false;
          this.responsecheckdescripcion = "";
          this.sinresultados = false
        }
      },
      especificacionIgv: function() {
        if (!this.ventaGratuita) {
          this.especificacion.codigo = "10";
          this.especificacion.descripcion = "Operacion onerosa";
          this.especificacion.codigoTributo = "1000";
          this.calcItem();
        } else {
          this.especificacion.codigo = "21";
          this.especificacion.descripcion = "Exonerado - Transferencia gratuita";
          this.especificacion.codigoTributo = "9996";
          this.calcItemGratuitos();
        }
      },
      ventaGratuita: function() {
        if (!this.ventaGratuita) {
          this.especificacion.codigo = "10";
          this.especificacion.descripcion = "Exonerado - Transferencia gratuita";
          this.especificacion.codigoTributo = "1000";
        } else {
          this.especificacion.codigo = "15";
          this.especificacion.descripcion = "Grabado - Bonificaciones";
          this.especificacion.codigoTributo = "9996";
        }
      },
      precioVentaUnitario: function() { 
        if (this.precioVentaUnitario < 0) {
          this.checkprecioventaunitario = true;
          this.responsecheckprecioventaunitario = "Cantidad debe ser mayor a 0";
        } else {
          this.checkprecioventaunitario = false;
          this.responsecheckprecioventaunitario = "";
        }
        if(this.tipoOperacion == "0101EDU"){
          this.especificacionIgv = "02"
          this.valorUnitario = this.precioVentaUnitario;
        }
        if (this.especificacionIgv == "01" && this.tipoOperacion != "0200") {
            if (!this.vunitario) {
              this.valorUnitario = this.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
            }
        } else if (
                this.especificacionIgv == "02" ||
                this.especificacionIgv == "03" ||
                this.tipoOperacion == "0200"
        ) { 
          this.valorUnitario = this.precioVentaUnitario;
        }
      },
      valorUnitario: function() {
        if (this.valorUnitario < 0) {
          this.checkvalorunitario = true;
          this.responsecheckvalorunitario = "Cantidad debe ser mayor a 0";
        } else {
          this.checkvalorunitario = false;
          this.responsecheckvalorunitario = "";
        }
        if (this.vunitario) {
          if(this.tipoOperacion == "0101EDU"){
            this.especificacionIgv = "02"
            this.valorUnitario = this.precioVentaUnitario;
          }
          if (this.especificacionIgv == "01" && this.tipoOperacion != "0200") {
            this.precioVentaUnitario = this.valorUnitario * (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
          } else if (
                  this.especificacionIgv == "02" ||
                  this.especificacionIgv == "03" ||
                  this.tipoOperacion == "0200"
          ) {
            this.precioVentaUnitario = this.valorUnitario;
          }
        }
      },
      servicio: function(val) {
        if (this.servicio) {
          this.unidadMedidaCantidad = "ZZ";
        } else {
          this.unidadMedidaCantidad = "NIU";
        }
      },
      switchAnticipo: function() {
        if (this.switchAnticipo) {
          this.anticipo = true;
        } else {
          this.anticipo = false;
        }
      },
      coleccion:function(){
            if(this.coleccion !=null){                   
                this.itemsEX = this.coleccion
                this.action.i = true                  
            }else{
               
            }
        },
      guiasmasiva(){
          if(this.guiasmasiva !=null){
            this.items_guias = this.guiasmasiva
            this.pasandoGuias = this.guiasmasiva
            this.accion.i = true

          }else{
            
          }
        },
      formadepago(){
        if(this.formadepago.codigo == '000'){
          this.previsualizar = true;
        }else{
          this.previsualizar = false
           if(this.formadepago.codigo == '00'){
              this.modalCredito = true;
              this.datesCredito()
            }else if(this.formadepago.codigo != '00'){
              this.cuotasCredito = []
            }
          }
        },
        montoPagoCuota(){
          if(this.fechaPagoCuota !='' && this.montoPagoCuota > 0){
            this.validarcredito = false
          }else{
             this.validarcredito = true
          }
        },
        fechaPagoCuota(){
          if(this.fechaPagoCuota !='' && this.montoPagoCuota > 0){
            this.validarcredito = false
          }else{
             this.validarcredito = true
          }
        },
        isc(){
          if(!this.isc){
            this.montoISC = '';
            this.selectedISC = 0;
            if(!this.vunitario){
              this.valorUnitario = this.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
            }  
          }
        },
        selectedISC(){
          if(this.selectedISC == 1){
            this.iscCodigo = "01";
            this.cuadroISC = true;
          }else if(this.selectedISC == 2){
            this.iscCodigo = "02"
             this.cuadroISC = true;
          }else if(this.selectedISC == 3){
            this.iscCodigo = "03"
             this.cuadroISC = true;
          }
        },
        selectedRetencion(){
          if(this.selectedRetencion != null){
            this.retencionIgv()
          }else if(this.selectedRetencion == null){
            this.retencionIgvCredito = ''
            // this.retencionIgv()
          }
        },
        importeTotal(){
          if(this.selectedRetencion != null){
             this.retencionIgv()
          }
        },
        provinciaSeleccionadaUbigeoOrigen: function () {
          this.distOrigen = true,
          this.distOrigenCargando = true,
          this.searchDistrictOrigen(this.distOrigenCargando, 1)
      },
        departamentoSeleccionadoUbigeoOrigen: function () {
          this.provOrigen = true,
          this.searchProvinceOrigen(1)
      },
        distritoSeleccionadoUbigeoOrigen: function () {
          this.distOrigenCargando = false,
          this.ubigeoOrigenDom = this.departamentoSeleccionadoUbigeoOrigen + this.provinciaSeleccionadaUbigeoOrigen + this.distritoSeleccionadoUbigeoOrigen.codDistrito,
          this.prependUbigeoOrigen = this.distritoSeleccionadoUbigeoOrigen.nombre,
          this.bloqueUbigeoPartida = true
      },

      departamentoSeleccionadoUbigeoDestino: function () {
          this.provDestino = true,
          this.searchProvinceDestino(1)
      },
      provinciaSeleccionadaUbigeoDestino: function () {
          this.distDestino = true,
          this.distDestinoCargando = true,
          this.searchDistrictDestino(this.distDestinoCargando, 1)
      },
      distritoSeleccionadoUbigeoDestino: function () {
        this.distDestinoCargando = false,
        this.ubigeoDestinoDom = this.departamentoSeleccionadoUbigeoDestino + this.provinciaSeleccionadaUbigeoDestino + this.distritoSeleccionadoUbigeoDestino.codDistrito,
        this.prependUbigeoDestino = this.distritoSeleccionadoUbigeoDestino.nombre
      },
    },
    methods: {
       //TEMPORAL
        // print: function () {
        //     this.printweb = true
        //     },
        // nuevaImpresion: function () {
        //     this.modalimpresion = false,
        //     this.vistaimpresion = false,
        //     this.newimpresion = true,
        //     this.initTicket()
        //     },
        //TEMPORAL
      valorUnitIsc(){
        if(this.montoISC !=''){
            let convertirISC = '';
            let impuestoISC = '';
            let impuestoIGV = '';
            let suma = '';

            if(this.selectedISC == 1 ){
              this.valorUniSinIsC = this.valorUnitario
              convertirISC = this.montoISC/100;
              impuestoISC = parseFloat(this.valorUnitario * convertirISC);
              impuestoIGV = (this.valorUnitario + impuestoISC)* (this.$store.state.igv == 18 ? 0.18 : 0.105); // 0.18
              suma = this.valorUnitario + impuestoISC;
              this.valorUnitario = suma;
              
            }else if(this.selectedISC == 2){
              this.valorUniSinIsC = this.valorUnitario
              impuestoISC = this.montoISC
              suma = parseFloat(this.valorUnitario) + parseFloat(impuestoISC);
              this.valorUnitario = suma;
            
            }else if(this.selectedISC == 3){
               this.valorUniSinIsC = this.valorUnitario
              this.valorSugerido = parseFloat(this.montoISC) * parseFloat(this.porcentajeISC/100);
              suma = (this.valorSugerido) + (this.valorUnitario);
              this.valorUnitario = suma;
              
            }
          }else if(this.montoISC == ''){
            // this.precioVentaUnitario = ''
          }
          this.cuadroISC = false;
          this.flechaISC = true;
      },
      mostrarISC(){
        this.flechaISC = false;
        this.cuadroISC = true;
      },
      onChange(event) {
            this.file = event.target.files ? event.target.files[0] : null;
      },
      onChange2(event) {
            this.guiasdoc = event.target.files ? event.target.files[0] : null;
      },
      totalitems(value){
            this.items = value
            this.action.i = false
        },
        totalitems2(value){
            this.guiasRelacionada = value
            this.action.i = false
        },
      quickEmisionProforma: function() {
        let itemBlank = [];
        this.bufferOrdenpago = this.$store.getters.getordenpago
        this.bufferProforma = this.$store.getters.getproforma;
        if (Object.values(this.bufferProforma).length > 0) {
          if (this.bufferProforma.proforma.receptor.nro && this.bufferProforma.proforma.receptor.nro.length == 11)
            {
            this.receptor.numero = this.bufferProforma.proforma.receptor.nro;
            this.receptor.razonSocial = this.bufferProforma.proforma.receptor.razonSocial;
            this.receptor.direccion = this.bufferProforma.proforma.receptor.direccionFiscal;
            }
          this.items = this.bufferProforma.proforma.items;
          this.moneda = this.bufferProforma.proforma.moneda;
          this.$store.commit("setproforma", itemBlank);
        }else if(Object.values(this.bufferOrdenpago).length > 0) 
        {
          if(this.bufferOrdenpago.ordenPago.receptor.nro && this.bufferOrdenpago.ordenPago.receptor.nro.length == 11)
            {
            this.receptor.numero = this.bufferOrdenpago.ordenPago.receptor.nro;
            this.receptor.razonSocial = this.bufferOrdenpago.ordenPago.receptor.razonSocial;
            this.receptor.direccion = this.bufferOrdenpago.ordenPago.receptor.direccionFiscal;
            }
          this.items = this.bufferOrdenpago.ordenPago.items;
          this.moneda = this.bufferOrdenpago.ordenPago.moneda;
          this.idOrdenPago = this.bufferOrdenpago.idOrdenPago
          this.$store.commit("setordenpago", itemBlank);
        }
      },
      cerrarmodalOtroCargo: function() {
        this.otroscargosmodal = false;
      },
      cerrarmodaldsctGlobal(){
        this.descuentoglobalM = false;
      },
      accumulateOtrosCargos: function() {
        let val = 0.0;
        let val2 = 0.0;
        this.listaOtrosCargosAgregados.forEach(function(element) {
          val += parseFloat(element.montoCargoDescuento);
        });
        this.items.forEach(function(element) {
          if(element.cargosDescuentosItem && element.cargosDescuentosItem.codigoCargoDescuento == '48'){
            element.cargosDescuentosItem.forEach(function(element){
            val2 += parseFloat(element.montoCargoDescuento)
          })
          }  
        });
        this.sumatoriaOtrosCargosProducto = val2;
        this.sumatoriaOtrosCargos = val;
        return (val+val2).toFixed(2);
      },
      deleteOtroCargo: function(index, value) {
        
        this.$swal({
          title: "Eliminar Otro Cargo",
          text: "Seguro de eliminar el cargo con monto " + value.montoCargoDescuento,
          icon: "error",
          buttons: true,
          dangerMode: true
        }).then(willDelete => {
          if (willDelete) {
            this.listaOtrosCargosAgregados.splice(index, 1);
          }
        });
      },
      addMontoCargo: function() {
        this.montoOtroCargo2 = parseFloat(this.montoOtroCargo)
        let otrocargo = {
          // codigoMotivoCargo: this.otroCargo.codigo,
          // factorNumericoCargo: parseFloat((this.montoOtroCargo * 100) / this.importeTotal),
          // montoCargo: parseFloat(this.montoOtroCargo),
          // montoBaseCargo: this.baseCargo,
          indicador: "",
          codigoCargoDescuento: "",
          factorCargoDescuento: "",
          montoCargoDescuento: "",
          baseCargoDescuento: "",
        };
          otrocargo.indicador = "cargo",
          otrocargo.codigoCargoDescuento =  this.otroCargo.codigo,
          otrocargo.factorCargoDescuento =  parseFloat(((this.montoOtroCargo)/[(this.importeTotal-this.sumatoriaOtrosCargos)]).toFixed(5)),   
          otrocargo.baseCargoDescuento = parseFloat((this.baseCargo).toFixed(2)),
          otrocargo.montoCargoDescuento = parseFloat(((otrocargo.factorCargoDescuento)*otrocargo.baseCargoDescuento).toFixed(2))

        if (this.montoOtroCargo > 0) {
          this.listaOtrosCargosAgregados.push(otrocargo);
          this.montoOtroCargo = "";
        } else {
          this.$snotify.warning("El monto debe ser mayor a 0", "Cuidado");
        }
      },
      validateOtrosCargos: function() {
        if (this.listaOtrosCargosAgregados.length > 0) {
          return false;
        } else {
          return true;
        }
      },
      quickEmision: function() {
        if (this.emisionrapida.itemsrapidos.length > 0) {
          let itemsBuffer = [];
          let itemTransitorio = {
            adicional: "",
            baseAfectacionIgv: "",
            cantidad: "",
            idProducto: "",
            codigoProducto: "",
            codigoProductoGs1: "",
            codigoProductoSunat: "",
            codigoTributo: "",
            descripcion: "",
            descuento: "",
            idFactura: "",
            idFacturaItem: "",
            montoAfectacionIgv: "",
            montoTotalImpuestosItem: "",
            porcentajeDescuento: "",
            porcentajeImpuesto: "",
            precioVentaUnitario: "",
            tipoAfectacionIgv: "",
            tipoPrecioVentaUnitario: "",
            unidadMedidaCantidad: "NIU",
            valorUnitario: "",
            valorVenta: "",
            valorUnitarioVista: "",
            valorVentaVista: ""
          };
          this.emisionrapida.itemsrapidos.forEach(function(element) {
            (itemTransitorio.adicional = element.adicional),
                    (itemTransitorio.baseAfectacionIgv = element.baseAfectacionIgv),
                    (itemTransitorio.cantidad = element.cantidad),
                    (itemTransitorio.idProducto = element.idProducto),
                    (itemTransitorio.codigoProducto = element.codigoProducto),
                    (itemTransitorio.codigoProductoGs1 = element.codigoProductoGs1),
                    (itemTransitorio.codigoProductoSunat = element.codigoProductoSunat),
                    (itemTransitorio.codigoTributo = element.codigoTributo),
                    (itemTransitorio.descripcion = element.descripcion),
                    (itemTransitorio.descuento = element.descuento),
                    (itemTransitorio.idFactura = element.idFactura),
                    (itemTransitorio.idFacturaItem = element.idFacturaItem),
                    (itemTransitorio.montoAfectacionIgv = element.montoAfectacionIgv),
                    (itemTransitorio.montoTotalImpuestosItem =
                            element.montoTotalImpuestosItem),
                    (itemTransitorio.porcentajeDescuento = element.porcentajeDescuento),
                    (itemTransitorio.porcentajeImpuesto = element.porcentajeImpuesto),
                    (itemTransitorio.precioVentaUnitario = element.precioVentaUnitario),
                    (itemTransitorio.tipoAfectacionIgv = element.tipoAfectacionIgv),
                    (itemTransitorio.tipoPrecioVentaUnitario =
                            element.tipoPrecioVentaUnitario),
                    (itemTransitorio.unidadMedidaCantidad =
                            element.unidadMedidaCantidad),
                    (itemTransitorio.valorUnitario = element.valorUnitario),
                    (itemTransitorio.valorUnitarioVista = element.valorUnitario),
                    (itemTransitorio.valorVenta = element.valorVenta),
                    (itemTransitorio.valorVentaVista = element.valorVenta);
            if (
                    itemTransitorio.adicional == "" ||
                    itemTransitorio.adicional == null ||
                    itemTransitorio.adicional == "[]" ||
                    itemTransitorio.adicional == "[]"
            ) {
              delete itemTransitorio.adicional;
              itemsBuffer.push(itemTransitorio);
              itemTransitorio = {
                adicional: "",
                baseAfectacionIgv: "",
                cantidad: "",
                idProducto: "",
                codigoProducto: "",
                codigoProductoGs1: "",
                codigoProductoSunat: "",
                codigoTributo: "",
                descripcion: "",
                descuento: "",
                idFactura: "",
                idFacturaItem: "",
                montoAfectacionIgv: "",
                montoTotalImpuestosItem: "",
                porcentajeDescuento: "",
                porcentajeImpuesto: "",
                precioVentaUnitario: "",
                tipoAfectacionIgv: "",
                tipoPrecioVentaUnitario: "",
                unidadMedidaCantidad: "NIU",
                valorUnitario: "",
                valorVenta: "",
                valorUnitarioVista: "",
                valorVentaVista: ""
              };
            } else {
              (itemTransitorio.adicional = JSON.parse(element.adicional)),
                      itemsBuffer.push(itemTransitorio);
              itemTransitorio = {
                adicional: "",
                baseAfectacionIgv: "",
                cantidad: "",
                idProducto: "",
                codigoProducto: "",
                codigoProductoGs1: "",
                codigoProductoSunat: "",
                codigoTributo: "",
                descripcion: "",
                descuento: "",
                idFactura: "",
                idFacturaItem: "",
                montoAfectacionIgv: "",
                montoTotalImpuestosItem: "",
                porcentajeDescuento: "",
                porcentajeImpuesto: "",
                precioVentaUnitario: "",
                tipoAfectacionIgv: "",
                tipoPrecioVentaUnitario: "",
                unidadMedidaCantidad: "NIU",
                valorUnitario: "",
                valorVenta: "",
                valorUnitarioVista: "",
                valorVentaVista: ""
              };
            }
          });
          this.items = itemsBuffer;  
        } else {
          this.items = [];
        }
      },
      validateRegularizacion: function() {
        if (this.selectedAnticipos.length > 0) {
          return false;
        } else {
          return true;
        }
      },
      sendFacturaAnticipos: function() {
        let desctglobal = {
            indicador: "",
            codigoCargoDescuento: "",
            factorCargoDescuento:"",
            montoCargoDescuento: "",
            baseCargoDescuento: ""
          }
        let valAnticipo = 0.0
        this.saveAnticipos.forEach(function(element){
           valAnticipo += element.montoAnticipado
        })
          let v1
          let v2
          let total
          this.valorAnticipo = parseFloat(valAnticipo / (this.$store.state.igv == 18 ? 1.18 : 1.105)); //1.18
              desctglobal.indicador = "descuento",
              desctglobal.codigoCargoDescuento = "04"
              desctglobal.factorCargoDescuento  = parseFloat((this.valorAnticipo / this.valortotal()).toFixed(5))        
              v1 = parseFloat((this.valorAnticipo / this.valortotal()).toFixed(5)) 
              desctglobal.baseCargoDescuento = parseFloat(this.valortotal().toFixed(2));
              v2 = parseFloat(this.valortotal().toFixed(2));
              total = v1*v2
              desctglobal.montoCargoDescuento = parseFloat(total.toFixed(2));
          this.cargosDescuentosGlobales.push(desctglobal)
          this.modalAnticipos = false;
      },
      addAnt: function(value, i) {
        let bufferAnticipo = {
          serieNumero: "",
          tipoComprobanteAnticipo: "",
          montoAnticipado: "",
          fechaPago: ""
        };
        if (
                parseFloat(value.montoAnticipo) > 0 &&
                parseFloat(value.montoAnticipo) <= parseFloat(value.montoRegularizar)
        ) {
          // Datos generales del item, uso en front
          if (value.compRegularizado != null) {
            bufferAnticipo.compRegularizado = value.compRegularizado;
          }
          if (value.created_at != null) {
            bufferAnticipo.created_at = value.created_at;
          }
          if (value.deleted_at != null) {
            bufferAnticipo.deleted_at = value.deleted_at;
          }
          bufferAnticipo.idAnticipo = value.idAnticipo;
          bufferAnticipo.idEmisor = value.idEmisor;
          bufferAnticipo.idReceptor = value.idReceptor;
          bufferAnticipo.montoRegularizar = value.montoRegularizar;
          bufferAnticipo.regularizado = value.regularizado;
          bufferAnticipo.serie = value.serie;
          bufferAnticipo.numero = value.numero;
          bufferAnticipo.tipoAfectacion = value.tipoAfectacion;
          bufferAnticipo.tipoComprobante = value.tipoComprobante;
          bufferAnticipo.updated_at = value.updated_at;
          // Datos para el Json Regularizacion de anticipos
          bufferAnticipo.serieNumero = value.serie + "-" + value.numero;
          bufferAnticipo.tipoComprobanteAnticipo = "02";
          bufferAnticipo.montoAnticipado = parseFloat(value.montoAnticipo);
          if (value.tipoAfectacion == 10) {
            bufferAnticipo.montoAnticipado = parseFloat(parseFloat(value.montoAnticipo).toFixed(2));
            bufferAnticipo.montoAnticipadoValor = parseFloat(value.montoAnticipo) / (this.$store.state.igv == 18 ? 1.18 : 1.105) ; //1.18
            bufferAnticipo.montoAnticipadoIgv =
                    parseFloat(value.montoAnticipo) -
                    parseFloat(value.montoAnticipo) / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
          }
          if (value.tipoAfectacion == 20) {
            bufferAnticipo.montoAnticipadoExonerado = parseFloat(
                    value.montoAnticipo
            );
          }
          if (value.tipoAfectacion == 30) {
            bufferAnticipo.montoAnticipadoInafecto = parseFloat(
                    value.montoAnticipo
            );
          }
          if (value.tipoAfectacion == 40) {
            bufferAnticipo.montoAnticipadoExportacion = parseFloat(
                    value.montoAnticipo
            );
          }
          bufferAnticipo.fechaPago = this.$moment(value.created_at).format(
                  "YYYY-MM-DD"
          );
          this.selectedAnticipos.push(bufferAnticipo);
          this.docAnticipos.splice(i, 1);
          this.saveAnticipos = this.selectedAnticipos;
        } else if (value.montoAnticipo <= 0) {
          this.$snotify.warning(
                  "El monto ingresado debe ser mayor a cero!",
                  "Atención"
          );
        } else if (
                parseFloat(value.montoAnticipo) > parseFloat(value.montoRegularizar)
        ) {
          this.$snotify.warning(
                  "El monto anticipado no puede ser mayor al que va a regularizar",
                  "Atención"
          );
        } else {
          this.$snotify.warning("Valor invalido", "Atención");
        }
      },
      remAnt: function(item, i) {
        this.docAnticipos.push(item);
        this.selectedAnticipos.splice(i, 1);
      },
      searchAnticipoByRuc: function() {
        this.selectedAnticipos = [];
        this.saveAnticipos = [];
        // let cantAnticipos = this.selectedAnticipos.length;
        // if (cantAnticipos > 0) {
        //   this.selectedAnticipos.splice(0, cantAnticipos);
        //   //cada que ingran al boton de anticipos de borra el array
        // //  this.cargosDescuentosGlobales = [] 
        // }
        this.cargandoAnticipos = false;
        this.cargando = true;
        axios
                .post(process.env.VUE_APP_API_URL + "anticipos/receptor", {
                  token: this.$store.getters.userToken,
                  idReceptor: this.receptor.numero
                })
                .then(
                        response => (
                                (this.docAnticipos = response.data.data),
                                        (this.totalRows = this.invoices.length),
                                        (this.total = response.data.total),
                                        (this.desde = response.data.from),
                                        (this.hasta = response.data.to),
                                        (this.cargando = false),
                                        (this.cargandoAnticipos = true)
                        )
                )
                .catch(error => (this.cargandoAnticipos = false));
      },
      accumulateAnticipos: function() {
        let val = 0.0;
        let valAnticiposValor = 0.0;
        let valAnticiposIgv = 0.0;
        this.selectedAnticipos.forEach(function(element) {
          if (element.tipoAfectacion == 10) {
            val += parseFloat(element.montoAnticipado);
            valAnticiposValor += parseFloat(element.montoAnticipadoValor);
            valAnticiposIgv += parseFloat(element.montoAnticipadoIgv);
          } else if (element.tipoAfectacion == 20) {
            val += parseFloat(element.montoAnticipadoExonerado);
          } else if (element.tipoAfectacion == 30) {
            val += parseFloat(element.montoAnticipadoInafecto);
          }else if(element.tipoAfectacion == 40){
            val += parseFloat(element.montoAnticipado);
          }
        });
        this.totalAnticipos = val.toFixed(2);
        this.totalAnticiposValor = valAnticiposValor;
        this.totalAnticiposIgv = valAnticiposIgv;
        return val.toFixed(2);
      },
      addAnticipos: function() {
        if (this.receptor.numero.length === 11) {
          this.modalAnticipos = !this.modalAnticipos;
          this.modalAnticipos = true;
          this.disabledAnticipo = true;
          this.switchAnticipo = false;
          this.searchAnticipoByRuc();
        } else {
          this.$snotify.warning("Debe ingresar el ruc del receptor", "Atencion");
        }
      },
      loadListAnticipos: function() {
        let cantAnticipos = this.selectedAnticipos.length;
        if (cantAnticipos > 0) {
          this.selectedAnticipos.splice(0, cantAnticipos);
        }
        this.cargandoAnticipos = false;
        this.cargando = true;
        axios
                .post(process.env.VUE_APP_API_URL + "anticipos", {
                  token: this.$store.getters.userToken,
                  page: this.currentPage,
                  limit: this.limite,
                  order: this.orden
                })
                .then(
                        response => (
                                (this.docAnticipos = response.data.data),
                                        (this.totalRows = this.invoices.length),
                                        (this.total = response.data.total),
                                        (this.desde = response.data.from),
                                        (this.hasta = response.data.to),
                                        (this.cargando = false),
                                        (this.cargandoAnticipos = true)
                        )
                )
                .catch(function(error) {
                  this.cargandoAnticipos = false;
                });
      },
      updateClient: function() {
        // (this.modalCliente = true),
        (this.updateClienteDatos = true),
                axios
                        .post(process.env.VUE_APP_API_URL + "receptores/actualizar", {
                          token: this.$store.getters.userToken,
                          ruc: this.rucCliente.length>0  ? this.rucCliente : this.receptor.numero
                        })
                        .then(response => (
                          (this.updateClienteDatos = false),
                          (this.razon_social = response.data.response.razon_social),
                          this.getReceivers(),
                          this.$snotify.success(response.data.msg, "Éxito"),
                          (this.modalCliente = false),
                          (this.modalClienteCargando = false)
                          ))
                        .catch(error => (
                          (this.updateClienteDatos = false),
                          this.modalCliente == true ? this.$snotify.error("El RUC ingresado es invalido!", "Error") : this.rucNoEncontrado = true,
                          this.modalClienteCargando = false,
                          this.modalCliente = false
                          ));
      },
      adicionalDetraccionBack(value) {
        this.adicionalDetraccion = value;
        if (Object.values(this.adicionalDetraccion) != "") {
          this.itemsDetraccionCheck = true;
        } else {
          this.itemsDetraccionCheck = false;
        }
      },
      emisionRapida: function() {
        this.viewEmisionRapida = true;
      },
      enter: function() {
        if (this.validateFields()) {
          this.addItem();
        }
      },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      showAccountDetraction: function() {
        axios
                .post(process.env.VUE_APP_API_URL + "cuenta/detraccion/buscarcuenta", {
                  token: this.$store.getters.userToken
                })
                .then(response => (this.cuentaDetracionAdmin = response.data.response))
                .catch(error => {});
      },
      getSeries: function() {
        let nuevoIGV = null
        axios
        .post(process.env.VUE_APP_API_URL + "usuario/series/" + this.tipodoc, {
          token: this.$store.getters.userToken
        })
        .then(response => (
          (this.listaSeries = response.data.data),
          (this.rolSeries = response.data.rol),
          (this.seriesCargadas = false),
          nuevoIGV = response.data.igv,
          this.almacenarIGV(nuevoIGV)
        ))
        .catch(error => {
          this.seriesCargadas = false;
        });
      },
      almacenarIGV(value){
        this.igvGlobal = value
        if(value == 18){
          this.unoDieciocho = 1.18;
          this.ceroDieciocho = 0.18;
          this.dieciocho = 18;
        }else if(value == 10.5){ 
          this.unoUno = 1.105;
          this.ceroUno = 0.105;       
          this.diez = 10.5; 
        }
        this.guiaAFactura(); 
      },
      setReceiver: function(item) {
        (this.receptor.numero = item.idReceptor),
                (this.receptor.tipo = item.tipo),
                (this.receptor.razonSocial = item.razonSocial),
                (this.receptor.direccion = item.direccionReferencia),
                (this.direcciones = item.direcciones),
                (this.listaCorreos = item.email),
                (this.listarec = false),
                (this.listaReceptores = []);
        if(this.receptor.numero.length == 11 && this.receptor.direccion != ''){
          this.editarDireccion = true
        }else{
          this.editarDireccion = false
        }
      },
      setReceiverProductCode: function(item) {
        // (this.cantidad = 1),
        (this.idProducto = item.idProducto),
        (this.codigoProducto = item.codigo),
        (this.descripcion = item.descripcion),
        (this.codigoSunatBarras = item.codigoProductoSunat),
        (this.precioVentaUnitario = item.precioUnitario),
        (this.unidadMedidaCantidad = item.unidadMedida);
        this.itemEditado = false;
        if (item.tipoAfectacionIgv == "") {
          this.especificacionIgv = "01";
        }else{
          this.especificacionIgv = item.tipoAfectacionIgv;
        }
        (this.listaProductCod = false), 
        (this.listaProductCode = []);
        this.resultadoCodProducto =[];

        if(this.scanerCodigo){
          setTimeout(() => {
            this.addItem();
          }, 100);

        }
      },
      setReceiverBarCodeSunat: function(item) {
        (this.cantidad = 1),
                (this.idProducto = item.idProducto),
                (this.codigoProducto = item.codigo),
                (this.descripcion = item.descripcion),
                (this.codigoSunatBarras = item.codigoProductoSunat),
                (this.precioVentaUnitario = item.precioUnitario),
                (this.unidadMedidaCantidad = item.unidadMedida);
        if (item.tipoAfectacionIgv == "") {
          this.especificacionIgv = "01";
        } else {
          this.especificacionIgv = item.tipoAfectacionIgv;
        }
        (this.listabarcodesunat = false), (this.listaBarCodeSunat = []);
      },
      setReceiverDescription2(item){
        (this.idProducto = item.idProducto),
        (this.codigoProducto = item.codigo),
        (this.descripcion = item.descripcion),
        (this.codigoSunatBarras = item.codigoProductoSunat),
        (this.precioVentaUnitario = item.precioUnitario);
        this.otrosCargosProducto = item.otrosCargos;
        this.unidadMedidaCantidad = item.unidadMedida;
        if (item.tipoAfectacionIgv == "") {
          this.especificacionIgv = "01";
        } else {
          this.especificacionIgv = item.tipoAfectacionIgv;
        }
        (this.listades = false), (this.listaDescription = []);
        if(item.isc !='' && item.isc != null){
          this.isc = true;
          this.selectedISC = item.isc.tipoISC;
          if(item.isc.tipoISC == 3){
            this.montoISC = item.isc.valorReferencial
            this.porcentajeISC = item.isc.valorISC
          }else{
            this.montoISC = item.isc.valorISC
          }
        }
      },
      setReceiverDescription: function(item) {
        if(item.descuentaStock.length > 0){
          this.descuentaStock = item.descuentaStock
        }
        this.itemEditado = false,
        this.stock = item.stock,
        (this.idProducto = item.idProducto),
        (this.codigoProducto = item.codigo),
        (this.descripcion = item.descripcion),
        (this.codigoSunatBarras = item.codigoProductoSunat),
        (this.precioVentaUnitario = item.precioUnitario);
        this.otrosCargosProducto = item.otrosCargos;
        this.unidadMedidaCantidad = item.unidadMedida;
        if (item.tipoAfectacionIgv == "") {
          this.especificacionIgv = "01";
        } else {
          this.especificacionIgv = item.tipoAfectacionIgv;
        }
        (this.listades = false), (this.listaDescription = []);
        if(item.isc !='' && item.isc != null){
          this.isc = true;
          this.selectedISC = item.isc.tipoISC;
          if(item.isc.tipoISC == 3){
            this.montoISC = item.isc.valorReferencial
            this.porcentajeISC = item.isc.valorISC
          }else{
            this.montoISC = item.isc.valorISC
          }
        }
      },
      initData: function() {
        if (this.especificacionIgv === "01") {
          this.Especificacion = this.EspecificacionIgv;
        } else if (this.especificacionIgv === "02") {
          this.Especificacion = this.EspecificacionIgv2;
        } else if (this.especificacionIgv === "03") {
          this.Especificacion = this.EspecificacionIgv3;
        }
      },
      initDates: function() {
            if(this.typeInvoice == "1"){
               let r1 = {
              from: this.$moment().subtract(50000, "years"),
              to: this.$moment().subtract(4, "days")
              };
              let r2 = {
              from: this.$moment().add(0, "days"),
              to: this.$moment().add(60000, "years")
              };
              this.diasnopermitidos.ranges.splice(r1);
              this.diasnopermitidos.ranges.splice(r2);
              this.diasnopermitidos.ranges.push(r1);
              this.diasnopermitidos.ranges.push(r2);
              this.currentdate = this.$moment().format("YYYY-MM-DD HH:mm:ss"); 
            }else{
              let r1 = {
              from: this.$moment().subtract(50000, "years"),
              to: this.$moment().subtract(1791, "days")
              };
               let r2 = {
              from: this.$moment().add(0, "days"),
              to: this.$moment().add(60000, "years")
              };
              this.diasnopermitidos.ranges.splice(r1);
              this.diasnopermitidos.ranges.splice(r2); 
              this.diasnopermitidos.ranges.push(r1);
              this.diasnopermitidos.ranges.push(r2);
              this.currentdate = this.$moment().format("YYYY-MM-DD HH:mm:ss");
            }      
      },
      datesCredito: function() {
          let r1 = {
          from: this.$moment().subtract(50000, "years"),
          to: this.$moment().subtract(this.numdiaspermitidos, "days")
          };
          let r2 = {
          from: this.$moment().add(6000, "years"),
          to: this.$moment().add(60000, "years")
          };
          this.diasnopermitidosCredito.ranges.splice(r1);
          this.diasnopermitidosCredito.ranges.splice(r2);
          this.diasnopermitidosCredito.ranges.push(r1);
          this.diasnopermitidosCredito.ranges.push(r2); 
      },
      initMoneda: function() {
        this.moneda = {
          id: "1",
          codigo: "PEN",
          descripcion: "SOLES",
          simbolo: "S/."
        };
      },
      calcItem: function() {
        var parent = this;
        if (parent.especificacionIgv === "01" && !parent.vunitario) {
          parent.Especificacion = parent.EspecificacionIgv;
          parent.especificacion = {
            codigo: "10",
            descripcion: "Operacion onerosa",
            codigoTributo: "1000"
          };
          parent.valorUnitario = parent.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105) ; //1.18
        } else if (parent.especificacionIgv === "01" && parent.vunitario) {
          parent.precioVentaUnitario = parent.valorUnitario * (this.$store.state.igv == 18 ? 1.18 : 1.105) ; //1.18
        } else if (parent.especificacionIgv === "02" && !parent.vunitario) {
          parent.Especificacion = parent.EspecificacionIgv2;
          parent.especificacion = {
            codigo: "30",
            descripcion: "Operación Onerosa",
            codigoTributo: "9998"
          };
          parent.valorUnitario = parent.precioVentaUnitario;
        } else if (parent.especificacionIgv === "02" && parent.vunitario) {
          parent.precioVentaUnitario = parent.valorUnitario;
        } else if (parent.especificacionIgv === "03" && !parent.vunitario) {
          parent.Especificacion = parent.EspecificacionIgv3;
          parent.especificacion = {
            codigo: "20",
            descripcion: "Operación Onerosa",
            codigoTributo: "9997"
          };
          parent.valorUnitario = parent.precioVentaUnitario;
        } else if (parent.especificacionIgv === "03" && parent.vunitario) {
          parent.precioVentaUnitario = parent.valorUnitario;
        } else if (parent.tipoOperacion == "0200" && !parent.vunitario) {
          parent.valorUnitario = parent.precioVentaUnitario;
        } else if (parent.tipoOperacion == "0200" && parent.vunitario) {
          parent.precioVentaUnitario = parent.valorUnitario;
        }
      },
      calcItemGratuitos: function() {
        var parent = this;
        if (parent.especificacionIgv === "01" && !parent.vunitario) {
          parent.Especificacion = parent.EspecificacionIgv;
          parent.especificacion = {
            codigo: "15",
            descripcion: "Grabado - Bonificaciones",
            codigoTributo: "9996"
          };
          parent.valorUnitario = parent.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105) ; //1.18
        } else if (parent.especificacionIgv === "01" && parent.vunitario) {
          parent.precioVentaUnitario = parent.valorUnitario * (this.$store.state.igv == 18 ? 1.18 : 1.105) ; //1.18
        } else if (parent.especificacionIgv === "02" && !parent.vunitario) {
          parent.Especificacion = parent.EspecificacionIgv2;
          parent.especificacion = {
            codigo: "31",
            descripcion: "Retiro por Bonificación",
            codigoTributo: "9996"
          };
          parent.valorUnitario = parent.precioVentaUnitario;
        } else if (parent.especificacionIgv === "02" && parent.vunitario) {
          parent.precioVentaUnitario = parent.valorUnitario;
        } else if (parent.especificacionIgv === "03" && !parent.vunitario) {
          parent.Especificacion = parent.EspecificacionIgv3;
          parent.especificacion = {
            codigo: "21",
            descripcion: "Transferencia gratuita",
            codigoTributo: "9996"
          };
          parent.valorUnitario = parent.precioVentaUnitario;
        } else if (parent.especificacionIgv === "03" && parent.vunitario) {
          parent.precioVentaUnitario = parent.valorUnitario;
        } else if (parent.tipoOperacion == "0200" && !parent.vunitario) {
          parent.valorUnitario = parent.precioVentaUnitario;
        } else if (parent.tipoOperacion == "0200" && parent.vunitario) {
          parent.precioVentaUnitario = parent.valorUnitario;
        }
      },
      validateFields: function() {
        let validateDetraccion = false;
        let itemsDetraccion = false;
        let itemsGenerales = false;
          if (this.tipoOperacion == "1004" && this.itemsDetraccionCheck) {
              itemsDetraccion = true;
          }else {
              itemsDetraccion = false;
          }
          if(this.cantidad != "" && this.descripcion != "" && this.precioVentaUnitario !== ""){
            itemsGenerales = true;
          }else {
            itemsGenerales = false;
          }
          // Caso detraccion transporte de carga "tipoOperacion == '1004'"
          if(itemsDetraccion && itemsGenerales && this.tipoOperacion == "1004") {
            return true;
          }
          if(this.validateExportacion && itemsGenerales && this.tipoOperacion == "0200"){
            // Caso emision de exportacion
            return true;
          }
          if(itemsGenerales && this.tipoOperacion == "0101EDU" && 
                              this.dniAlumno != "" &&
                              this.nomApeAlumno != "" ){
            return true;
          }
          if (itemsGenerales && (this.tipoOperacion == "0101" ||
                          this.tipoOperacion == "0112" ||
                          this.tipoOperacion == "0113" ||
                          this.tipoOperacion == "1001" ||
                          this.tipoOperacion == "1002" ||
                          this.tipoOperacion == "1004")) 
          {
            // Caso emision comun
            return true;
          } else {
            return false;
          }
      },
      validateFieldsGuia: function() {
        if (
                this.seriedeguia != "" &&
                this.numerodeguia != "" &&
                this.tipodeguia !== ""
        ) {
          return true;
        } else {
          return false;
        }
      },
      validateFieldsRelacionadas: function() {
        if (this.numerorelacionado != "" && this.docRelacionado !== "") {
          return true;
        } else {
          return false;
        }
      },
      validateFieldsAdicionales: function() {
        if (this.key != "" && this.value != "") {
          return true;
        } else {
          return false;
        }
      },
      validateInvoice: function() {
        let validaSerie;
        this.validadorseries = 0;
        let ventaTotal = this.accumulateTotalSale();
        let tiposerie = "";
        if (this.typeInvoice == 1) {
          if (this.indexSerie == 0) {
            this.serie = this.listaSeries[0];
            tiposerie = this.serie;
          } else {
            this.serie = this.listaSeries[this.indexSerie];
            tiposerie = this.serie;
          }
        } else if (this.typeInvoice == 2) {
          tiposerie = this.seriecon;
        }
        if (this.tipoOperacion == "0200") {
          // Exportacion de bienes
          if (
                  tiposerie !== "" &&
                  this.items.length > 0 &&
                  !this.seriesCargadas &&
                  this.stateReceptorNumero
          ) {
            if (this.totalAnticipos > 0 && ventaTotal >= 0) {
              return true;
            } else if (this.totalAnticipos == 0 && ventaTotal >= 0) {
              return true;
            } else if (ventaTotal < 0) {
              return false;
            }
          } else {
            return false;
          }
        } else {
          // Venta interna
         if(this.typeInvoice == "1"){
            validaSerie = this.listaSeries.length
          }else{
            validaSerie = -1
          }
          if (validaSerie != 0 &&
              tiposerie !== "" &&
              this.items.length > 0 &&
              !this.seriesCargadas &&
              this.stateReceptorRuc &&
              this.receptor.numero.length === 11){
                if (this.totalAnticipos > 0 && ventaTotal >= 0) {
                    return true;
                    } else if (this.totalAnticipos == 0 && ventaTotal >= 0) {
                      return true;
                    } else if (ventaTotal < 0) {
                      return false;
                    }
                  } else {
                    return false;
                  }
        }
      },
      accumulateIgv: function() {
        let val = 0.0;
        let valEnvio = 0.0;
        let val2 = 0.0;
        let valGratuita = 0.0;
        let codtributo = 0.0;
        let sumaCargoDescuentoItem = 0.0;
        let montoImpuestos = 0.0;
        this.items.forEach(function(element) {
          if ( element.codigoTributo == "9996" && element.tipoPrecioVentaUnitario == "02"){
            valGratuita += parseFloat(element.montoTotalImpuestosItem);
          }else{
            val += parseFloat(element.montoTotalImpuestosItem);
            montoImpuestos += parseFloat(element.montoTotalImpuestosItem);
            val2 += parseFloat(element.montoAfectacionIgv);
          }
          codtributo = element.codigoTributo
          
        });
        this.items.forEach(function(element){
          if(element.cargosDescuentosItem && element.cargosDescuentosItem.codigoCargoDescuento == '48'){
            element.cargosDescuentosItem.forEach(function(element){
               sumaCargoDescuentoItem += parseFloat(element.montoCargoDescuento)
            })
          }
        });
        this.sumaCargoDescuentoItem = sumaCargoDescuentoItem
        this.cotributo = codtributo;
        // Regularizacion de anticipos
        if (this.selectedAnticipos.length > 0 && this.totalAnticiposIgv > 0) {
          if(codtributo == '1000'){
            this.tPrecioVenta = val ;
            montoImpuestos = (val).toFixed(2) - (this.totalAnticiposIgv).toFixed(2);
          this.sumatoriaIgv = (val2).toFixed(2) - (this.totalAnticiposIgv).toFixed(2);
          } else {
            montoImpuestos = val;    
            this.sumatoriaIgv = val2;
          }       
        }else if (this.selectedAnticipos.length > 0 && this.totalAnticiposIgv == 0){
          (montoImpuestos = val), 
          (this.sumatoriaIgv = val2);
        } 
        if(this.valorGlobal >0){
            let impuesto = ( montoImpuestos - (this.valorGlobal*(this.$store.state.igv == 18 ? 0.18 : 0.105))); //0.18
            this.sumatoriaIgv =  (val2 - (this.valorGlobal*(this.$store.state.igv == 18 ? 0.18 : 0.105))); //0.18
            montoImpuestos = impuesto;
            // val2 = this.sumatoriaIgv;
            // val = this.montoTotalImpuestos;
        } 
        if(this.selectedAnticipos.length == 0 && this.totalAnticiposIgv == 0 && this.valorGlobal == 0){
          if(this.emisionrapidaIgv !='' && !this.editarConFacturaRapida){
            (valEnvio = this.emisionrapidaIgv),
            (montoImpuestos = val), 
            (this.sumatoriaIgv = val2);
          }else{
            // val normal
          (montoImpuestos = val), 
          (this.sumatoriaIgv = val2);
          }
        }
        this.montoTotalImpuestos = montoImpuestos;
        this.sumatoriaIgvGratuitas = valGratuita;
        if(this.emisionrapidaIgv !='' && !this.editarConFacturaRapida){
          return valEnvio
        }else{
          return val.toFixed(2);
        } 
      },
      accumulateTaxes: function() {
        var val = 0.0;
        this.items.forEach(function(element) {
          val += parseFloat(element.montoAfectacionIgv);
        });
        this.sumatoriaIgv = val;
        return val.toFixed(2);
      },
      accumulateRecordedSale: function() {
        
        let val = 0.0;
        let valGrabadaAnticipos = 0.0;
        let valEnvio = 0.0;
        let codigotribu = 0.0;
        let totalVentaGravadaTemp = 0.0;
        this.items.forEach(function(element) {
          if (element.tipoAfectacionIgv == "10") {
            val += parseFloat(element.valorVenta);
          }
          codigotribu = element.codigoTributo 
        });

        this.selectedAnticipos.forEach(function(element) {
          if (element.tipoAfectacion == 10) {
            valGrabadaAnticipos += parseFloat(element.montoAnticipadoValor);
          }
        });
        
        if(this.selectedAnticipos.length > 0 && valGrabadaAnticipos > 0) {
            totalVentaGravadaTemp = val;
            if(codigotribu =='1000'){
              this.valGrabadaAnticipos = valGrabadaAnticipos;
            }else{
                let v1 = valGrabadaAnticipos
                let v2 = (v1 * (this.$store.state.igv == 18 ? 0.18 : 0.105)); //0.18 
                this.valGrabadaAnticipos = (v1 + v2 ) ;
            }      
        }
        if(this.valorGlobal > 0){
          totalVentaGravadaTemp = val
          this.valDescuentoGlobal = this.valorGlobal;
          // totalVentaGravadaTemp = val - this.valorGlobal;
            // val = this.totalVentaGravada;
        }

        if(this.selectedAnticipos.length == 0 && this.valGrabadaAnticipos == 0 && this.valDescuentoGlobal == 0){
            this.valGrabadaAnticipos = 0; 
            this.valDescuentoGlobal = 0;
            if(this.emisionrapidaGravada !='' && !this.editarConFacturaRapida){
              valEnvio = this.emisionrapidaGravada
              totalVentaGravadaTemp = val;
            }else{
              totalVentaGravadaTemp = val;
            }
        }

        if(this.emisionrapidaGravada !=''&& !this.editarConFacturaRapida){
          if(this.emisionrapida.itemsrapidos.length > 0){
            this.totalVentaGravada = totalVentaGravadaTemp;
          }
          return valEnvio; 
        }else{
          this.totalVentaGravada = totalVentaGravadaTemp;
          return val.toFixed(2);
        } 
      },
      accumulateExoneratedSale: function() {
        let val = 0.0;
        let valExoneradoAnticipos = 0.0;
        this.items.forEach(function(element) {
          if (element.tipoAfectacionIgv == "20") {
            val += parseFloat(element.valorVenta);
          }
        });
        this.selectedAnticipos.forEach(function(element) {
          if (element.tipoAfectacion == 20) {
            valExoneradoAnticipos += parseFloat(element.montoAnticipadoExonerado);
          }
        });
        if (this.selectedAnticipos.length > 0 && valExoneradoAnticipos > 0) {
          this.totalVentaExonerada = val - valExoneradoAnticipos;
          this.totalVentaExonerada2 = val;
        } else {
          this.totalVentaExonerada = val;
          this.totalVentaExonerada2 = val;
        }
        return val.toFixed(2);
      },
      accumulateUnaffectedSale: function() {
        var val = 0.0;
        let valInafectaAnticipos = 0.0;
        this.items.forEach(function(element) {
          if (element.tipoAfectacionIgv == "30") {
            val += parseFloat(element.valorVenta);
          }
        });
        this.selectedAnticipos.forEach(function(element) {
          if (element.tipoAfectacion == 30) {
            valInafectaAnticipos += parseFloat(element.montoAnticipadoInafecto);
          }
        });
        if (this.selectedAnticipos.length > 0 && valInafectaAnticipos > 0) {
          this.totalVentaInafecta = val - valInafectaAnticipos;
          this.totalVentaInafecta2= val;
        } else {
          this.totalVentaInafecta = val;
          this.totalVentaInafecta2= val;
        }
        return val.toFixed(2);
      },
      accumulateFreeSale: function() {
        var val = 0.0;
        this.items.forEach(function(element) {
          if (
                  element.tipoAfectacionIgv == "11" ||
                  element.tipoAfectacionIgv == "12" ||
                  element.tipoAfectacionIgv == "13" ||
                  element.tipoAfectacionIgv == "14" ||
                  element.tipoAfectacionIgv == "15" ||
                  element.tipoAfectacionIgv == "16" ||
                  element.tipoAfectacionIgv == "31" ||
                  element.tipoAfectacionIgv == "32" ||
                  element.tipoAfectacionIgv == "33" ||
                  element.tipoAfectacionIgv == "34" ||
                  element.tipoAfectacionIgv == "35" ||
                  element.tipoAfectacionIgv == "36" ||
                  element.tipoAfectacionIgv == "21"
          ) {
            val += parseFloat(element.valorVenta);
          }
        });
        this.totalVentaGratuita = val;
        return val.toFixed(2);
      },
      accumulateExportSale: function() {
        var val = 0.0;
        let valExportacionAnticipos = 0.0;
        this.items.forEach(function(element) {
          if (element.tipoAfectacionIgv == "40") {
            val += parseFloat(element.valorVenta);
          }
        });

        this.selectedAnticipos.forEach(function(element) {
          if (element.tipoAfectacion == 40) {
            valExportacionAnticipos += parseFloat(element.montoAnticipadoExportacion);
          }
        });
        if(this.selectedAnticipos.length > 0 && valExportacionAnticipos > 0){
          this.totalVentaExportacion = val - valExportacionAnticipos;
          this.totalVentaExportacion2 = val;
        }else{
          this.totalVentaExportacion = val;
          this.totalVentaExportacion2 = val;
        }
        return val.toFixed(2);
      },
      accumulateTotalSale: function() {
        let val = 0.0;
        if (
                this.totalVentaGravada != 0 ||
                this.totalVentaInafecta != 0 ||
                this.totalVentaExonerada != 0 ||
                this.totalVentaExportacion != 0 ||
                this.accumulateICBPER() != 0
        ) {
          val =
                  this.montoTotalImpuestos +
                  this.totalVentaGravada +
                  this.totalVentaInafecta +
                  this.totalVentaExonerada +
                  this.totalVentaExportacion +
                  this.sumatoriaOtrosCargos  +
                  this.sumatoriaOtrosCargosProducto +
                  this.accumulateICBPER() -
                  this.valGrabadaAnticipos -
                  this.valDescuentoGlobal
                  

                  this.baseCargo = this.importeTotal - this.sumatoriaOtrosCargos;
                  this.importeTotal = val; 
                                          
        } else {
          this.importeTotal = 0;
          this.baseCargo = 0;
        }
        return val.toFixed(2);
      },
      montoDetraccionCalc: function() {
        let val = 0.0;
        this.montoDetraccion = (this.importeTotal * parseFloat(this.detraccion.porcentajeDetraccion)) / 100;
       if(this.moneda.codigo == 'USD'){
          val = (this.tipocambiomonedadolar.venta) * (this.montoDetraccion);
       }else{
         if(this.montoDetraccion!=''){
          val = this.montoDetraccion.toFixed(0);
         }
       }
        return val;
      },
      addDescuentosGlobales(){
        this.descuentoItemMontoG = parseFloat(this.descuentoItemMontoG);
        if(this.accumulateTotalSale() > 0){
          if(this.descuentoItemMontoG <= this.accumulateTotalSale()){
            let desctglobal = {
              indicador: "",
              codigoCargoDescuento: "",
              factorCargoDescuento:"",
              montoCargoDescuento: "",
              baseCargoDescuento: ""
            }
            let valorDes ={
              monto:""
            }
            if(this.descuentoItemMontoG != "" || this.descuentoItemPorcentajeG != ""){
                this.valorGlobal = this.descuentoItemMontoG / (this.$store.state.igv == 18 ? 1.18 : 1.105) ; //1.18
                desctglobal.indicador = "descuento",
                desctglobal.codigoCargoDescuento = "02"
                desctglobal.factorCargoDescuento = parseFloat((this.valorGlobal / this.valortotal()).toFixed(5));                           
                desctglobal.baseCargoDescuento = parseFloat(this.valortotal().toFixed(2));
                desctglobal.montoCargoDescuento = parseFloat(((desctglobal.factorCargoDescuento)*desctglobal.baseCargoDescuento).toFixed(2))
                this.cargosDescuentosGlobales.push(desctglobal)
                this.$snotify.success("Descuento Agregado");

                valorDes.monto = this.descuentoItemMontoG
                this.listarMontos.push(valorDes)
            }else{
              this.$snotify.warning("El monto debe ser mayor a 0", "Cuidado");
            }
          }else{
            this.$snotify.warning("El monto del descuento no puede ser mayor al total de la venta", "Cuidado");
          }
        }else{
          this.$snotify.warning("Venta Total debe ser mayor que Cero", "Cuidado");
        }
      },
      borrarDescuento: function (index) {
            this.listarMontos.splice(index,1)
            this.cargosDescuentosGlobales.splice(index,1)
            if(this.listarMontos.length <= 0){
              this.descuentoItemMontoG = ''
              this.valorGlobal = ''
              // this.cargosDescuentosGlobales = []
              this.listarMontos = []
              this.gravado = false
            }        
      },
      accumulatedescuentoG(){
       let val = 0.0;
        this.cargosDescuentosGlobales.forEach(function(element) {
          if(element.codigoCargoDescuento == '02'){
            val = parseFloat(element.montoCargoDescuento);
          }
        });
        return val.toFixed(2);
      },
      valortotal(){
                let val = 0.0;
                this.items.forEach(function(element){
                    if(element.valorTotal !=''){
                         val += parseFloat(element.valorVenta);
                    }
                })
                return val;
         },
      accumulateDescuento: function() {
        var val = 0.0;
        this.items.forEach(function(element) {
          val += parseFloat(element.descuento);
        });
        this.totalDescuentosAcumulados = val;
        return val.toFixed(2);
      },
       accumulateICBPER: function() {
          let total = 0.0;
        this.items.forEach(function(element) {
          if (element.afectoIcbper) {
           total = total +(0.5 * element.cantidad);
          }
        });
        return total;
       },
       sumadetracciontrasporte(value){
         let recive = value
         let sumadetraccion = 0.00
         recive.forEach(function(element){
           sumadetraccion += parseFloat(element.valorTrasporte)
         })  
         this.totaldetraccion = sumadetraccion    
      },
      addItem: function() {
        let tasabolsa = 0;
        let item = {
          valorVentaSinAfectar: 0,
          tipoAfectacionIgv: 0,
          codigoTributo: "",
          idProducto: "-",
          codigoProductoSunat: "",
          unidadMedidaCantidad: "",
          cantidad: "",
          descripcion: "",
          valorUnitario: "",
          tipoPrecioVentaUnitario: "",
          descuento: "",
          porcentajeDescuento: "",
          baseAfectacionIgv: "",
          valorUnitarioVista: "",
          valorVenta: "",
          valorVentaVista: "",
          porcentajeImpuesto: "",
          montoAfectacionIgv: "",
          montoTotalImpuestosItem: "",
          precioVentaUnitario: "",
          adicional: {
            indicardorDsct:'',
            dsctSoles:'',
            dsctPorcentaje:'',
            precioVentaUni:'',
            precioTotalIGV:0.0,
            servicioTransporteCarga: {
              detalleTramos: []
            },
            transporteTerrestrePasajeros: {}
          },
          cargosDescuentosItem:[{}],
          iscOtrosTributosItem:[]
        };
        // item.stock = this.stock,
        item.valorVentaSinAfectar = parseFloat((this.valorUnitario * this.cantidad));
        item.tipoAfectacionIgv = this.especificacion.codigo;
        if (this.codigoProducto != "") {
          item.codigoProducto = this.codigoProducto;
        }
        if (!this.vbarras) {
          if (this.codigoSunatBarras != null) {
            item.codigoProductoSunat = this.codigoSunatBarras;
          } else {
            delete item.codigoProductoSunat;
          }
        } else {
          if (this.codigoProductoGs1 != "") {
            item.codigoProductoGs1 = this.codigoProductoGs1;
            delete item.codigoProductoSunat;
          } else {
            delete item.codigoProductoGs1;
          }
        }
        item.idProducto = this.idProducto;
        item.unidadMedidaCantidad = this.unidadMedidaCantidad;
        item.cantidad = parseFloat(this.cantidad);
        item.descripcion = this.descripcion;
        item.valorUnitario = parseFloat(this.valorUnitario);
        if (
                this.especificacion.codigo == "10" ||
                this.especificacion.codigo == "20" ||
                this.especificacion.codigo == "30"
        ) {
          item.tipoPrecioVentaUnitario = "01";
        } else {
          item.tipoPrecioVentaUnitario = "02";
        }
        if (this.descuentoItemMonto != "" && this.especificacionIgv == "01") {
            item.adicional.indicardorDsct = '01'
            item.adicional.dsctSoles = parseFloat(this.descuentoItemMonto)
            item.descuento = parseFloat(parseFloat(this.descuentoItemMonto / (this.$store.state.igv == 18 ? 1.18 : 1.105)).toFixed(10)); //1.18
            item.porcentajeDescuento = parseFloat(this.descuentoItemMonto / (this.$store.state.igv == 18 ? 1.18 : 1.105)) / item.valorVentaSinAfectar;   //1.18    
            delete item.adicional.dsctPorcentaje;
       } else if ( this.descuentoItemMonto != "" && (this.especificacionIgv == "02" || this.especificacionIgv == "03")) {
            item.adicional.dsctSoles = parseFloat(this.descuentoItemMonto)
            item.adicional.indicardorDsct = '01'
            item.descuento = parseFloat(this.descuentoItemMonto).toFixed(10);
            item.porcentajeDescuento = parseFloat(this.descuentoItemMonto) / item.valorVentaSinAfectar;
            this.inafecto = (item.valorVentaSinAfectar  - this.descuentoItemMonto)/item.cantidad;
            delete item.adicional.dsctPorcentaje;
        } else if (this.descuentoItemPorcentaje != "") {
            item.adicional.indicardorDsct = '02'
            item.adicional.dsctPorcentaje = parseFloat(this.descuentoItemPorcentaje)
            item.descuento = ((this.descuentoItemPorcentaje / 100) * item.valorUnitario * item.cantidad).toFixed(10);
            item.porcentajeDescuento = this.descuentoItemPorcentaje / 100;
            delete item.adicional.dsctSoles;
        } else {
          item.descuento = parseFloat(0.0);
          item.porcentajeDescuento = parseFloat(0.0);
          delete item.cargosDescuentosItem;
          item.cargosDescuentosItem = [];
          delete item.adicional.indicardorDsct;
          delete item.adicional.dsctSoles;
          delete item.adicional.dsctPorcentaje;
        }
        if (item.descuento == 0) {
          item.baseAfectacionIgv = parseFloat(((item.valorUnitario) * (item.cantidad)));
          delete item.cargosDescuentosItem;
          item.cargosDescuentosItem = []
        } else {
          item.baseAfectacionIgv = parseFloat(((item.valorUnitario * item.cantidad) - (item.descuento)));
        }
        // Bloque de las gratuitas
        if (this.ventaGratuita) {
          item.valorUnitario = parseFloat(0.0);
          item.valorUnitarioVista = parseFloat(this.valorUnitario);

          item.valorVenta = parseFloat(this.precioVentaUnitario * this.cantidad);

          item.valorVentaVista = (0.0);
          this.valorDesctGlobal = item.valorVenta;

          item.baseAfectacionIgv = this.precioVentaUnitario * this.cantidad;
          item.montoAfectacionIgv = item.baseAfectacionIgv * (this.$store.state.igv == 18 ? 0.18 : 0.105); //0.18
          item.montoTotalImpuestosItem = parseFloat(0.0);
 
        } else {
          item.valorUnitario = parseFloat((this.valorUnitario));
          item.valorUnitarioVista = item.valorUnitario;
          item.valorVenta = parseFloat((item.baseAfectacionIgv));
          item.valorVentaVista = item.valorVenta;
          this.valorDesctGlobal = item.valorVenta;
        }
        if (this.especificacionIgv == "01" && this.ventaGratuita == false) {       
            if(this.vunitario == true){
              item.montoAfectacionIgv = parseFloat(((item.baseAfectacionIgv) * ((this.$store.state.igv == 18 ? 0.18 : 0.105)))); //0.18
              item.montoTotalImpuestosItem = parseFloat(item.montoAfectacionIgv);        
            }else{
              item.montoAfectacionIgv = parseFloat(((item.baseAfectacionIgv) * ((this.$store.state.igv == 18 ? 0.18 : 0.105)))); //0.18
              item.montoTotalImpuestosItem = parseFloat(item.montoAfectacionIgv);
            }  
        } else if (
                this.especificacionIgv == "02" ||
                this.especificacionIgv == "03"
        ) {
          item.montoAfectacionIgv = parseFloat(0.0);
          item.montoTotalImpuestosItem = parseFloat(item.montoAfectacionIgv);
        }
        if (this.tipoOperacion == "0200") {
              (item.codigoTributo = "9995"),
              (item.tipoAfectacionIgv = "40"),
              (item.montoAfectacionIgv = parseFloat(0.0));
               item.montoTotalImpuestosItem = parseFloat(item.montoAfectacionIgv);
        } else {
          item.codigoTributo = this.especificacion.codigoTributo;
        }
        // item.tipoAfectacionIgv == '20' || item.tipoAfectacionIgv == '30' || item.tipoAfectacionIgv == '40'
        if (
                item.tipoAfectacionIgv == "20" ||
                item.tipoAfectacionIgv == "21" ||
                item.tipoAfectacionIgv == "30" ||
                item.tipoAfectacionIgv == "31" ||
                item.tipoAfectacionIgv == "32" ||
                item.tipoAfectacionIgv == "33" ||
                item.tipoAfectacionIgv == "34" ||
                item.tipoAfectacionIgv == "35" ||
                item.tipoAfectacionIgv == "36" ||
                item.tipoAfectacionIgv == "37" ||
                item.tipoAfectacionIgv == "40"
        ) {
          item.porcentajeImpuesto = 0;
        } else if (
                item.tipoAfectacionIgv == "10" ||
                item.tipoAfectacionIgv == "11" ||
                item.tipoAfectacionIgv == "12" ||
                item.tipoAfectacionIgv == "13" ||
                item.tipoAfectacionIgv == "14" ||
                item.tipoAfectacionIgv == "15" ||
                item.tipoAfectacionIgv == "16"
        ) {
          item.porcentajeImpuesto = (this.$store.state.igv == 18 ? 18 : 10.5); //18
        }

        item.adicional.precioVentaUni = parseFloat(this.precioVentaUnitario)
        item.precioVentaUnitario = parseFloat(this.precioVentaUnitario);
        // ISC
        if(this.isc){
          if(this.selectedISC == 1){
            let valorVentaTipo1  = this.valorUniSinIsC * item.cantidad
            let igvTipo1 = valorVentaTipo1 * (this.$store.state.igv == 18 ? 0.18 : 0.105); // 0.18
            let iscValor = (this.montoISC/100) * valorVentaTipo1;
            let impuesto1 =  ((valorVentaTipo1 + iscValor) * (this.$store.state.igv == 18 ? 0.18 : 0.105)) + iscValor ; //0.18
            let precioISC = this.precioVentaUnitario * (this.montoISC/100);
            let precioSumaISC = parseFloat(this.precioVentaUnitario) + parseFloat(precioISC);
            item.precioVentaUnitario = parseFloat(precioSumaISC);
            item.valorVenta = valorVentaTipo1
            item.valorUnitario = this.valorUniSinIsC      

            let baseAfecta1 = (valorVentaTipo1 * (this.montoISC/100)) + valorVentaTipo1;
            let montoAfecta1 = (valorVentaTipo1 + iscValor)*(this.$store.state.igv == 18 ? 0.18 : 0.105); //0.18

            item.montoTotalImpuestosItem = parseFloat(parseFloat(impuesto1).toFixed(2));
            item.baseAfectacionIgv = parseFloat(parseFloat(baseAfecta1).toFixed(2))
            item.montoAfectacionIgv = parseFloat(parseFloat(montoAfecta1).toFixed(2))
          }else if(this.selectedISC == 2){
            let valorVentaTipo2 = this.valorUniSinIsC * item.cantidad;
            let precioUniConISC = (parseFloat(this.montoISC/100) * parseFloat(this.precioVentaUnitario)) + parseFloat(this.precioVentaUnitario);
            let nuevoValorVenta = parseFloat(valorVentaTipo2) + parseFloat(this.montoISC)
            
            item.precioVentaUnitario = parseFloat(precioUniConISC)
            item.valorVenta = valorVentaTipo2
            item.valorUnitario = this.valorUniSinIsC
            //montoTotalImpuestosItem
            let igvTipo2 = parseFloat(this.precioVentaUnitario) * (this.montoISC/100); 
            let impuestosISC = parseFloat(igvTipo2) * (this.cantidad);
            let valor3 = parseFloat(valorVentaTipo2) * (this.$store.state.igv == 18 ? 0.18 : 0.105); //0.18
            let sumaValoresIGV = parseFloat(impuestosISC) + parseFloat(valor3);
            item.montoTotalImpuestosItem =  parseFloat(sumaValoresIGV);

            //baseAfectacionIgv
             let baseAfecta2 = parseFloat(this.valorUniSinIsC) * parseFloat(this.cantidad);
             let vBase = parseFloat(baseAfecta2) * (this.montoISC/100);
             let sumaBase = parseFloat(baseAfecta2) + parseFloat(vBase);
            item.baseAfectacionIgv = parseFloat(sumaBase);

            //montoAfectacionIgv
            let montoAfecta = parseFloat(valorVentaTipo2 * (this.$store.state.igv == 18 ? 0.18 : 0.105)); //0.18
            let montoAfecta2 = parseFloat(montoAfecta)* parseFloat(this.montoISC/100);//1.8
            let sumaAfecta2 = parseFloat(montoAfecta) + parseFloat(montoAfecta2);
            item.montoAfectacionIgv = parseFloat(parseFloat(sumaAfecta2).toFixed(2));
          }else if(this.selectedISC == 3){
              let valorVen = this.valorUniSinIsC * item.cantidad;

              let precioUniISC = (parseFloat(this.valorSugerido/100) * parseFloat(this.precioVentaUnitario)) + parseFloat(this.precioVentaUnitario);
              item.precioVentaUnitario = parseFloat(precioUniISC);
              let valorVentaTipo3 = this.valorUniSinIsC * item.cantidad;
              item.valorVenta = valorVentaTipo3;
              item.valorUnitario = this.valorUniSinIsC
              //montoTotalImpuestosItem3
              let vI1 = parseFloat(this.precioVentaUnitario) * (this.valorSugerido/100);
              let vI2 = parseFloat(vI1) * (this.cantidad);
              let vI3 = parseFloat(valorVen) * (this.$store.state.igv == 18 ? 0.18 : 0.105); //0.18
              let sumaMI = parseFloat(vI2) + parseFloat(vI3);
              item.montoTotalImpuestosItem =  parseFloat(sumaMI);
              //baseAfectacionIgv3
              let vBA1 = parseFloat(this.valorUniSinIsC) * parseFloat(this.cantidad);
              let vBA2 = parseFloat(vBA1) * (this.valorSugerido/100);
              let sumaBA = parseFloat(vBA1) + parseFloat(vBA2);
              item.baseAfectacionIgv = parseFloat(sumaBA);
              //montoAfectacionIgv
              let vMA1 = parseFloat(valorVen * (this.$store.state.igv == 18 ? 0.18 : 0.105)); //0.18
              let vMA2 = parseFloat(vMA1) * parseFloat(this.valorSugerido/100);
              let sumaMA = parseFloat(vMA1) + parseFloat(vMA2);
              item.montoAfectacionIgv = parseFloat(parseFloat(sumaMA).toFixed(2));
          }
              let iscItems = {
                  baseTributo:"",
                  montoTributo:"",
                  tasaTributo: "",
                  tipoSistemaIsc: "",
                  codigoTributo: "2000"             
              }
              if(this.selectedISC == 1 || this.selectedISC == 2){
                iscItems.baseTributo = parseFloat((item.valorVenta).toFixed(2))
                iscItems.montoTributo = parseFloat((item.valorVenta * (this.montoISC/100)).toFixed(2))              
                iscItems.tasaTributo = parseFloat(this.montoISC)
              }else if(this.selectedISC == 3){
                iscItems.baseTributo = parseFloat(this.montoISC) * parseFloat(this.cantidad)
                iscItems.tasaTributo = parseFloat(this.porcentajeISC)
                iscItems.montoTributo = parseFloat(((iscItems.baseTributo * iscItems.tasaTributo)/100).toFixed(2))              
                
              }
              iscItems.tipoSistemaIsc = this.iscCodigo,
              item.iscOtrosTributosItem.push(iscItems)
              this.montoISC = '';
              this.porcentajeISC = '';
              this.isc = false;
              item.adicional.precioTotalIGV = parseFloat(item.valorVenta) + parseFloat(item.montoTotalImpuestosItem);
            }else{
              delete item.iscOtrosTributosItem
            }
        // Descuento por item
        if (item.descuento != 0) {
          if(this.descuentoItemMonto != "" &&(this.especificacionIgv == "02" || this.especificacionIgv == "03")){
            item.precioVentaUnitario = this.inafecto; 
            item.cargosDescuentosItem[0].indicador= "descuento";
            (item.cargosDescuentosItem[0].codigoCargoDescuento= "00");
            (item.cargosDescuentosItem[0].factorCargoDescuento = parseFloat(parseFloat(item.porcentajeDescuento).toFixed(5)));
            item.cargosDescuentosItem[0].montoCargoDescuento = parseFloat(parseFloat(item.descuento).toFixed(2));
            item.cargosDescuentosItem[0].baseCargoDescuento = parseFloat(parseFloat(item.valorVentaSinAfectar).toFixed(2));
          }else{
          if(this.cantidad >= 0){
            this.montoValorUnitario2 = ( item.valorUnitario - (item.descuento/item.cantidad)); 
            this.montoIgvGlobal = this.montoValorUnitario2 * (this.$store.state.igv == 18 ? 0.18 : 0.105); // 0.18
            if(this.tipoOperacion == "0200"){
              let descPorcen = this.precioVentaUnitario * item.porcentajeDescuento
              item.precioVentaUnitario = (this.precioVentaUnitario - descPorcen)
            }else{
              if(item.descuento != 0){
                let desc = this.precioVentaUnitario * item.porcentajeDescuento
                item.precioVentaUnitario = (this.precioVentaUnitario - desc)
              }else{
                item.precioVentaUnitario = this.montoValorUnitario2 + this.montoIgvGlobal;
              }
            }
            item.cargosDescuentosItem[0].indicador= "descuento";
            (item.cargosDescuentosItem[0].codigoCargoDescuento= "00");
            (item.cargosDescuentosItem[0].factorCargoDescuento = parseFloat(parseFloat(item.porcentajeDescuento).toFixed(5)));     
            item.cargosDescuentosItem[0].baseCargoDescuento = parseFloat(parseFloat(item.valorVentaSinAfectar).toFixed(2));
            item.cargosDescuentosItem[0].montoCargoDescuento = parseFloat(parseFloat(item.cargosDescuentosItem[0].factorCargoDescuento * item.cargosDescuentosItem[0].baseCargoDescuento).toFixed(2));
          }else{
            item.precioVentaUnitario = item.baseAfectacionIgv + item.montoAfectacionIgv; 
            item.cargosDescuentosItem[0].indicador= "descuento";
            (item.cargosDescuentosItem[0].codigoCargoDescuento= "00");
            (item.cargosDescuentosItem[0].factorCargoDescuento = parseFloat(parseFloat(item.porcentajeDescuento).toFixed(5)));
            item.cargosDescuentosItem[0].montoCargoDescuento = parseFloat(parseFloat(item.descuento).toFixed(2));
            item.cargosDescuentosItem[0].baseCargoDescuento = parseFloat(parseFloat(item.valorVentaSinAfectar).toFixed(2));
            }
          }
        }else if(this.otrosCargosProducto !=null && this.otrosCargosProducto > 0){
          let otrocargo = {
          indicador: "",
          codigoCargoDescuento: "",
          factorCargoDescuento: "",
          montoCargoDescuento: "",
          baseCargoDescuento: "",
        };
          otrocargo.indicador = "cargo",
          otrocargo.codigoCargoDescuento =  "48"
          otrocargo.factorCargoDescuento = parseFloat((this.otrosCargosProducto/100).toFixed(5))
          // otrocargo.baseCargoDescuento = parseFloat(((this.valorUnitario) / (this.cantidad)).toFixed(2)),
          otrocargo.baseCargoDescuento = parseFloat((this.precioVentaUnitario / (otrocargo.factorCargoDescuento +(this.$store.state.igv == 18 ? 1.18 : 1.105) )).toFixed(2)), //1.18
          otrocargo.montoCargoDescuento = parseFloat(((otrocargo.baseCargoDescuento)*(otrocargo.factorCargoDescuento)).toFixed(2))
          item.cargosDescuentosItem.push(otrocargo);
          this.otrosCargosProductoAgregados = item.cargosDescuentosItem;
          item.precioVentaUnitario = parseFloat(this.precioVentaUnitario) + parseFloat(otrocargo.montoCargoDescuento)
        }else {
         delete item.cargosDescuentosItem;
        //  item.cargosDescuentosItem = []
        }
        if (this.itemsDetraccionCheck) {
          item.adicional.servicioTransporteCarga = this.adicionalDetraccion.servicioTransporteCarga;
        } else {
          delete item.adicional.servicioTransporteCarga;
        }
        if (Object.values(item.adicional).length == 0) {
          delete item.adicional;
        }
        if(this.tipoOperacion =="0101EDU"){
          item.adicional.transporteTerrestrePasajeros.numeroAsiento = this.aula;
          item.adicional.transporteTerrestrePasajeros.informacionManifiesto = this.gradoYseccion;
          item.adicional.transporteTerrestrePasajeros.tipoDocumentoPasajero = "1";
          item.adicional.transporteTerrestrePasajeros.numeroDocumentoPasajero = this.dniAlumno;
          item.adicional.transporteTerrestrePasajeros.nombresApellidosPasajero = this.nomApeAlumno;
          item.adicional.transporteTerrestrePasajeros.ubigeoLugarOrigen = this.ubigeoOrigenDom;
          item.adicional.transporteTerrestrePasajeros.direccionDetalladaOrigen = this.direccionDomAlumno;
          item.adicional.transporteTerrestrePasajeros.ubigeoLugarDestino = this.ubigeoDestinoDom;
          item.adicional.transporteTerrestrePasajeros.direccionDetalladaDestino = this.direccionColegio;
          item.adicional.transporteTerrestrePasajeros.fechaInicioProgramado = this.$moment(this.periodoAcademido).format("YYYY-MM-DD")
        }
        if(this.descuentaStock == '1'){
          item.descuentaStock = 1
        }else if(this.descuentaStock =='2'){
          item.descuentaStock = 2
        }
        // tasaicbper = tasaicbper(this.fechaEmision) version futura
        tasabolsa = tasaicbper();
        // Impuestos a las bolsas plasticas
        if (this.icbper) {
          item.precioVentaUnitario = parseFloat(this.precioVentaUnitario);
          item.montoTotalImpuestosItem = item.montoTotalImpuestosItem + (item.cantidad * 0.50);
          item.afectoIcbper = this.icbper;
          this.icbper = false;
        } else {
          item.afectoIcbper = false;
        }
        if (this.setIndex != -1) {
          Object.assign(this.items[this.setIndex], item);
          this.$snotify.warning("Item Actualizado Correctamente", "Atencion"),
                  (this.setIndex = -1);
          (this.setUpdateItem = false), this.initItem();
        } else {
          if (
                  parseFloat(item.descuento) >
                  parseFloat(item.valorUnitario * item.cantidad)
          ) {
            this.$snotify.warning(
                    "El descuento no puede ser mayor al valor total por item",
                    "Cuidado"
            );
          } else {
            this.items.push(item), this.initItem();
            this.vbarras = false;
          }
        }
        if (this.items.length > 0) {
          this.buttonRegularizacionAnticipos = false;
        }
        (this.adicionalDetraccion = {
          servicioTransporteCarga: {
            ubigeoOrigen: "",
            direccionOrigen: "",
            ubigeoDestino: "",
            direccionDestino: "",
            detalleViaje: "",
            valorReferencialServicioTransporte: 0,
            valorReferencialCargaActiva: 0,
            valorReferencialCargaUtil: 0,
            detalleTramos: []
          }
        }),
                (this.itemsDetraccionCheck = false);
                this.gravado = false;
                this.modalEditarAdicionales = false;
                this.sumaISC();
                if(this.itemEditado == false){
                  this.actualizarItemsLista();
                }
                this.scanerCodigo = false;
      },
      actualizarItemsLista(){
        let codigo
        if(this.items.length > 0){
          this.items.forEach(element => {
            codigo = element.codigoProducto
          });
        }
        this.actualizarItem(codigo)
      },
      actualizarItem(codigo){
            axios
            .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                token: this.$store.getters.userToken,
                filtro: 'code',
                p: codigo
            })
            .then(response => (
                this.reciveArrayActualizado = response.data.response,
                this.editarStockItem(this.reciveArrayActualizado)
                // this.cargandoInformacion = false,
                // this.filtrandoItem(this.reciveArrayActualizado,item.codigo)
            ))
            .catch(error => ( 
                   console.log(error)
            ))
          
      },
      editarStockItem(array){
        this.items = this.items.map(item => {
          // Busca la actualización por el id del producto
        const actualizacion = array.find(act => act.idProducto === item.idProducto);
          // Si se encontró una actualización, actualiza el stock
          if (actualizacion) {
            item.stock = actualizacion.stock;
          }
          // Devuelve el item actualizado o sin cambios al array items
          return item;  
        });
      },
      busquedaCodigoItem(codigo){
        this.cargandoCodBarras = true;
            axios
            .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                token: this.$store.getters.userToken,
                filtro: 'code',
                p: codigo
            })
            .then(response => (
              this.cargandoCodBarras = false,
              this.listaProductCod = true,
              this.resultadoCodProducto = response.data.response  
                // this.buscaItemCodigo()
            ))
            .catch(error => ( 
              this.cargandoCodBarras = false,
                   console.log(error)
            ))
      },
      sumaISC(){
        let totalISC = 0.0;
        this.items.forEach(element => {
          if(element.iscOtrosTributosItem && element.iscOtrosTributosItem !=''){
              element.iscOtrosTributosItem.forEach(element => {
              totalISC += element.montoTributo
            });
          }
        });
        return totalISC
      },
      initItem: function() {
        this.descuentaStock = "";
        (this.descuento = false),
                (this.cantidad = 1),
                (this.codigoProducto = ""),
                (this.codigoTributo = ""),
                (this.tipoAfectacionIgv = ""),
                (this.descripcion = ""),
                (this.precioVentaUnitario = ""),
                (this.valorUnitario = ""),
                (this.codigoSunatBarras = ""),
                (this.codigoProductoGs1 = ""),
                (this.descuentoItemMonto = ""),
                (this.descuentoItemPorcentaje = ""),
                (this.descuento = false),
                (this.unidadMedidaCantidad = "NIU"),
                (this.especificacionIgv = "01");
        (this.ventaGratuita = false), (this.idProducto = "-");
      },
      deleteItem: function(index) {
        this.$swal({
          title: "Eliminar Item",
          text: "Seguro de eliminar este item ???",
          icon: "error",
          buttons: true,
          dangerMode: true
        }).then(willDelete => {
          if (willDelete) {
            this.items.splice(index, 1);
            // this.totalcuotas = 0.0
            // this.limpiarCuotas();
            if (this.items.length == 0) {       
              this.buttonRegularizacionAnticipos = true;
              this.disabledAnticipo = false;
              this.descuentoItemMontoG = ''
              this.valorGlobal = ''
              this.cargosDescuentosGlobales = []
              this.listarMontos = []
            }
          } else {
          }
        });
      },        
      addGuia: function() {
        let guias = {};
        (guias.serie = this.seriedeguia), (guias.numero = this.numerodeguia);
        if (this.tipodeguia == "09") {
          guias.tipoGuia2 = "Guia Remision Remitente";
        } else if (this.tipodeguia == "31") {
          guias.tipoGuia2 = "Guia Remision Transportista";
        }
        (guias.tipo = this.tipodeguia),
                (this.itemGuia.numero = this.seriedeguia + "-" + this.numerodeguia);
        this.itemGuia.tipo = this.tipodeguia;
        this.items_guias.push(guias);
        this.guiasRelacionada.push(this.itemGuia);
        this.itemGuia = {};
        this.seriedeguia = "";
        this.numerodeguia = "";
        this.tipoguialock = true;
      },
      deleteGuia: function(index) {
        this.items_guias.splice(index, 1);
        this.guiasRelacionada.splice(index, 1);
        this.seriedeguia = "";
        this.numerodeguia = "";
        if (this.items_guias.length == 0) {
          this.tipoguialock = false;
        }
      },
      addDocRelacionado: function() {
        let relacionados = {};
        relacionados.numerorelacionado = this.numerorelacionado;
        if (this.docRelacionado == "01") {
          relacionados.tipoRelacionadoDescripcion =
                  "Factura – emitida para corregir error en el RUC";
        } else if (this.docRelacionado == "02") {
          relacionados.tipoRelacionadoDescripcion =
                  "Factura – emitida por anticipos";
        } else if (this.docRelacionado == "03") {
          relacionados.tipoRelacionadoDescripcion =
                  "Boleta de Venta – emitida por anticipos";
        } else if (this.docRelacionado == "04") {
          relacionados.tipoRelacionadoDescripcion = "Ticket de Salida - ENAPU";
        } else if (this.docRelacionado == "05") {
          relacionados.tipoRelacionadoDescripcion = "Código SCOP";
        } else if (this.docRelacionado == "99") {
          relacionados.tipoRelacionadoDescripcion = "Otros";
        }
        relacionados.tipo = this.docRelacionado;
        this.itemRelacionado.numero = this.numerorelacionado;
        this.itemRelacionado.tipo = this.docRelacionado;
        this.items_relacionados.push(relacionados);
        this.docRelacionada.push(this.itemRelacionado);
        this.itemRelacionado = {};
        this.numerorelacionado = "";
        this.docrelacionadolock = true;
      },
      deleteDocRelacionado: function(index) {
        this.items_relacionados.splice(index, 1);
        this.docRelacionada.splice(index, 1);
        this.numerorelacionado = "";
        if (this.items_relacionados.length == 0) {
          this.docrelacionadolock = false;
        }
      },
      addAdicional: function() {
        this.itemAdicional.key = this.key;
        this.itemAdicional.value = this.value;
        this.items_adicionales.push(this.itemAdicional);
        this.itemAdicional = {};
        this.key = "";
        this.value = "";
      },
      deleteAdicional: function(index) {
        this.items_adicionales.splice(index, 1);
      },
      backItem: function(item) {
        this.add_update_item = false;
        //this.item = item
      },
      updateItem: function(index, itemUpdate) {
        this.itemEditado = true,
        this.editarConFacturaRapida = true
        this.modalEditarAdicionales = true
        //cambio momentaneo
        if(itemUpdate.adicional && itemUpdate.adicional.servicioTransporteCarga){
           this.editarAdicionales = itemUpdate.adicional.servicioTransporteCarga
        }
        let itemChange = itemUpdate;
        let item = {};
        this.setUpdateItem = true;
        this.setIndex = index;
        this.cantidad = itemChange.cantidad;
        this.unidadMedidaCantidad = itemChange.unidadMedidaCantidad;
        if(itemChange.codigoProducto){
          this.codigoProducto = itemChange.codigoProducto;
        }
        this.idProducto = itemChange.idProducto;
        if(itemChange.codigoProductoSunat && itemChange.codigoProductoSunat !=''){
          this.vbarras = false;
          this.codigoSunatBarras = itemChange.codigoProductoSunat;
        }else if(itemChange.codigoProductoGs1 !=''){
          this.vbarras = true;
          if(this.vbarras){
             this.codigoProductoGs1 = itemChange.codigoProductoGs1
          }
        }
        this.descripcion = itemChange.descripcion;   
        if(itemChange.adicional && itemChange.adicional.precioVentaUni !=''){
            this.precioVentaUnitario = itemChange.adicional.precioVentaUni
        }else{
            this.precioVentaUnitario = itemChange.precioVentaUnitario
        }
        this.valorUnitario = itemChange.valorUnitario;

        if(itemChange.adicional && itemChange.adicional.indicardorDsct == '01'){
            this.descuentoItemMonto = itemChange.adicional.dsctSoles
        }else if(itemChange.adicional && itemChange.adicional.indicardorDsct == '02'){
            this.descuento = true
            this.descuentoItemPorcentaje = itemChange.adicional.dsctPorcentaje
        }else{
            this.descuentoItemMonto = ''
            this.descuentoItemPorcentaje = ''
        }
        if(itemUpdate.tipoAfectacionIgv == "10"){
                this.especificacionIgv = '01'
            }else if(itemUpdate.tipoAfectacionIgv == "20"){
                this.especificacionIgv = '03'
            }else if(itemUpdate.tipoAfectacionIgv == "30"){
                this.especificacionIgv = '02'
            }
            //ISC
          if(itemChange.iscOtrosTributosItem){
            this.isc = true;
            this.cuadroISC = true;
            
            if(itemChange.iscOtrosTributosItem[0].tipoSistemaIsc == "01"){
              this.selectedISC = 1
              this.montoISC = itemChange.iscOtrosTributosItem[0].tasaTributo
            }else if(itemChange.iscOtrosTributosItem[0].tipoSistemaIsc == '02'){
              this.selectedISC = 2
              this.montoISC = itemChange.iscOtrosTributosItem[0].tasaTributo
            }else if(itemChange.iscOtrosTributosItem[0].tipoSistemaIsc == '03'){
              this.selectedISC = 3;
              this.montoISC = itemChange.iscOtrosTributosItem[0].baseTributo / (itemChange.cantidad)
              this.porcentajeISC = (itemChange.iscOtrosTributosItem[0].tasaTributo) ;
            }
          }
      },
      executeUpdate: function() {
        this.addItem();
      },
      insertarAdicionales: function(event) {
        let item = {
          nombre: this.adicionales.nombre,
          valor: this.adicionales.valor
        };
        this.adicionales.push(item);
        (this.adicionales.nombre = ""), (this.adicionales.valor = "");
      },
      sendPreviw: function(value) {
          let sumatotalcarga = 0.00
          this.items.forEach(function(element){
            if(element.adicional.servicioTransporteCarga){
              sumatotalcarga += parseFloat(element.adicional.servicioTransporteCarga.valorReferencialServicioTransporte)
            }else{

            }
          })
          this.totalsumadetraccion = sumatotalcarga
        if(this.selectedRetencion != null){
          this.retencionIgv()
        }else if(this.selectedRetencion == null){
          this.retencionIgvCredito = ''
          this.retencionIgv()
        }
        if (!value) {
          (this.previwEmit = true),
                  (this.invoicePrev.data = ""),
                  (this.invoicePrev.bandera = false);
        } else {
          this.typeInvoice == "1" ? (this.validadorseries = this.listaSeries.length) : (this.validadorseries = -1);
          if (this.validadorseries == 0) {
                this.$snotify.warning("Verifique que tenga una serie valida y que haya seleccionado un receptor!", "Cuidado"),
                (this.previwEmit = false);
          } else {
            this.previwEmit = false;
          }
        }
      },
      modalEmision(){
        this.check = true;
        (this.previwEmit = false),
        (this.invoicePrev.data = ""),
        (this.invoicePrev.bandera = false);
         setTimeout(() => this.sendInvoice(),1000);
      },
      sendInvoice: function() {
        this.check = true;
        let valReferencialTramo = 0;
        this.invoice.token = this.$store.getters.userToken;
        // Caso exportacion de bienes
        this.invoice.adicional.tipo_igv = this.igvGlobal
        if (this.tipoOperacion == "0200") {
          this.invoice.receptor.tipo = this.tipoDocumentoExtrangeros;
          this.invoice.receptor.nro = this.receptor.numero.toString();
          this.invoice.receptor.razonSocial = this.receptor.razonSocial;
          this.invoice.receptor.direccionFiscal = this.receptor.direccion;
          this.invoice.adicional.dirAlternativa = this.receptor.direccion;
           this.invoice.totalPrecioVenta = this.totalVentaExportacion2;
           this.invoice.totalValorVenta = this.totalVentaExportacion2;
        } else {
          // Caso emision normal
          this.invoice.receptor.nro = this.receptor.numero.toString();
          this.invoice.receptor.tipo = this.receptor.tipo;
          this.invoice.receptor.razonSocial = this.receptor.razonSocial;
          this.invoice.receptor.direccionFiscal = this.receptor.direccion;
          this.invoice.adicional.dirAlternativa = this.receptor.direccion;
        }
        if (this.typeInvoice == 1) {
          if (this.indexSerie == 0) {
            this.invoice.serie = this.listaSeries[0];
          } else {
            this.invoice.serie = this.listaSeries[this.indexSerie];
          }
        } else if (this.typeInvoice == 2) {
          this.invoice.contingencia = true;
          this.invoice.serie = this.seriecon;
          this.invoice.numero = this.numero;
        }       
        if (this.totalVentaGratuita > 0 && this.totalVentaGravada > 0) {
          // Caso de Gratuitas combinadas con Gravadas
          this.invoice.totalValorVenta = this.totalVentaGravada;
          // if(this.selectedAnticipos.length > 0 && this.totalAnticiposIgv > 0){
          //     if(this.cotributo == '1000'){
          //       this.tPrecioVenta = this.totalVentaGravada + this.tPrecioVenta; //anticipos
          //       this.invoice.totalPrecioVenta = this.tPrecioVenta;
          //     }
          //   }else{
          //     this.invoice.totalPrecioVenta = this.importeTotal; 
          //   }
          this.invoice.totalPrecioVenta = this.importeTotal; 
          this.invoice.montoTotalImpuestos = this.montoTotalImpuestos;
          this.invoice.totalVentaGratuita = this.totalVentaGratuita;
          this.invoice.sumatoriaIgvGratuitas = this.sumatoriaIgvGratuitas;
          this.invoice.totalVentaGravada = this.totalVentaGravada;
          this.invoice.sumatoriaIgv = this.sumatoriaIgv;
          this.invoice.totalVentaExonerada = this.totalVentaExonerada;
          this.invoice.totalVentaInafecta = this.totalVentaInafecta;
          this.invoice.totalVentaExportacion = this.totalVentaExportacion;
          this.invoice.importeTotal = this.importeTotal;
        } else if (this.totalVentaGratuita > 0 && this.totalVentaGravada == 0) {
          // Caso de solo gratuitas
          this.invoice.montoTotalImpuestos = 0.0;
          this.invoice.totalVentaGratuita = this.totalVentaGratuita;
          this.invoice.sumatoriaIgvGratuitas = this.sumatoriaIgvGratuitas;
          this.invoice.importeTotal = 0.0;
        }
       if(this.descuentoItemMontoG !='' && this.selectedAnticipos.length > 0){
          //si tiene descuento global y anticipos
          const valorGlobalNormalizado = parseFloat(this.valorGlobal).toFixed(2);
          const valorAnticipoNormalizado = parseFloat(this.valorAnticipo).toFixed(2);
          const totalVentaGravadaNormalizado = parseFloat(this.totalVentaGravada).toFixed(2);
          const suma = parseFloat(totalVentaGravadaNormalizado) + parseFloat(valorGlobalNormalizado) - parseFloat(valorAnticipoNormalizado);
          const diferencia = parseFloat(totalVentaGravadaNormalizado) - parseFloat(suma);
          this.invoice.totalVentaGravada = diferencia;
          this.invoice.cargosDescuentosGlobales = this.cargosDescuentosGlobales;
        }else if(this.selectedAnticipos.length > 0){
          //si tiene anticipos y no tiene descuento global
          if(this.selectedAnticipos.length > 0 && this.cotributo =='1000' ){
            const valorAnticipoNormalizado = parseFloat(this.valorAnticipo).toFixed(2);
            const totalVentaGravadaNormalizado = parseFloat(this.totalVentaGravada).toFixed(2);
            const diferencia = parseFloat(totalVentaGravadaNormalizado) - parseFloat(valorAnticipoNormalizado);
            this.invoice.totalVentaGravada = diferencia;
            this.invoice.cargosDescuentosGlobales = this.cargosDescuentosGlobales;
          }else{
            if(this.tipoOperacion == "0200"){
             delete this.invoice.totalVentaGravada
            }else{
              //cuando hacen duplicidad de factura
              if(this.emisionrapidaGravada !='' && !this.editarConFacturaRapida){
                this.invoice.totalVentaGravada = this.emisionrapidaGravada;
              }else{
                this.invoice.totalVentaGravada = this.totalVentaGravada;
              }
            }
          }
        }else if(this.descuentoItemMontoG !=''){
          //si tiene descuento global y no tiene anticipos
            const valorGlobalNormalizado = parseFloat(this.valorGlobal).toFixed(2);
            const totalVentaGravadaNormalizado = parseFloat(this.totalVentaGravada).toFixed(2);
            const diferencia = parseFloat(totalVentaGravadaNormalizado) - parseFloat(valorGlobalNormalizado);
            this.invoice.totalVentaGravada = diferencia;
            this.invoice.cargosDescuentosGlobales = this.cargosDescuentosGlobales;
        }else if(this.cargosDescuentosGlobales == []){
          delete this.invoice.cargosDescuentosGlobales
            if(this.emisionrapidaGravada !='' && !this.editarConFacturaRapida){
              this.invoice.totalVentaGravada = this.emisionrapidaGravada;
            }else{
              this.invoice.totalVentaGravada = this.totalVentaGravada;
            }
        }
        else{
          delete this.invoice.cargosDescuentosGlobales
            if(this.tipoOperacion == "0200"){
             delete this.invoice.totalVentaGravada
            }else{
              if(this.emisionrapidaGravada !='' && !this.editarConFacturaRapida){
                this.invoice.totalVentaGravada = this.emisionrapidaGravada;
              }else{
                  this.invoice.totalVentaGravada = this.totalVentaGravada;
              }
            }
            
        }
        //cuando hacen duplicidad de factura
        if(this.emisionrapidaIgv !='' && !this.editarConFacturaRapida){
          this.invoice.montoTotalImpuestos = this.emisionrapidaIgv;
        }else{
          this.invoice.montoTotalImpuestos = this.montoTotalImpuestos;
        }  
        this.invoice.sumatoriaIgv = this.sumatoriaIgv;
        if(this.sumaCargoDescuentoItem > 0){
          this.invoice.sumatoriaOtrosCargos = this.sumaCargoDescuentoItem;
        }     
        this.invoice.importeTotal = parseFloat(this.importeTotal.toFixed(2));
        if (this.totalVentaExonerada > 0) {
          this.invoice.totalVentaExonerada = this.totalVentaExonerada2;
        } else {
          delete this.invoice.totalVentaExonerada;
        }
        if (this.totalVentaInafecta > 0) {
          this.invoice.totalVentaInafecta = this.totalVentaInafecta2;
        } else {
          delete this.invoice.totalVentaInafecta;
        }
        if (this.totalVentaExportacion > 0) {
          this.invoice.totalVentaExportacion = this.totalVentaExportacion2;
        } else{
           delete this.invoice.totalVentaExportacion;
        }
        if (this.guiasRelacionada.length > 0) {
          this.invoice.guiasRelacionada = this.guiasRelacionada;
        } else {
          delete this.invoice.guiasRelacionada;
        }
        if (this.docRelacionada.length > 0) {
          this.invoice.docRelacionada = this.docRelacionada;
        } else {
          delete this.invoice.docRelacionada;
        }
        if (this.items_adicionales.length > 0) {
          this.invoice.adicional.extras = this.items_adicionales;
        } else {
          delete this.invoice.adicional.extras;
        }
        if (this.totalDescuentosAcumulados > 0) {
          this.invoice.adicional.totalDescuentoItem = this.totalDescuentosAcumulados;
        } else {
          delete this.invoice.adicional.totalDescuentoItem;
        }
        if (this.sumatoriaOtrosCargos > 0) {
          // this.invoice.adicional.cargosGlobal = this.listaOtrosCargosAgregados;
          this.invoice.cargosDescuentosGlobales = this.listaOtrosCargosAgregados;
          this.invoice.sumatoriaOtrosCargos = this.sumatoriaOtrosCargos;
        }
        if(this.selectedRetencion != null){
           this.invoice.cargosDescuentosGlobales = this.cargosDescuentosGlobales
        }
        if (this.tipoOperacion == "1001") {
          this.invoice.adicional.detraccion.codigoSujetoDetraccion = this.detraccion.codigo;
          this.invoice.adicional.detraccion.numeroCuentaBanco = this.cuentaDetracionAdmin;
          this.invoice.adicional.detraccion.medioPago = "001";
          if(this.moneda.codigo == 'USD'){
            this.invoice.adicional.detraccion.montoDetraccion = ((this.tipocambiomonedadolar.venta) * (this.montoDetraccion)).toFixed(2);
          }else{
            this.invoice.adicional.detraccion.montoDetraccion = (this.montoDetraccion).toFixed(2);
          }
          this.invoice.adicional.detraccion.porcentajeDetraccion = parseFloat(this.detraccion.porcentajeDetraccion).toFixed(5);
        } else if (this.tipoOperacion == "1002") {  
          this.invoice.adicional.detraccion.codigoSujetoDetraccion = "004";
          this.invoice.adicional.detraccion.numeroCuentaBanco = this.cuentaDetracionAdmin;
          this.invoice.adicional.detraccion.medioPago = "001";
          this.invoice.adicional.detraccion.montoDetraccion = ((this.importeTotal * parseFloat(4)) /100).toFixed(2);
          this.invoice.adicional.detraccion.porcentajeDetraccion = "4";
        } else if (this.tipoOperacion == "1004") {
          this.invoice.adicional.detraccion.codigoSujetoDetraccion = "027";
          this.invoice.adicional.detraccion.numeroCuentaBanco = this.cuentaDetracionAdmin;
          this.invoice.adicional.detraccion.medioPago = "001";
          valReferencialTramo = this.sumatoriaValorReferencialPorTm();
          // if (valReferencialTramo > this.importeTotal) {
          //     this.invoice.adicional.detraccion.montoDetraccion = ((valReferencialTramo * parseFloat(4)) /100).toFixed(2);
          // }else {
            if(this.importeTotal > this.totalsumadetraccion){
              this.invoice.adicional.detraccion.montoDetraccion = parseFloat((this.importeTotal * parseFloat(0.04)).toFixed(2));
              let montoDetraccionImporteTotal = parseFloat((this.importeTotal * parseFloat(0.04)).toFixed(2));
                if(this.moneda.codigo == 'USD'){
                  let valorMontoDetraccion = parseFloat(this.tipocambiomonedadolar.venta) * (montoDetraccionImporteTotal).toFixed(2)
                   this.invoice.adicional.detraccion.montoDetraccion = parseFloat((valorMontoDetraccion).toFixed(2))
                }
            }else{
              this.invoice.adicional.detraccion.montoDetraccion = parseFloat((this.totalsumadetraccion * parseFloat(0.04)).toFixed(2));
               let montoDetraccionTotalDetraccion = parseFloat((this.totalsumadetraccion * parseFloat(0.04)).toFixed(2));
               if(this.moneda.codigo == 'USD'){
                let valorMontoDetraccion2 = parseFloat(this.tipocambiomonedadolar.venta) * (montoDetraccionTotalDetraccion).toFixed(2)
                   this.invoice.adicional.detraccion.montoDetraccion = parseFloat((valorMontoDetraccion2).toFixed(2))
                }
            }
          // }
          this.invoice.adicional.detraccion.porcentajeDetraccion = 4;
        } else {
          delete this.invoice.adicional.detraccion;
        }
        // Factura regulacion de anticipos
        if (this.selectedAnticipos.length > 0) {
          this.invoice.adicional.anticipos = this.selectedAnticipos;
          this.invoice.adicional.totalAnticipos = parseFloat(this.totalAnticipos);
        } else {
          delete this.invoice.adicional.anticipos;
        }
        if(this.tipoOperacion =="0101EDU"){
          this.invoice.tipoOperacion = "0101"
        }else{
          this.invoice.tipoOperacion = this.tipoOperacion;
        }
        if (
                this.descuentoGlobalMonto != "" ||
                this.descuentoGlobalPorcentaje != ""
        ) {
          this.invoice.adicional.descuentoGlobal.codigoMotivoDescuento = "02";
          this.invoice.adicional.descuentoGlobal.factorNumericoDescuento = this.factorNumericoDescuento;
          this.invoice.adicional.descuentoGlobal.montoDescuento = this.montoDescuento;
          this.invoice.adicional.descuentoGlobal.montoBaseDescuento = this.montoBaseDescuento;
        } else {
          delete this.invoice.adicional.descuentoGlobal;
        }
        if (this.femision != "") {
          this.invoice.fechaEmision = this.$moment(this.femision).format(
                  "YYYY-MM-DD HH:mm:ss"
          );
        }
        if (this.fvencimiento != "") {
          this.invoice.adicional.fechaVencimiento = this.$moment(
                  this.fvencimiento
          ).format("YYYY-MM-DD");
        }
        if (this.formadepago.codigo != "000") {
          if (this.formadepago.codigo === "00") {
            // this.invoice.credito = 1;
            // this.invoice.adicional.credito = 1;
              this.invoice.adicional.credito = this.cuotasCredito
              this.invoice.adicional.montoPendientePagoCredito = parseFloat(this.totalcredito)
          } else {
            this.invoice.adicional.formaPago = this.formadepago.codigo;
            this.invoice.adicional.nombreFormaPago = this.formadepago.nombre;
            // this.invoice.adicional.credito = 0;
          }
        }
        if (this.ordenCompra != "") {
          this.invoice.adicional.ordenCompra = this.ordenCompra;
        }
        // isc
        if(this.sumaISC() > 0){
          this.invoice.sumatoriaIsc = this.sumaISC()
        }
        this.invoice.adicional.rol = this.$store.getters.userData.rol
        this.invoice.adicional.username = this.$store.getters.userData.username;
        this.invoice.adicional.amazoniaSelva = this.$store.state.user.data.amazonia == 1 ? true : false;
        if(this.tipoOperacion == "0200"){
        this.invoice.adicional.incoterm = this.incotermExporta.name;
        this.invoice.adicional.codigoSunatEstablecimiento = "0000"
        }
        if(this.monederoPago == 1){
          this.invoice.monedero = 1
          this.invoice.nombreMonedero = "Yape"
        }else if(this.monederoPago == 2){
          this.invoice.monedero = 2
          this.invoice.nombreMonedero = "Plin"
        }else if(this.monederoPago == 3){
          this.invoice.monedero = 3
          this.invoice.nombreMonedero = "A Crédito"
        }else if(this.monederoPago == 4){
          this.invoice.monedero = 4
          this.invoice.nombreMonedero = "Tarjeta de Débito"
        }else if(this.monederoPago == 5){
          this.invoice.monedero = 5
          this.invoice.nombreMonedero = "Efectivo ventas menores  "
        }else if(this.monederoPago == 6){
          this.invoice.monedero = 6
          this.invoice.nombreMonedero = "Tarjeta de Crédito emitida en Perú"
        }else if(this.monederoPago == 7){
          this.invoice.monedero = 7
          this.invoice.nombreMonedero = "Depósito en cuenta"
        }else if(this.monederoPago == 8){
          this.invoice.monedero = 8
          this.invoice.nombreMonedero = "Transferencia de Fondos"
        }
        this.invoice.items = this.items;
        this.invoice.email = this.listaCorreos;
        this.invoice.tipoMoneda = this.moneda.codigo;
        this.invoice.idOrdenPago = this.idOrdenPago;
        if (this.anticipo) {
          this.invoice.anticipo = true;
        }
        if (Object.values(this.invoice.adicional).length == 0) {
          delete this.invoice.adicional;
        }
        // Total de icbper
        if (this.totalIcbper() > 0) {
          this.invoice.sumatoriaIcbper = this.totalIcbper();
        } else {
          delete this.invoice.sumatoriaIcbper;
        }
        axios
        .post(process.env.VUE_APP_API_URL + "facturas/emitir", this.invoice)
        .then(response => (
            (this.info = response.data),
            (this.check = false),
            this.$snotify.success(response.data.msg, "Exito"),
            this.datosFactura(response.data.response),
            this.initInvoice(),
            this.$emit("comprobanteEmitido", response.data)
        ))  
        .catch(error => (
              (this.check = false),
              (this.previwEmit = true),
              (this.contingencia = false),
              this.catchErorr(error.response.data)
        ));
      },
      datosFactura(data){
        this.$store.commit("respuestaFactura", data)
      },
      totalIcbper: function() {
        let total = 0;
        this.items.forEach(function(element) {
          if (element.afectoIcbper) {
            total = total + (0.5*element.cantidad);
          }
        });
        return total;
      },
      catchErorr: function(value) {
        let errorgateway = "";
        let errorapicentral = "";
        value.msg ? (errorgateway = value.msg) : (errorgateway = "");
        value.response.message
                ? (errorapicentral = value.response.message)
                : (errorapicentral = "");
        // this.$snotify.error(errorgateway + errorapicentral, "Error");
        this.openErrorFactura = true,
        this.errorFactura = true,
        this.error1 = value.msg
        this.error2 = value.response.message
        this.error3 = value.response.description
        this.errorJson = value
      },
      cerrarmodal(value){
        this.errorFactura = value
        this.openErrorFactura = false
      },
      initInvoice: function() {
        this.direcciones = [];
        this.totaldetraccion = 0.00;
        this.valGrabadaAnticipos = "";
        this.receptor.numero = "";
        this.receptor.direccion = "";
        this.receptor.razonSocial = "";
        this.receptor.tipo = "6";
        this.serie = "";
        this.seriecon = "";
        this.numero = "";
        this.especificacionIgv = "01";
        this.tipoDocumento = 0;
        this.formadepago = { codigo: "008", nombre: "Efectivo ventas menores" };
        this.ordenCompra = "";
        this.items_guias = [];
        this.items_relacionados = [];
        this.guiasRelacionada = [];
        this.docRelacionada = [];
        this.docrelacionadolock = false;
        this.seriedeguia = "";
        this.numerodeguia = "";
        this.tipodeguia = "09";
        this.docRelacionado = "99";
        this.items_adicionales = [];
        this.fvencimiento = "";
        this.key = "";
        this.value = "";
        this.typeInvoice = 1;
        this.items = [];
        this.descuentoGlobalMonto = "";
        this.descuentoGlobalPorcentaje = "";
        this.descuentoItemMonto = "";
        this.descuentoItemPorcentaje = "";
        this.montoTotalImpuestos = 0.0;
        this.totalVentaInafecta = 0.0;
        this.totalVentaExonerada = 0.0;
        this.totalVentaExportacion = 0.0;
        this.totalVentaGravada = 0.0;
        this.totalVentaGratuita = 0.0;
        this.sumatoriaIgv = 0.0;
        this.importeTotal = 0.0;
        this.baseCargo = 0.0;
        this.ventaGratuita = false;
        this.tipoDocumentoExtrangeros = "0";
        this.contingencia = false;
        this.adicionalDetraccion = {};
        this.docAnticipos = [];
        this.selectedAnticipos = [];
        this.totalAnticipos = 0.0;
        this.totalAnticiposValor = 0.0;
        this.valorGlobal = '';
        this.invoice = {
          tipoOperacion: "",
          serie: "",
          montoTotalImpuestos: 0.0,
          totalVentaGravada: 0.0,
          totalVentaExonerada: 0.0,
          sumatoriaIgv: 0.0,
          sumatoriaIcbper: 0.0,
          importeTotal: 0.0,
          adicional: {
            totalDescuentoItem: "",
            extras: [],
            descuentoGlobal: {
              codigoMotivoDescuento: "",
              factorNumericoDescuento: 0.0,
              montoDescuento: 0.0,
              montoBaseDescuento: 0.0
            },
            detraccion: {
              codigoSujetoDetraccion: "",
              numeroCuentaBanco: "",
              medioPago: "",
              montoDetraccion: "",
              porcentajeDetraccion: ""
            },
            dirAlternativa: ""
          },
          guiasRelacionada: [],
          docRelacionada: [],
          items: [],
          receptor: {
            tipo: "",
            nro: "",
            razonSocial: "",
            direccion: ""
          }
        };
        this.selectedRetencion = null
        this.cuotasCredito=[],
        this.totalcredito = 0.0,
        this.detraccion = {
          codigo: "000",
          descripcion: "Seleccionar tipo detraccion",
          porcentajeDetraccion: "0%"
        };
        // this.tipoOperacion = "0101";
        this.adicional.dirAlternativa = "";
        this.previwEmit = true;
        this.tipoguialock = false;
        this.anticipos = [];
        this.selectedAnticipos = [];
        this.totalAnticipos = 0.0;
        this.disabledAnticipo = false;
        this.totalAnticiposGrabada = 0.0;
        this.buttonRegularizacionAnticipos = true;
        this.switchAnticipo = false;
        this.invoicePrev.data = this.info.response;
        this.invoicePrev.bandera = true; //mostrar pdf al emitir
        this.sumatoriaOtrosCargos = 0;
        this.sumatoriaOtrosCargosProducto = 0;
        this.listaOtrosCargosAgregados = [];
        this.otrosCargosProductoAgregados = [];
        this.initMoneda();
        this.action.reset = true
        this.accion.reset = true
        this.file = null,
        this.guiasdoc = null,
        // this.coleccion = [],
        this.doc ="",
        this.valorGlobal = '',
        this.descuentoItemMontoG = '',
        this.cargosDescuentosGlobales = [],
        this.listarMontos = [],
        this.gravado = false,
        this.incotermExporta = {
          tipo:"4",
          name:"FOB"
        },
        this.itemsEX = []
        this.aula = "",
        this.gradoYseccion = "",
        this.dniAlumno = "",
        this.nomApeAlumno = "",
        this.ubigeoOrigenDom = "", 
        this.direccionDomAlumno = "", 
        this.ubigeoDestinoDom = "", 
        this.direccionColegio = "", 
        this.periodoAcademido = ""
        // this.mostrarPdf(this.banderaPdfUsuario)
      },
      // mostrarPdf(value) {
      //   this.invoicePrev.bandera = value
      // },
      // guardarBandera(value) {
      //   this.banderaPdfUsuario = value
      // },
      sumatoriaValorReferencialPorTm: function() {
        let val = 0.0;
        this.adicionalDetraccion.servicioTransporteCarga.detalleTramos.forEach(
                function(element) {
                  val += parseFloat(element.montoAfectacionIgv);
                }
        );
        return val;
      },
      pitcherReceiver: function(value) {
        if (value === 1) {
          if (this.receptor.numero.length >= 3) {
            setTimeout(() => this.getReceivers(), 200);
          } else if (this.receptor.numero.length <= 2) {
            this.initReceptor();
          }
        }
        if (value === 2) {
          if (this.receptor.razonSocial.length >= 3) {
            setTimeout(() => this.getReceiversByRSocial(), 200);
          } else if (this.receptor.razonSocial.length <= 2) {
            this.initReceptor();
          }
        }
      },
      getReceivers: function() {
        if(this.receptor.numero.charAt(0)!=2 ){
          this.ructen = false
        }else{
         this.ructen = true
        }
        this.cargandoreceptor = true;
        if (this.receptor.numero.length >= 3) {
          this.stateReceptorRuc(this.receptor.numero);
          if (this.rucValid) {
            this.listarec = true;
            this.norec = false;
            // lista/razonSocial
            axios
                    .post(process.env.VUE_APP_API_URL + "receptores/listaconterceros", {
                      token: this.$store.getters.userToken,
                      q: this.receptor.numero,
                      tipoRec: "6"
                    })
                    .then(
                            response => (
                                    (this.listaReceptores = response.data),
                                            (this.cargandoreceptor = false),
                                            this.addReceiver(this.listaReceptores),
                                            this.receivercount(this.listaReceptores.length)
                            )
                    )
                    .catch(
                            error => (
                                    (this.listaReceptores = []),
                                            (this.cargandoreceptor = false),
                                            (this.listarec = false)
                                    // this.norec = false
                            )
                    );
          }
        } else if (this.receptor.numero.length === 0) {
          (this.listaReceptores = []), (this.cargandoreceptor = false);
        } else {
          this.listaReceptores = [];
        }
      },
      changeDirection: function() { 
      this.verDirecciones = true;    
        if(Object.values(this.bufferProforma).length > 0){
          axios.post(process.env.VUE_APP_API_URL + "receptores/listaconterceros",{
              token: this.$store.getters.userToken,
              q: this.receptor.numero,
              tipoRec: "6"
          })
          .then(response=>(
            this.direcciones = response.data[0].direcciones))
        }
      },
      setDirection: function(value) {
        (this.receptor.direccion = value.direccion),
                (this.verDirecciones = false);
      },
      getReceiversByRSocial: function() {
        if (this.receptor.razonSocial.length >= 3) {
          this.cargandoreceptor = true;
          this.listarec = true;
          this.norec = false;
          axios
                  .post(
                          process.env.VUE_APP_API_URL +
                          "receptores/listaconterceros/razonsocial",
                          {
                            token: this.$store.getters.userToken,
                            q: this.receptor.razonSocial
                          }
                  )
                  .then(
                          response => (
                                  (this.listaReceptores = response.data),
                                          (this.cargandoreceptor = false),
                                          this.addReceiver(this.listaReceptores),
                                          this.receivercount(this.listaReceptores.length)
                          )
                  )
                  .catch(error => (this.cargandoreceptor = false));
        } else {
          (this.listaReceptores = []), (this.cargandoreceptor = false);
        }
      },
      initReceptor: function() {
        (this.receptor = {
          numero: "",
          tipo: "6",
          direccion: "",
          nombre: "",
          direccionReferencia: ""
        }),
                (this.listaReceptores = []),
                (this.cargandoreceptor = false);
                this.editarDireccion = false
      },
      editarDire(){
        this.ructen = false
        this.habilitarDireccion = true
        this.editarDireccion = false
      },
      direccionLista(){
        this.ructen = true
        this.habilitarDireccion = false
        this.editarDireccion = true
      },
      stateReceptorRuc(value) {
        let expreg = new RegExp("\\s|<|>|[A-Za-z]|^[3-9]|^[0]");
        if (value.length == 0) {
          // this.$snotify.error('RUC Inválido','Error');
          this.rucValid = false;
        } else if (expreg.test(value)) {
          this.$snotify.error("RUC Inválido", "Error");
          this.rucValid = false;
        } else {
          this.rucValid = true;
        }
      },
      addReceiver: function(value) {
        if (value.length == 0) {
          if(this.receptor.numero.length ==11){
            this.modalClienteCargando = true;
            this.updateClient();
          }else if(this.receptor.numero.length < 11){
            this.modalCliente = true;
          }
        } else {
          this.modalCliente = false;
        }
      },
      busquedaProductos(){
         this.searchItems = true
      },
      search(){
            this.mostrarListaProduc = true
            axios
            .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                token: this.$store.getters.userToken,
                filtro: 'name',
                p: this.descripcion
            })
            .then(response=>(
                this.ListProductos = response.data.response,
                this.ListProductos.forEach(function(element) {
                        element.cantidad = '',
                        element.boleta = 'boleta'
                    }),
                this.listaDescription = [],
                this.listades = false,
                this.mostrarListaProduc = false
            ))
            .catch(error=>(
               this.$snotify.warning("Debe agregar una descripción","Cuidado"),
                this.mostrarListaProduc = false
            ))      
      },
      searchCodigo(){ 
            let responseArray
            let merged
            this.mostrarListaProduc = true
            axios
            .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                token: this.$store.getters.userToken,
                filtro: 'code',
                p: this.codDescripcion  
            })
            .then(response=>(
                this.ListProductos = response.data.response,
                this.ListProductos.forEach(function(element) {
                        element.cantidad = ''
                        // element.boleta = 'boleta'
                    }),
                this.listaDescription = [],
                this.listades = false,
                this.mostrarListaProduc = false,
                responseArray = response.data.response,
                merged=(Object.assign({}, ...responseArray)),
                this.addUnidad(merged)
            ))
            .catch(error=>(
                this.$snotify.warning("No se encontro el código del producto","Cuidado"),
                this.mostrarListaProduc = false
            ))     
      },
      cargarItems(){
            let valor = false
            this.ListProductos.forEach(function(element){
                if(element.cantidad > 0){
                    valor = true
                }
            })
            if(valor){
                this.subirItems = true
                this.itemsModal = this.ListProductos.filter(x => x.cantidad > 0)
                this.itemsEX = this.itemsModal
                this.action.i = true 
                // this.searchItems = false
            }else{
                this.$snotify.warning("Debe agregar una cantidad","Cuidado")
            }
      },
      addUnidad(data){
        let array = []
        let item = data
        let cantidad = data.cantidad
        if(cantidad == ''){
          item.cantidad = 1
          array.push(item)
          this.itemsEX = array
          this.action.i = true
          // this.codDescripcion ='' 
        }else{
          array.push(item)
          this.itemsEX = array
          this.action.i = true 
        }
      },
      closeSearchItem(){
            this.searchItems = false
      },
      teclaCodigoProducto(event){
        if (event.keyCode === 13) {
          // this.getReceiversProductCode();
          this.buscaItemCodigo();
          return;
        }
        if (this.timerCod) {
          clearTimeout(this.timerCod);
        }
        this.timerCod = setTimeout(() => {this.getReceiversProductCode();}, 1000)
      },
      getReceiversProductCode: function(value) {
        let arrayNuevo = [];
        this.listaProductCode = []
        if(this.codigoProducto.length == 0) {
          this.listaProductCode = [];
          this.listaproductcode = false;
          this.noProductCode = false;
          this.cargandoCodBarras = false;
          return;
        }else if(this.codigoProducto.length >=2) {
          arrayNuevo = this.$store.getters.getTotalItems.filter(item => {
                // Verificar si la descripción del producto contiene el texto de búsqueda
                if(item && item.codigo){
                  return item.codigo.toLowerCase().includes(this.codigoProducto.toLowerCase());
                }
                });
                this.cargandoCodBarras = true;
                this.listaProductCod = true;
                this.noProductCode = false;

                this.listaProductCode = arrayNuevo,
                this.cargandoCodBarras = false
                // this.listaProductCod = false,
                this.ordenarOpcionesCodigo(this.listaProductCode)
        }
        // if (value.length >=2) {
        //   this.cargandoCodBarras = true;
        //   this.listaproductcode = true;
        //   this.noProductCode = false;
        //   axios
        //   .post(process.env.VUE_APP_API_URL + "productos/buscar", {
        //     token: this.$store.getters.userToken,
        //     filtro: "code",
        //     p: this.codigoProducto
        //   })
        //   .then(response => (
        //     (this.listaProductCode = response.data.response),
        //     (this.cargandoCodBarras = false),
        //     (this.listaproductcode = false),
        //     this.receivercountProduct(this.listaProductCode.length)
        //   ))
        //   .catch(error => (
        //     this.$snotify.error(error.response.data.msj, "Error"),
        //     (this.cargandoCodBarras = false),
        //     (this.listaproductcode = false)
        //   ));
        // }
      },
      ordenarOpcionesCodigo: function(item) {
            this.opcionesOrdenadasCodigo = item.slice().sort((a, b) => {
                const lowerCaseDescripcionA = a.descripcion.toLowerCase();
                const lowerCaseDescripcionB = b.descripcion.toLowerCase();
                const lowerCaseSearch = this.codigoProducto.toLowerCase();

                const indexA = lowerCaseDescripcionA.indexOf(lowerCaseSearch);
                const indexB = lowerCaseDescripcionB.indexOf(lowerCaseSearch);
                // Si ambos tienen la misma cantidad de caracteres coincidentes,
                // ordenar por el índice en la descripción
                if (indexA === indexB) {
                    return indexA - indexB;
                }
                // Si tienen diferentes cantidades de caracteres coincidentes,
                // ordenar por la diferencia en la cantidad de caracteres
                if (indexA === 0) {
                    return -1; // a aparece primero
                } else if (indexB === 0) {
                    return 1; // b aparece primero
                } else if (indexA > 0 && indexB > 0) {
                    // Si ambos están después de la primera posición,
                    // ordenar por la posición
                    return indexA - indexB;
                } else {
                    // Si uno de ellos no contiene el término de búsqueda en la descripción,
                    // el que contiene la coincidencia aparece primero
                    return indexA < 0 ? 1 : -1;
                }
            });
      },
      getReceiversBarCodeSunat: function(value) {
        let receiver = "";
        let filtro = "";
        if (!this.vbarras) {
          receiver = "codesunat";
          filtro = this.codigoSunatBarras
        } else {
          receiver = "codegs1";
          filtro = this.codigoProductoGs1
        }
        if (value.length > 1) {
          this.cargandoBarrasSunat = true;
          this.listabarcodesunat = true;
          this.noBarCodeSunat = false;
          axios
                  .post(process.env.VUE_APP_API_URL + "productos/buscar", {
                    token: this.$store.getters.userToken,
                    // 'name, code, codesunat, codegs1'
                    // Parametro ej: Shoes -> sho
                    filtro: receiver,
                    p: filtro
                  })
                  .then(
                          response => (
                                  (this.listaBarCodeSunat = response.data.response),
                                          (this.cargandoBarrasSunat = false),
                                          this.receivercountBarrasSunat(this.listaBarCodeSunat.length)
                          )
                  )
                  .catch(error => {
                    this.cargandoBarrasSunat = false;
                  });
        }
      },
      tecla(event){
        if (event.keyCode === 13) {
          this.getReceiversDescription();
          return;
        }
          if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {this.getReceiversDescription();}, 1000)
      },
      agregarItem(item){
      //   this.precioVentaUnitario //ejecuta el watch para activar la funcion en caso seleccionan V.Unitario
        this.setReceiverDescription(item)
      },
      getReceiversDescription: function() {
        let arrayNuevo = []
            this.listaDescription = []
            if(this.descripcion.length >=3){
                arrayNuevo = this.$store.getters.getTotalItems.filter(item => {
                // Verificar si la descripción del producto contiene el texto de búsqueda
                if(item && item.descripcion){
                  return item.descripcion.toLowerCase().includes(this.descripcion.toLowerCase());
                }
                });
                this.sinresultados = true, 
                this.cargandoDescription = true,
                this.listades = true,
                this.nodescription = false,

                this.listaDescription = arrayNuevo,
                this.cargandoDescription = false,
                this.sinresultados = false,
                this.cargandoreceptor = false,
                this.receivercountDescription(this.listaDescription.length),
                this.ordenarOpciones(this.listaDescription)
            }else{
                arrayNuevo = []
            }
            if (arrayNuevo.length === 0 && this.descripcion.length >= 4) {
                this.$snotify.warning('PRODUCTO NO ENCONTRADO')
            } 
      },
      ordenarOpciones: function(item) {
            this.opcionesOrdenadas = item.slice().sort((a, b) => {
                const lowerCaseDescripcionA = a.descripcion.toLowerCase();
                const lowerCaseDescripcionB = b.descripcion.toLowerCase();
                const lowerCaseSearch = this.descripcion.toLowerCase();

                const indexA = lowerCaseDescripcionA.indexOf(lowerCaseSearch);
                const indexB = lowerCaseDescripcionB.indexOf(lowerCaseSearch);
                // Si ambos tienen la misma cantidad de caracteres coincidentes,
                // ordenar por el índice en la descripción
                if (indexA === indexB) {
                    return indexA - indexB;
                }
                // Si tienen diferentes cantidades de caracteres coincidentes,
                // ordenar por la diferencia en la cantidad de caracteres
                if (indexA === 0) {
                    return -1; // a aparece primero
                } else if (indexB === 0) {
                    return 1; // b aparece primero
                } else if (indexA > 0 && indexB > 0) {
                    // Si ambos están después de la primera posición,
                    // ordenar por la posición
                    return indexA - indexB;
                } else {
                    // Si uno de ellos no contiene el término de búsqueda en la descripción,
                    // el que contiene la coincidencia aparece primero
                    return indexA < 0 ? 1 : -1;
                }
            });
      },
      menssageErrorDescripcion: function(value) {
        if (value.success == 0) {
          this.$snotify.warning(value.msj, "Atención");
        }
      },
      cerrarresultados: function() {
        (this.listaDescription = []), (this.listades = false);
      },
      cleanReceiversDescription: function() {
        this.cargandoDescription = false;
      },
      receivercount: function(value) {
        if (value.length === 0) {
          this.$snotify.warning(
                  "No se encontró al receptor, ingrese el RUC completo ó agreguelo como nuevo cliente",
                  "Atención"
          );
        }
      },
      receivercountProduct: function(value) {
        if (!value) {
          this.noProductCode = true;
        } else {
          this.noProductCode = false;
        }
      },
      receivercountBarrasSunat: function(value) {
        if (!value) {
          this.noBarCodeSunat = true;
        } else {
          this.noBarCodeSunat = false;
        }
      },
      receivercountDescription: function(value) {
        if (!value) {
          this.nodescription = true;
        } else {
          this.nodescription = false;
        }
      },
      customFormatter: function(date) {
        return this.$moment(date).format("YYYY-MM-DD HH:mm:ss");      
      },
      changeTab: function(value) {
        this.$emit("tabindex", value);
      },
      idEmision: function(value) {
        this.$emit("identificadorFactura", value);
      },
      addcuota(index,value){
        let sumatotales = 0
        let sumatotalesCredito = 0;
        let totalCreditoCuota = 0.0;
        sumatotales = parseFloat(this.totalcredito) + parseFloat(this.montoPagoCuota)
        totalCreditoCuota = parseFloat(this.montoPagoCuota)
        sumatotalesCredito = parseFloat(sumatotales.toFixed(2))
        if(this.fechaPagoCuota !='' && this.montoPagoCuota > 0){
          if(this.accumulateTotalSale() >= parseFloat(this.montoPagoCuota)){
            if(this.accumulateTotalSale() >= sumatotalesCredito){
              let total = 0.0
              let cuota = {
              identificadorCuota:'',
              fechaPagoCuota:'',
              montoPagoCuota:'',
            } 
            cuota.identificadorCuota = this.numerador(this.cuotasCredito.length+1)
            cuota.fechaPagoCuota = this.$moment(this.fechaPagoCuota).format("YYYY-MM-DD"),
            cuota.montoPagoCuota = parseFloat(totalCreditoCuota.toFixed(2))
            this.cuotasCredito.push(cuota)

            this.cuotasCredito.forEach(function(element){
              total += parseFloat(element.montoPagoCuota);
            }) 
            this.totalcredito = total.toFixed(2)
            this.fechaPagoCuota = '',
            this.montoPagoCuota = '',
            this.cantidadDias = ''
            }else{
              this.$snotify.warning('El monto no debe ser mayor al importe total del documento');
              sumatotales = 0
            }  
          }else{
            this.$snotify.warning('El monto no debe ser mayor al importe total del documento');
            sumatotales = 0
          }
        }
      },
      // limpiarCuotas(){
      //     if(this.totalcuotas == 0){
      //       this.cuotasCredito = [],
      //       this.totalcredito = 0.0
      //     }
      // },
      deletecuota(index){ 
        let totalarray =''
        totalarray = this.cuotasCredito.length+1
        this.renameident(index)
        this.cuotasCredito.splice(index, 1);

        let total = 0.0
        this.cuotasCredito.forEach(function(element){
          total += parseFloat(element.montoPagoCuota);
        }) 
          this.totalcredito = total.toFixed(2)
      },
      renameident(index){ 
        for (let i=0;i < this.cuotasCredito.length; i++) {
            if(i > index){
              this.cuotasCredito[i].identificadorCuota = this.numerador(i)
            }
        }
      },
      modalcredito(){
        this.modalCredito = false
      },
      numerador(value){
        let cuotanom = value
        let cadenacuota = ''
       if(cuotanom >=1 && cuotanom <=9){
          cadenacuota = 'Cuota00'+ String(cuotanom)
       }else if(cuotanom >=10 && cuotanom <=99){
          cadenacuota = 'Cuota0'+ String(cuotanom)
       }else if(cuotanom >=100 && cuotanom <=999){
         cadenacuota = 'Cuota'+ String(cuotanom)
       }
       return cadenacuota;
      },
      vercreditos(){
         this.modalCredito = true
      },
      barra(){
        this.vbarras=true;
      },
      retencionIgv(){
        let i = this
        if(this.selectedRetencion == null || this.selectedRetencion == '' ){
            // this.cargosDescuentosGlobales.forEach(function(element,index){
            //   if(element.codigoCargoDescuento == '62'){
            //     i.cargosDescuentosGlobales.splice(index,1)
            //   }      
            // })
        }else{
            this.cargosDescuentosGlobales.forEach(function(element,index){
              if(element.codigoCargoDescuento == '62'){
                i.cargosDescuentosGlobales.splice(index,1)
              }      
            })
          let retencionigv = {
            indicador: "",
            codigoCargoDescuento: "",
            factorCargoDescuento:"",
            montoCargoDescuento: "",
            baseCargoDescuento: ""
          }
          retencionigv.indicador = "descuento"
          retencionigv.codigoCargoDescuento = "62"
          if(this.selectedRetencion == 1){
            retencionigv.factorCargoDescuento = parseFloat(0.03);     
          }else if(this.selectedRetencion == 2){
            retencionigv.factorCargoDescuento = parseFloat(0.06);     
          }     
          retencionigv.montoCargoDescuento = parseFloat(((retencionigv.factorCargoDescuento * this.importeTotal)).toFixed(2));
          retencionigv.baseCargoDescuento = parseFloat(this.importeTotal.toFixed(2));
          this.cargosDescuentosGlobales.push(retencionigv)
          this.retencionIgvCredito = retencionigv.montoCargoDescuento  
        }      
      },
      consultaTipoCambio(date){
        let fechahoy = "";
        if(this.customFormatter() == this.currentdate){
           fechahoy = this.$moment(this.currentdate).format("YYYY-MM-DD"); 
        }else {
          fechahoy = date
        }
        axios 
        .post(process.env.VUE_APP_API_URL + "consulta/tipocambio",{
          fecha:fechahoy
        })
        .then(response=>(
          this.tipocambiomonedadolar = response.data
        ))
        .catch(error=>(
          console.log(error.response.data.msg)
        ))
      },
      cerrarModalSustentosGastos(){
        this.modalSustentaGastos = false;
      },
      cantidadDiasAgregados(){
        if(this.cantidadDias > 0){
          let fechaHoy2 = new Date();
          this.fechaPagoCuota = new Date();
          // cantidad de dias + el nùmero de la fecha actual
          let sumaFechas = parseFloat(this.cantidadDias) + parseFloat(this.$moment(fechaHoy2).format("DD"))
          //total suma con SetDate
          this.fechaPagoCuota.setDate(sumaFechas);
          //fecha resultado
          this.$moment(this.fechaPagoCuota).format("YYYY-MM-DD")
        }
      },
      pagosImg(valor){
        this.monederoPago = valor;
        valor == 1 ? this.colorPago1 = true : this.colorPago1 = false;
        valor == 2 ? this.colorPago2 = true : this.colorPago2 = false;
        valor == 3 ? this.colorPago3 = true : this.colorPago3 = false;
        valor == 4 ? this.colorPago4 = true : this.colorPago4 = false;
        valor == 5 ? this.colorPago5 = true : this.colorPago5 = false;
        valor == 6 ? this.colorPago6 = true : this.colorPago6 = false;
        valor == 7 ? this.colorPago7 = true : this.colorPago7 = false;
        valor == 8 ? this.colorPago8 = true : this.colorPago8 = false;
        if(valor == 1){
          this.formadepago.codigo = this.formaPago[3].codigo;
          this.formadepago.nombre = this.formaPago[3].nombre;
        }else if(valor == 2){
          this.formadepago.codigo = this.formaPago[3].codigo;
          this.formadepago.nombre = this.formaPago[3].nombre;
        }else if(valor == 3){
          this.formadepago.codigo = this.formaPago[1].codigo;
          this.formadepago.nombre = this.formaPago[1].nombre;
          this.modalCredito = true;
        }else if(valor == 4){
          this.formadepago.codigo = this.formaPago[4].codigo;
          this.formadepago.nombre = this.formaPago[4].nombre;
        }else if(valor == 5){
          this.formadepago.codigo = this.formaPago[8].codigo;
          this.formadepago.nombre = this.formaPago[8].nombre;
        }else if(valor == 6){
          this.formadepago.codigo = this.formaPago[5].codigo;
          this.formadepago.nombre = this.formaPago[5].nombre;
        }else if(valor == 7){
          this.formadepago.codigo = this.formaPago[2].codigo;
          this.formadepago.nombre = this.formaPago[2].nombre;
        }else if(valor == 8){
          this.formadepago.codigo = this.formaPago[3].codigo;
          this.formadepago.nombre = this.formaPago[3].nombre;
        }

      },
      mensaje: function () {
        let popup = "";
        let mensaje  = "";
        this.$store.getters.userMensajes.forEach(function(element){
          if(element.popup == '1'){
              popup = element.popup
              mensaje = element.mensaje
          }
        })
          // mensaje = "Estimado cliente, Su servicio será suspendido en las próximas horas por mantener facturas impagadas. CONSULTE LAS FORMAS DE PAGO EN"
          // let telefono = "Teléfonos: 995570648"
        if(popup == '1'){
            Swal.fire({
            title: 'Atención!!!',
            // html: mensaje + ' <a class="openUrl" href="http://telemovildata.com/formadepago">Formas de Pago</a> ' + telefono,
            html:mensaje,
            icon: 'warning',
          })
        };
      },
      //temporal
      send_message() {
        if(this.numeroWhatsApp && this.numeroWhatsApp.trim() !== ''){
            if(this.numeroWhatsApp.length == 9){
                const url = 'https://micomprobante.facturaonline.pe/s/pkey-'
                const {
                    idEmisor,
                    serie,
                    numero,
                    idReceptor,
                    importeTotal
                } = this.dataImpresion
                let factura = '01';
                const mensaje = 'Comprobante' + ' ' + this.dataImpresion.serie +'-'+ this.dataImpresion.numero + ' ' + 'Emitido a través de TELEMOVILPERU.COM'
                const cadena = `${idEmisor}|${factura}|${serie}|${numero}|${idReceptor}|${importeTotal}`
                const text = `${url}.${btoa(cadena)}+${mensaje}`
                window.open(`https://wa.me/+51${this.numeroWhatsApp}?text=${text}`, '_blank')
            }else{
                this.$snotify.warning("DEBE INGRESAR 9 DIGITOS")
            }
        }else{
            this.$snotify.warning("DEBE INGRESAR INFORMACION")
        }
    },
      limpiar(){
        //limpia el imput del codigo de barras
        this.codDescripcion = '';
      },
      importarProductosGuia(){
        this.modalImportarProdGuiaR = true;
        this.cargandoGuias = true;
          let dia1;
          let dia2;
          if(this.f1 === "" && this.f2 ===""){
            dia1 =  ""
            dia2 = ""
          }else{
            dia1 = this.$moment(this.f1).format('YYYY-MM-DD HH:mm:ss')
            dia2 = this.$moment(this.f2).format('YYYY-MM-DD 23:59:59')          
          }
          axios
          .post(process.env.VUE_APP_API_URL + 'guiaremitente', {
            token: this.$store.getters.userToken,
            f1:dia1,
            f2:dia2,
            limit: this.limiteGuia,
          })
          .then(response => {
            this.guides = response.data.data;
            this.cargandoGuias = false;
          })
          .catch(error =>  {})
        
      },
        mostrarDetalles: function (row, index) {
              if(row.detailsShowing){
                  row.toggleDetails()
                  this.guides[index].mostrardetalles = false
              }else{
                  this.guides[index].mostrardetalles = true
                  this.guides[index].loading = true
                  if(this.guides[index].lista.length == 0){
                      setTimeout(() => 
                          this.detallesDocumento(row, index)
                      , 10);  
                  }else{
                      this.guides[index].loading = false
                      row.toggleDetails()
                  } 
              }
        },
        detallesDocumento: function (row, index) {
          this.cargandoItemGuia = true,
            axios
            .post(process.env.VUE_APP_API_URL + 'guiaremitente/items',{
                token: this.$store.getters.userToken,
                idguia: row.item.idGuiaRemitente
            })
            .then(response => (
                this.parseDetallesDocumento(response.data.response, row, index),
                this.cargandoItemGuia = false
            ))
            .catch(error => (  
                this.guides[index].mostrardetalles = false
            )) 
        },
        parseDetallesDocumento: function (value, row, index) {
            this.guides[index].lista = []
            for (let i=0; i<value.length; i++){
                value[i].moneda = row.item.tipoMoneda
                this.guides[index].lista.push(value[i])
            }
            this.guides[index].loading = false
            // this.guides[index].mostrardetalles = false
            if(value.length > 0){
                row.toggleDetails()
            }

            const resultado = this.seleccionados.flatMap(obj => obj.lista);
            this.totalSeleccionados = resultado;
        },
        finalizarProceso(){
          if (!this.seleccionados.length) {
            this.$bvToast.toast('Debes seleccionar al menos un ítem.', {
              title: 'Aviso',
              variant: 'warning',
              solid: true
            });
            return;
          }


          const totalItems = this.$store.getters.getTotalItems;
          const coincidencias = this.totalSeleccionados.map(seleccionado => {
            // Si no tiene codigoItem, lo agregamos tal cual
            if (!seleccionado.codigoItem) {
              return {
                ...seleccionado,
                precioUnitario: null,
                codigo:null,
                unidadMedida:"NIU",
                tipoAfectacionIgv:0
              };
            }
            // Buscar coincidencia en totalItems por código
            const item = totalItems.find(i => i.codigo === seleccionado.codigoItem);
            if (item) {
              return {
                ...item,
                cantidad: seleccionado.cantidad
              };
            } else {
              // Si no se encuentra en totalItems, lo descartamos o podrías agregarlo igual, si deseas
              return null;
            }
          }).filter(Boolean); // Elimina los null (casos sin coincidencia ni código)
        this.itemsEX = coincidencias
        this.action.i = true
        this.modalImportarProdGuiaR = false;
        this.seleccionados = [];
        this.totalSeleccionados = [];
        },
        guiaAFactura(){
          let itemBlank = []
          let guia = this.$store.getters.getGuiaAFacturas // DATOS RECEPTOR
          const itemsGuias = this.$store.getters.getDuplicarGuiaRemisionItems; // ITEMS DE LA GUIA
          const totalItems = this.$store.getters.getTotalItems; //ITEMS DEL STORAGE
          let itemsCompletos = [];
          if(guia && guia.receiver){
            this.receptor.numero = guia.receiver.idReceptor
            this.receptor.razonSocial = guia.receiver.razonSocial
            this.receptor.direccion = guia.receiver.direccionReferencia   
            itemsGuias.forEach(itemGuia => {
              if (!itemGuia.codigoItem || itemGuia.codigoItem.trim() === '') {
                const nuevoItem = {
                    tipoAfectacionIgv: 0,
                    codigoTributo: 0,
                    idProducto: null,
                    unidadMedidaCantidad: itemGuia.unidadMedida ? itemGuia.unidadMedida : 'NIU', // Sobrescribir unidad de medida
                    cantidad: itemGuia.cantidad ? itemGuia.cantidad : 1, // Sobrescribir cantidad
                    descripcion: itemGuia.descripcion,
                    valorUnitario: 0,
                    tipoPrecioVentaUnitario: 0,
                    descuento: 0,
                    porcentajeDescuento: 0,
                    baseAfectacionIgv: 0,
                    valorUnitarioVista: 0,
                    valorVenta: 0,
                    valorVentaVista: 0,
                    porcentajeImpuesto: 0,
                    montoAfectacionIgv: 0,
                    montoTotalImpuestosItem: 0,
                    precioVentaUnitario: 0,
                };

                // Agregar el nuevo ítem a itemsCompletos
                itemsCompletos.push(nuevoItem);
              } else {
                const itemCompleto = totalItems.find(item => item.codigo === itemGuia.codigoItem);
                if (itemCompleto) {
                  itemsCompletos.push({
                    ...itemCompleto,
                    cantidad: itemGuia.cantidad ? itemGuia.cantidad: 1, // usa cantidad si existe, sino valor por defecto 1
                    descripcion: itemGuia.descripcion
                  });
                }
              }

            });
            if(this.igvGlobal !=''){
                this.itemsEX = itemsCompletos
                this.action.i = true
            }
          }
        this.$store.commit('guiaAFacturas', itemBlank)
        },
        rowClass(item, type) {
          if (!item || type !== 'row') return
          if (item.precioVentaUnitario === 0) return 'table-warning'
        },
        respuestaFactura() {
          this.dataFactura =  this.$store.getters.getRespuestaFactura;
        },
        vistaPreviaPdf(){
          this.dataFactura =  this.$store.getters.getRespuestaFactura;
          this.previewmodal = true; // Abre el modal
          this.cargandoPdf = true;
          this.pdfobject = '';
          axios
          .post(process.env.VUE_APP_API_URL + "facturas/pdf",{
            token: this.$store.getters.userToken,
            id: this.dataFactura.idFactura
          })
          .then(response => (
            this.pdfobject = response.data.base64,
            this.cargandoPdf = false,
            this.$snotify.success(response.data.message, 'Mostrando PDF')
          ))
          .catch(error => (
            this.previewmodal = false, 
            this.cargandoPdf = false, 
            this.$snotify.error("Error al cargar el PDF", "Error") 
          ))
      },
      buscaItemCodigo(){
        // this.cargandoCodBarras = false;
        // this.listaProductCod = true;
        let unicoItem = []
        if(this.codigoProducto.length >=2) {
          unicoItem = this.resultadoCodProducto.filter(item => {
                // Verificar si la descripción del producto contiene el texto de búsqueda
                if(item && item.codigo){
                  return item.codigo.toLowerCase().includes(this.codigoProducto.toLowerCase());
                }
                });
                this.listaProductCodeScaner = unicoItem
        }
        this.scanerCodigo = true;
      },
      ubigeoOrigenDomicilio(){
        this.modalUbigeoOrigen = true;
      },
      searchDistrictOrigen: function (value, ind) {
        let departmentActual = ''
        let provinceActual = ''
        if(ind == 1){
          departmentActual = this.departamentoSeleccionadoUbigeoOrigen,
          provinceActual = this.provinciaSeleccionadaUbigeoOrigen,
          this.distOrigenCargando = value
        }else if(ind == 2){
 
        }
        axios
        .post(process.env.VUE_APP_API_URL + 'ubigeo/distrito',{
            token: this.$store.getters.userToken,
            department: departmentActual,
            province: provinceActual
        })
        .then(response => (
            this.listDistrictOrigen = response.data,
            this.distOrigenCargando = false
        ))
        .catch(error => {})
      },
      searchProvinceOrigen: function (ind) {
        let departamentoActual = ''
        if(ind == 1){
            departamentoActual = this.departamentoSeleccionadoUbigeoOrigen
            this.provOrigenCargando = true
        }else if(ind == 2){
          
        }
        axios
        .post(process.env.VUE_APP_API_URL + 'ubigeo/provincia',{
            token: this.$store.getters.userToken,
            department: departamentoActual
        })
        .then(response => (
            this.listProvinceOrigen = response.data,
            this.provOrigenCargando = false                     
        ))
        .catch(error => {})
      },

      searchProvinceDestino: function (ind) {
        let departamentoActual = ''
        if(ind == 1){
            departamentoActual = this.departamentoSeleccionadoUbigeoDestino,
            this.provDestinoCargando = true
        }else if(ind == 2){
        }
        axios
        .post(process.env.VUE_APP_API_URL + 'ubigeo/provincia',{
            token: this.$store.getters.userToken,
            department: departamentoActual
        })
        .then(response => (
            this.listProvinceDestino = response.data,
            this.provDestinoCargando = false                  
        ))
        .catch(error => {})
      },
      searchDistrictDestino: function (value, ind) { 
        let departmentActual = ''
        let provinceActual = ''
        if(ind == 1){
          departmentActual = this.departamentoSeleccionadoUbigeoDestino,
          provinceActual = this.provinciaSeleccionadaUbigeoDestino,
          this.distDestinoCargando = value
        }else if(ind == 2){

        }
        axios
        .post(process.env.VUE_APP_API_URL + 'ubigeo/distrito',{
            token: this.$store.getters.userToken,
            department: departmentActual,
            province: provinceActual
        })
        .then(response => (
            this.listDistrictDestino = response.data,
            this.distDestinoCargando = false 
        ))
        .catch(error => {})
      },
    }
  };
</script>

<style lang="scss" scoped>
  .facturador {
    padding-left: 20px;
    padding-right: 20px;
  }
  .botones {
    margin-top: 30px;
  }
  #info_item {
    margin-right: 15px;
  }
  .inputpersonalizado {
    width: 100%;
    border: none;
    border-bottom: 1px solid #ccc;
  }
  .dropdown li {
    border-bottom: 1px solid rgba(112, 128, 144, 0.1);
  }

  .dropdown li:last-child {
    border-bottom: none;
  }

  .dropdown li a {
    padding: 10px 20px;
    display: flex;
    width: 100%;
    align-items: center;
    font-size: 1.25em;
  }

  .dropdown li a .fa {
    padding-right: 0.5em;
  }
  .dropdown-toggle {
    padding-bottom: 0px !important;
  }
  .v-select .dropdown-toggle .clear {
    font-size: 23px;
    font-weight: 700;
    line-height: 1;
    color: rgba(60, 60, 60, 0.5);
    padding: 0;
    border: 0;
    background-color: transparent;
    cursor: pointer;
    margin-right: 6px;
    display: none;
  }
  label {
    margin-bottom: 0 !important;
  }
  .input-requerido::placeholder {
    color: #db0000;
    opacity: 1;
  }
  .input-placedark::placeholder {
    color: #353333;
    opacity: 0.9;
  }
  .input-dark {
    color: #000000;
    opacity: 1;
  }
  .searcher-field {
    z-index: 1000;
    position: absolute;
    max-height: 500px !important;
    overflow-y: scroll;
    width: 900px;
  }
  .searcher-result {
    font-size: 1em;
    padding: 5px;
    cursor: pointer;
  }
  .colorEmision {
    font-weight: bold;
    color: #00004d;
  }
  .acciones-espacio {
    margin-right: 10px;
  }
  .descuentoglobal {
    height: 28px;
  }
  .checkdescuentoglobal {
    margin-top: -8px;
    margin-left: -5px;
  }
  .porcentajeglobal {
    margin-left: -18px;
  }
  .buttonagregar {
    margin-top: -18px;
  }
  .mover{
      margin-top: -18px; 
    }
  .input-descuento {
    margin-top: -5px;
    margin-left: -12px;
  }
  .titulo-opitem {
    padding: 0;
    padding-left: 30%;
  }
  .descuentoitem {
    margin-top: 12px;
  }
  .sinresultados {
    padding: 0 5px 0 5px;
  }
  .searchItem{
    background-color: #F0E1F6;
    border-color: #F0E1F6;
    color: #9C53E0;
  }
  .sinresultados2 {
    padding: 0 10px 0 10px;
  }
  .alineacionTotales {
    margin-right: 50%;
    text-align: right;
  }
  .bajarunpoco {
    margin-top: 25%;
  }
  .monedaOtrosCargos {
    margin-top: -55px;
  }
  .monedaTotales {
    margin-top: 47%;
  }
  .cajatotales {
    margin-top: 10%;
    margin-left: -50%;
  }
  .adicionalesOperacionItem {
    background-color: #ffb80e;
    padding: 0px;
  }
  #drop {
    border: 2px dashed #bbb;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    padding: 25px;
    text-align: center;
    font: 20pt bold, "Vollkorn";
    color: #bbb;
  }
  .colorestelemovil {
    background-color: #006eae;
    color: #ffffff;
  }
  .separador {
    background-color: #ffc12c;
    width: 100%;
    height: 2px;
  }
  .coloresdetraccion {
    background-color: #009e30;
  }
  .agregaritemsPersonalizado {
    padding-left: 0.1%;
    width: 100%;
    height: 35px;
  }
  .agregaritemsnew {
    margin-top: 5px;
    margin-left: 4px;
  }
  .cargaritemsPersonalizado {
    padding-top: 0.2px;
  }
  .cargaritemsPersonalizadoRegAnt {
    padding-top: 0.2px;
    margin-left: 20%;
  }
  .retornarDetraccion {
    margin-top: 2%;
  }
  .centerpreview {
    text-align: center;
  }
  .estilospreview {
    color: #fc7e00;
  }
  .agregartramo {
    padding: 2px;
    margin-top: 2%;
  }
  .backubigeopartida {
    margin-top: 0%;
  }
  .quickemisionicon {
    margin-left: 10%;
  }
  .quickemisioniconf {
    color: black;
  }
  .quickemisioniconb {
    color: black;
  }
  .quickemisionicong {
    color: black;
  }
  .emisionrapidapersonalizada {
    width: 100%;
  }
  .emisionrapidaglobal {
    margin: 0px;
    padding: 0px;
    width: 100%;
    height: 37px;
  }
  .generalesemsionrapida {
    margin: 0px;
    padding-top: 2px;
    padding-bottom: 2px;
    margin-top: -16px;
    margin-left: 11%;
  }
  .generalesemsionrapidaserie {
    margin-top: -24%;
    margin-left: -21%;
  }
  .generalesemsionrapidanumero {
    margin-top: -24%;
    margin-left: -45%;
  }
  .bordesAnticipos {
    border: 1px solid #ccc;
  }
  .lianticipo {
    list-style: none;
  }
  .botonesemitir {
    width: 80px;
    margin-left: 15px;
  }
  .smallito {
    margin-bottom: -10px;
  }
  .buscarRuc {
    margin-top: -50px;
  }
  .drop {
    border: 2px dashed #bbb;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    padding: 25px;
    text-align: center;
    font: 20pt bold, "Vollkorn";
    color: #bbb;
  }
  .btnagregarstyle {
    width: 325px;
  }
  
  /*  */
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.estilo {
  border: 2px solid teal;
  color: white;
  background-color: teal;
  padding: 8px 20px;
  border-radius: 5px;
  font-weight: bold;
}

.upload-btn-wrapper input[type=file] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.lab{
  display: inline-block;
  background-color: teal;
  color: white;
  padding: 0.5rem;
  border-radius: 0.3rem;
  cursor: pointer;
  margin-left: 10px;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
.formasPagosImg{
width: 60%;
height: 40%;
border-radius: 25px;
cursor: pointer;
}

.searcher-result2 {
    background-color: white;
    font-size: 1em;
    cursor: pointer;
}
.searcher-result2 :hover{
  background-color:skyblue;
    border:1px solid grey
}
.searcher-result3{
  background-color: white;
} 
.colorBorde{
  border-color:#7e8fb9;
}
.tablaborde{
  border: 1px solid #B8cdd5;
}
.centrarTitulo{
text-align: center;
}
 /* Animación de pulso continuo */
 @keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0px 4px 6px rgba(217, 4, 41, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0px 8px 15px rgba(217, 4, 41, 0.6);
  }
  100% {
    transform: scale(1);
    box-shadow: 0px 4px 6px rgba(217, 4, 41, 0.4);
  }
}

/* Estilo inicial del botón */
.animated-button {
  animation: pulse 2s infinite; /* Pulso continuo */
  transition: transform 0.2s, box-shadow 0.2s, background-color 0.2s;
  border-radius: 8px; /* Bordes redondeados */
  font-weight: bold; /* Texto más destacado */
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

/* Efecto al pasar el cursor */
.animated-button:hover {
  background-color: #b80020; /* Rojo más oscuro */
  border-color: #b80020;
  transform: scale(1.1); /* Aumenta más el tamaño */
  box-shadow: 0px 10px 20px rgba(217, 4, 41, 0.8); /* Sombra más intensa */
}

/* Efecto al hacer clic */
.animated-button:active {
  transform: scale(0.95); /* Efecto de presión */
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Sombra más pequeña */
}

/* Efecto de brillo */
.animated-button::after {
  content: '';
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.2);
  z-index: -1;
  opacity: 0;
  transition: opacity 0.3s, transform 0.3s;
}

.animated-button:hover::after {
  opacity: 1;
  transform: scale(1.2); /* Brillo al pasar el cursor */
}
</style>